<template>
    <div>
        <div class="simple-form " v-if="contract.version>1">
            <div class="form-group center">
                <div class="form-label">
                    <label>变更前合同名称：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{ prevChangeContract.title }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>变更前合同编号：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{ prevChangeContract.fstPartyHtBh }}</span>
                </div>
            </div>
        </div>

        <div class="content-caption dashed">
            <span>合同信息</span>
            <div class="fr clearfix" v-if="onlyView == null || onlyView == false">
<!--                <button v-if="checkActionPerm('pre_pay') && contract.id != null && !contract.offline && contract.confirmed && contract.curValid && !contract.fullfilled && !contract.closed && !contract.terminated" class="swb-btn swb-btn-mini mr15"-->
<!--                        @click.stop="doPayPre(contract);">-->
<!--                    <span>预付</span>-->
<!--                </button>-->
<!--                <button v-if="contract.id != null && contract.confirmed" class="swb-btn swb-btn-mini mr15" @click.stop="toTradeVoucherList">-->
<!--                    <span>支付管理</span>-->
<!--                </button>-->
                <button v-if="contract.id != null && contract.confirmed" class="swb-btn swb-btn-mini mr15" @click.stop="toPayVoucherList">
                    <span>付款明细</span>
                </button>
                <button v-if="contract.id != null" class="swb-btn swb-btn-mini mr15" @click.stop="showContractRecord">合同操作记录</button>
                <button v-if="contract.id != null && contract.confirmed" class="swb-btn swb-btn-mini mr15" @click.stop="monitoringData">
                    <span>合同数据监控</span>
                </button>
            </div>
            <div class="fr clearfix" v-if="contract.fulfillApplyState != 0">
                <span class="mr15 font14">
                    <label>验收完成审核:</label>
                    <span v-if="contract.checkAuditState == 0">未审核</span>
                    <span v-if="contract.checkAuditState == 1">审核通过</span>
                    <span v-if="contract.checkAuditState == -1">审核未通过</span>
                </span>
                <span class="mr15 font14">
                    <label>验收完成申请:</label>
                    <span v-if="contract.checkApplyState == 0">未申请</span>
                    <span v-if="contract.checkApplyState == 1">已申请</span>
                    <span v-if="contract.checkApplyState == 2">已处理</span>
                </span>
                <span class="mr15 font14">
                    <label>履约完成审核:</label>
                    <span v-if="contract.fulfillAuditState == 0">未审核</span>
                    <span v-if="contract.fulfillAuditState == 1">审核通过</span>
                    <span v-if="contract.fulfillAuditState == -1">审核未通过</span>
                </span>
                <span class="mr15 font14">
                    <label>履约完成申请:</label>
                    <span v-if="contract.fulfillApplyState == 0">未申请</span>
                    <span v-if="contract.fulfillApplyState == 1">已申请</span>
                    <span v-if="contract.fulfillApplyState == 2">已处理</span>
                </span>
            </div>
        </div>
        <el-form :model="contract" :rules="contractRules" ref="contract" class="demo-ruleForm">
            <div class="simple-form flex col-2">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">零售商名称</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="fstPartyName">
                            <el-input :disabled="true" v-model="contract.fstPartyName"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">合同种类</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-radio-group :disabled="contract.id != null" v-model="contract.kindId" @change="kindChange">
                            <el-radio :label="0">标准合同</el-radio>
                            <el-radio :label="1">框架合同</el-radio>
                        </el-radio-group>
                    </div>
                </div>

                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">买方公司</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-input :disabled="true" v-model="contract.fstPartyRealComName"></el-input>
                        <div v-if="operateContract !='chakan'" class="form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择" @click="selectRealCom(true)"></div>
                    </div>
                </div>
                <div class="form-group center" v-if="isLegacyContract">
                    <div class="form-label">
                        <label class="required">线下合同</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-radio-group :disabled="contract.id != null" v-model="contract.offline">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <!--<div class="form-group center" v-if="operateContract=='chakan'">
                    <div class="form-label">
                        <label>{{ merchant }}内部合同编号</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="sndPartyHtBh">
                            <el-input :disabled="true" v-model="contract.sndPartyHtBh"></el-input>
                        </el-form-item>
                    </div>
                </div>-->
                <div class="form-group center" v-if="operateContract=='chakan'">
                    <div class="form-label">
                        <label>原始系统合同编号</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="originalNo">
                            <el-input :disabled="true" v-model="contract.originalNo"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center" v-if="operateContract=='chakan'">
                    <div class="form-label">
                        <label>{{ merchant }}签署人</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="sndPartySigner">
                            <el-input :disabled="true" v-model="contract.sndPartySigner"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center" v-if="contractType == goodsPurch.value || contractType == servcPurch.value">
                    <div class="form-label">
                        <label class="required">合同适用范围</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-input :disabled="true" v-model="contract.signGroupName"></el-input>
                        <div v-if="contract.fstPartyId == scopeEntity.id && operateContract !='chakan' && scopeEntity.type == retailerType" class="form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择"
                             @click="selectSignGroup()"></div>
                        <a class="swb-btn-link" v-if="contract.signGroupId != null && contract.signGroupId > 0" @click="viewSignGroup(contract.signGroupId)">查看</a>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">合同名称</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="title">
                            <el-input :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" v-model="contract.title"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center" v-if="operateContract=='chakan'">
                    <div class="form-label">
                        <label>{{ merchant }}确认时间</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="sndPartyConfirmTime">
                            <el-input :disabled="true" v-model="contract.sndPartyConfirmTime"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <!--<div class="form-group center">-->
                <!--<div class="form-label">-->
                <!--<label>自用合同编号</label>-->
                <!--</div>-->
                <!--<div class="form-value width-2x">-->
                <!--<el-form-item prop="fstPartyHtBh">-->
                <!--<el-input :disabled="operateContract=='chakan'" v-model="contract.fstPartyHtBh"></el-input>-->
                <!--</el-form-item>-->
                <!--</div>-->
                <!--</div>-->

                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">合同编号</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="accordHtBh">
                            <el-input
                                :disabled="operateContract=='chakan' || operateContract=='change' || (operateContract=='edit' && contract.creatorRealComId != null && scopeEntity.realComId != contract.creatorRealComId) || contract.version > 1"
                                v-model="contract.accordHtBh"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <div class="form-group center" v-if="contractType != servcPurch.value">
                    <div class="form-label">
                        <label class="required">跨订单结算</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-radio-group :disabled="contract.id != null" v-model="contract.settleCrossOrderAllowed" @change="settleChange">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </div>
                </div>

                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">合同来源</label>
                    </div>
                    <div v-if="contractType == integPurch.value" class="form-value width-3x">
                        <el-radio-group :disabled="contract.srcId != null || contract.sndPartyId != null" v-model="contract.srcFlag">
                            <el-radio v-for="bizSrcFlag in bizSrcFlagList" v-if="bizSrcFlag.name != 'DeviceRequire' && bizSrcFlag.name != 'DealInqry' && bizSrcFlag.name != 'PriceInqry'" :label="bizSrcFlag.value">
                                <span>{{ bizSrcFlag.text }}</span>
                            </el-radio>
                        </el-radio-group>
                    </div>
                    <div class="form-value width-3x" v-else>
                        <el-radio-group :disabled="contract.srcId != null || contract.sndPartyId != null" v-model="contract.srcFlag">
                            <el-radio v-for="bizSrcFlag in bizSrcFlagList" v-if="bizSrcFlag.name != 'DeviceRequire' && bizSrcFlag.name != 'DealInqry'" :label="bizSrcFlag.value">
                                <span>{{ bizSrcFlag.text }}</span>
                            </el-radio>
                        </el-radio-group>
                    </div>
                </div>

                <div class="form-group center" v-if="contract.srcFlag == 2">
                    <div class="form-label">
                        <label class="required">招标书</label>
                    </div>
                    <div class="form-value width-2x">
                        <div class="btn-label-group" style="margin-top: 7px;overflow: inherit;">
                            <el-form-item prop="srcId">
                                <label class="textfield" style="width: 242px;">{{ contract.srcName }}
                                    <i v-if="operateContract!='chakan' && !disabled && contract.srcId != null" class="cleared" @click="deleteCall()"></i>
                                </label>
                                <div v-if="operateContract=='change' || (contract.id == null || operateContract=='edit') && contract.sndPartyConfirmed == false " class="swb-btn  swb-btn-small fl right-radio" @click="showCallBidDocDlg()">
                                    <span>选择招标书</span>
                                </div>
                                <div class="swb-btn swb-btn-small fl swb-btn-disabled right-radio" v-else>选择招标书</div>
                                <el-input type="text" style="display: none;" v-model.number="contract.srcId"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </div>
                <!--供应商、服务商-->
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">{{ merchant }}</label>
                    </div>
                    <div class="form-value width-2x">
                        <div class="btn-label-group" style="margin-top: 7px;overflow: inherit">
                            <el-form-item prop="sndPartyId">
                                <label class="textfield" style="width: 242px;">{{ contract.sndPartyName }}</label>
                                <div v-if="contract.id == null && contract.srcFlag != 2" class="swb-btn swb-btn-small fl right-radio" @click="showMerchantDlg()">
                                    <span>选择{{ merchant }}</span>
                                </div>
                                <div class="swb-btn swb-btn-small fl swb-btn-disabled right-radio" v-else>选择{{ merchant }}</div>
                                <el-input type="text" style="display: none;" v-model.number="contract.sndPartyId"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">卖方公司</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-input :disabled="true" v-model="contract.sndPartyRealComName"></el-input>
                        <div v-if="operateContract !='chakan'" class="form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择" @click="selectRealCom(false)"></div>
                    </div>
                </div>

                <div class="form-group center" v-if="operateContract=='chakan'">
                    <div class="form-label">
                        <label>{{ merchant }}确认人</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="sndPartyConfirmerName">
                            <el-input :disabled="true" v-model="contract.sndPartyConfirmerName"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <div class="form-group center" v-if="contractType != integPurch.value && contract.srcFlag == 3">
                    <div class="form-label">
                        <label class="required">报价单</label>
                    </div>
                    <div class="form-value width-3x">
                        <div class="btn-label-group" style="margin-top: 7px;overflow: inherit;">
                            <el-form-item prop="srcId">
                                <label class="textfield" style="width: 242px;">{{ contract.srcName }}
                                    <i v-if="operateContract!='chakan' && !disabled && contract.srcId != null" class="cleared" @click="deletePrice()"></i>
                                </label>
                                <div v-if="operateContract=='change' || (contract.id == null || operateContract=='edit') && contract.sndPartyConfirmed == false && contract.sndPartyId != null" class="swb-btn swb-btn-small fl right-radio"
                                     @click="showPriceReplyDocDlg()">
                                    <span>选择报价单</span>
                                </div>
                                <div class="swb-btn swb-btn-small fl swb-btn-disabled right-radio" v-else>选择报价单</div>
                                <span class="inline-block ml10">(请先选择{{ merchant }})</span>
                                <el-input type="text" style="display: none;" v-model.number="contract.srcId"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </div>

                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">签署日期</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="signDate">
                            <el-date-picker class="width-2x" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" @change="changeSignDate" v-model="contract.signDate" type="date"
                                            placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                    </div>
                </div>

                <div class="form-group center" v-if="operateContract=='chakan'">
                    <div class="form-label">
                        <label>否认原因</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="denyCause">
                            <el-input type="textarea" :disabled="true" v-model="contract.denyCause"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">起始时间</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="dateStart">
                            <el-date-picker @change="checkTime" class="width-2x" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" v-model="contract.dateStart" type="date"
                                            placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                    </div>
                </div>

                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">结束时间</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="dateEnd">
                            <el-date-picker @change="checkTime" class="width-2x" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" v-model="contract.dateEnd" type="date"
                                            placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                    </div>
                </div>

                <div class="form-group center">
                    <div class="form-label">
                        <label>签署人姓名</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="fstPartySigner">
                            <el-input :disabled="operateContract=='chakan'" v-model="contract.fstPartySigner"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <div class="form-group center" v-if="forGoods && contract.kindId == 1">
                    <div class="form-label">
                        <label>到货期限（天）</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="desireArriveDays">
                            <el-input class="width-2x" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" type="number" v-model="contract.desireArriveDays"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <div class="form-group center">
                    <div class="form-label">
                        <label>自用合同标签</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="fstPartyFlag">
                            <el-input type="text" :disabled="operateContract!='change' && (disabled || operateContract=='chakan')" v-model="contract.fstPartyFlag"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <div v-if="contract.version>1 || operateContract=='change'" class="form-group center">
                    <div class="form-label">
                        <label>变更简要描述</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="changeDesc">
                            <el-input type="textarea" :disabled="operateContract!='change' && (disabled  || operateContract=='chakan')" v-model="contract.changeDesc"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <div class="form-group center">
                    <div class="form-label">
                        <label>合同摘要</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="content">
                            <el-input type="textarea" :disabled="operateContract!='change' && (disabled || operateContract=='chakan')" v-model="contract.contractDigest.content"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label :class="normalFlag ? 'required' : ''">税率(%)</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="taxRate">
                            <el-select v-if="normalFlag" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" v-model="contract.taxRate" filterable placeholder="请选择税率"
                                       @change="taxRateChange(contract.taxRate)">
                                <el-option v-for="item in fiscalTaxMarkList" :key="item.rate" :label="item.rate" :value="item.rate"></el-option>
                            </el-select>
                            <el-input v-if="!normalFlag" class="width-2x" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" v-model="contract.taxRate" @change="taxRateChange(contract.taxRate)"></el-input>
                            <!--<div class="form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择" @click="selectRateChange()"></div>-->
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center" v-if="contractType == goodsPurch.value">
                    <div class="form-label">
                        <label>购置可抵税</label>
                    </div>
                    <div class="form-value width-2x">
                        <span v-if="contract.taxOffset">是</span>
                        <span v-else>否</span>
                    </div>
                </div>
                <div class="form-group center" v-if="contractType != servcPurch.value">
                    <div class="form-label">
                        <label>启用区域价格</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-checkbox :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" v-model="contract.bizAreaFlag" @change="bizAreaFlagChange(null);"></el-checkbox>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>是否自动结算</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-radio-group v-model="contract.settleAutoFlag" :disabled="operateContract=='chakan'">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="form-group center" v-if="contract.settleAutoFlag">
                    <div class="form-label">
                        <label>结算周期(每月x日)</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-input-number v-model="contract.settlePeriodDay" :controls="false" :min="1" :max="28" :disabled="operateContract=='chakan'"></el-input-number>
                    </div>
                </div>
            </div>
        </el-form>

        <div v-if="contractType != servcPurch.value">
            <div class="content-caption dashed">
                <span>商品信息</span>
            </div>

            <div class="simple-row">
                <div class="left">
                    <button class="swb-btn swb-btn-small swb-btn-disabled" v-if="!showAssetInfo && (showBtn ===  false || disabledBtn) && operateContract!='change'">
                        <span>选择商品</span></button>
                    <button @click="showMkuListDlg" class="swb-btn swb-btn-small" v-else-if="!showAssetInfo"><span>选择商品</span></button>

                    <button class="swb-btn swb-btn-small swb-btn-disabled" v-if="showAssetInfo && (showBtn ===  false || disabledBtn) && operateContract!='change'">
                        <span>选择资产定义</span></button>
                    <button @click="showDevcDefListDlg" class="swb-btn swb-btn-small" v-else-if="showAssetInfo"><span>选择资产定义</span></button>

                    <button class="swb-btn swb-btn-small swb-btn-disabled" v-if="showAssetInfo && (showBtn ===  false || disabledBtn) && operateContract!='change'">
                        <span>选择组装件定义</span></button>
                    <button @click="showAsmblAccListDlg" class="swb-btn swb-btn-small" v-else-if="showAssetInfo"><span>选择组装件定义</span></button>
                </div>
                <div class="right">
                    <button class="swb-btn swb-btn-small swb-btn-primary" v-if="operateContract !='chakan'" @click="setBizFormBatch()">批量设置经营业态</button>
                </div>
            </div>

            <div class="table-layout">
                <el-form :model="contract" ref="contractGoodsList">
                    <el-table ref="multipleTable" :data="contract.contractGoodsList" border tooltip-effect="dark" maxHeight="500" style="width: 100%" @selection-change="handleSelectionChange" v-if="!showAssetInfo">
                        <el-table-column type="selection" width="40" align="center" fixed="left"></el-table-column>
                        <el-table-column align="left" prop="name" label="商品名称"></el-table-column>
                        <el-table-column align="left" prop="catName" label="分类"></el-table-column>
                        <el-table-column align="left" width="100px" prop="brandName" label="品牌"></el-table-column>
                        <el-table-column align="left" prop="model" label="型号"></el-table-column>
                        <el-table-column align="left" prop="fixedSpec" label="规格"></el-table-column>
                        <el-table-column align="center" width="60" prop="asmblAccFlag" label="组装件">
                            <template slot-scope="scope">
                                <el-form-item :prop="'contractGoodsList.' + scope.$index + '.asmblAccFlag'">
                                    <input type="checkbox" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" v-model="scope.row.asmblAccFlag" @change="setAsmblAcc(scope.row, scope.$index)"/>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="180" prop="asmblAccFlag" label="关联定义">
                            <template slot-scope="scope">
                                <span class="ellipsis" style="padding-right: 30px;display: inline-block;width: 100%;line-height: 1;" v-if="scope.row.assetDefId != null && scope.row.assetDefId != -1">{{scope.row.assetDefNo}}</span>
                                <a class="swb-btn-link" v-if="operateContract !='chakan' && (scope.row.assetDefId == null || scope.row.assetDefId == -1) " @click="selectDevcDef(scope.row, scope.$index)">选择</a>
                                <a class="swb-btn-link" v-if="operateContract !='chakan' && scope.row.skuId > 0 && (scope.row.assetDefId == null || scope.row.assetDefId == -1) && !needAudit" @click="saveDevcDef(scope.row, scope.$index)">生成定义</a>
                                <a class="swb-btn-link" :class="scope.row.assetDefId != null && scope.row.assetDefId != -1 ? 'delX' : ''" v-if="operateContract !='chakan'" @click="clearDevcDef(scope.row, scope.$index, true)">清除</a>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="80px" prop="quantity" label="数量" v-if="contract.kindId == 0">
                            <template slot-scope="scope">
                                <el-form-item :prop="'contractGoodsList.' + scope.$index + '.quantity'">
                                    <el-input :maxlength="6" :disabled="(disabled || operateContract=='chakan' || scope.row.bizAreaFlag) && operateContract!='change'" type="text"
                                              @change="goodsAmountOrQuantityChange(scope.row, scope.$index, 'quantity');" v-model.number="scope.row.quantity"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="100" label="是否可定制">
                            <template slot-scope="scope">
                                <input type="checkbox" :disabled="operateContract =='chakan' || scope.row.asmblAccFlag || !scope.row.customizable" v-model="scope.row.customized"/>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="60px" prop="unit" label="单位"></el-table-column>
                        <el-table-column align="center" width="100px" prop="price" label="统一含税价(元)">
                            <template slot-scope="scope">
                                <el-form-item :prop="'contractGoodsList.' + scope.$index + '.price'">
                                    <el-input v-if="checkActionPerm('view_item_price') || operateContract!='chakan'" :maxlength="9" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" type="text"
                                              @change="goodsAmountOrQuantityChange(scope.row, scope.$index, 'price');" v-model="scope.row.price"></el-input>
                                    <el-input v-else disabled type="text" value="没有权限"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="80" label="税率(%)">
                            <template slot-scope="scope">
                                <span v-if="checkActionPerm('view_item_price')">{{ scope.row.taxRate }}</span>
                                <span v-else>没有权限</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="80" prop="taxOffset" label="购置可抵税" v-if="contractType == goodsPurch.value">
                            <template slot-scope="scope">
                                <span v-if="scope.row.taxOffset">是</span>
                                <span v-else>否</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="100px" prop="ntxPrice" label="未税价(元)">
                            <template slot-scope="scope">
                                <div v-if="checkActionPerm('view_item_price')">
                                    <span v-if="scope.row.ntxPrice != null">{{ scope.row.ntxPrice }}</span>
                                    <span v-else>0.00</span>
                                </div>
                                <div v-else>
                                    <span>没有权限</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" width="100px" prop="bizFormNames" label="经营业态">
                            <template slot-scope="scope">
                                <div v-if="scope.row.bizFormNameList != null && scope.row.bizFormNameList.length > 0" v-for="(bizFormName, index) in scope.row.bizFormNameList">
                                    <span class="swb-tags swb-tags-success mr5">{{ bizFormName }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="90" label="启用区域价格">
                            <template slot-scope="scope">
                                <input v-if="checkActionPerm('view_item_price') || operateContract !='chakan'" type="checkbox" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" v-model="scope.row.bizAreaFlag"
                                       @change="bizAreaFlagChange(scope.$index)"/>
                                <span v-else>没有权限</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="100px" prop="amount" label="含税小计(元)" v-if="contract.kindId == 0">
                            <template slot-scope="scope">
                                <div v-if="checkActionPerm('view_item_price')">
                                    <span v-if="scope.row.amount != null">{{ scope.row.amount }}</span>
                                    <span v-else>0.00</span>
                                </div>
                                <div v-else>
                                    <span>没有权限</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="90px" prop="wrntPeriod" label="质保期(月)">
                            <template slot-scope="scope">
                                <el-form-item :prop="'contractGoodsList.' + scope.$index + '.wrntPeriod'" :rules="{validator: inputWrntPeriod, trigger: 'blur'}">
                                    <el-input :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" type="text" v-model.number="scope.row.wrntPeriod"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" width="150px" prop="desc" label="说明">
                            <template slot-scope="scope">
                                <el-form-item :prop="'contractGoodsList.' + scope.$index + '.desc'">
                                    <el-input :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" type="textarea" v-model="scope.row.desc"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column class="fixed" align="left" width="250" label="操作" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <a class="swb-btn-link" v-if="showSave && contract.sndPartyConfirmed == false && contract.srcId == null && contract.srcId == null || operateContract == 'change'" @click="removeGoods(scope.$index)">移除</a>
                                <a class="swb-btn-link"
                                   v-if="operateContract =='chakan' && contract.typeId != integPurch.value && contract.confirmed && contract.curValid && !contract.fullfilled && !contract.closed && contract.lockMode != 1 && !contractterminated "
                                   @click="addAdoptedDevice(scope.$index)">加入入选商品</a>
                                <a class="swb-btn-link" v-if="checkActionPerm('view_item_price') && scope.row.bizAreaFlag" @click="bizAreaOption(scope.row, scope.$index)">经营区域价格</a>
                                <a class="swb-btn-link" v-if="operateContract !='chakan'" @click="setBizForm(scope.row, scope.$index)">设置经营业态</a>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-table ref="multipleTable" :data="contract.contractGoodsList" border tooltip-effect="dark" maxHeight="500" style="width: 100%" @selection-change="handleSelectionChange" v-if="showAssetInfo">
                        <el-table-column type="selection" width="40" align="center" fixed="left"></el-table-column>
                        <el-table-column align="center" label="资产信息">
                            <el-table-column width="180" align="left" prop="assetDefNo" label="定义编码" style="position: relative" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <span class="ellipsis" style="padding-right: 30px;display: inline-block;width: 100%;line-height: 1;" v-if="scope.row.assetDefId != null && scope.row.assetDefId != -1">{{
                                            scope.row.assetDefNo
                                        }}</span>
                                    <a class="swb-btn-link" v-if="operateContract !='chakan' && (scope.row.assetDefId == null || scope.row.assetDefId == -1) " @click="selectDevcDef(scope.row, scope.$index)">选择</a>
                                    <a class="swb-btn-link" v-if="operateContract !='chakan' && scope.row.skuId > 0 && (scope.row.assetDefId == null || scope.row.assetDefId == -1) && !needAudit"
                                       @click="saveDevcDef(scope.row, scope.$index)">生成定义</a>
                                    <a class="swb-btn-link" :class="scope.row.assetDefId != null && scope.row.assetDefId != -1 ? 'delX' : ''" v-if="operateContract !='chakan'" @click="clearDevcDef(scope.row, scope.$index, true)">清除</a>
                                </template>
                            </el-table-column>
                            <el-table-column align="left" prop="devcName" label="名称" show-overflow-tooltip></el-table-column>
                            <el-table-column align="left" prop="devcCatName" label="分类" show-overflow-tooltip></el-table-column>
                            <el-table-column align="left" width="100px" prop="devcBrandName" label="品牌" show-overflow-tooltip></el-table-column>
                            <el-table-column align="left" prop="devcModel" label="型号" show-overflow-tooltip></el-table-column>
                            <el-table-column align="left" prop="devcFixedSpec" label="规格" show-overflow-tooltip></el-table-column>
                            <el-table-column align="center" width="60px" prop="devcUnit" label="单位"></el-table-column>
                        </el-table-column>
                        <el-table-column align="center" label="商品信息">
                            <el-table-column width="130" align="left" prop="name" label="名称" style="position: relative" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <span v-if="scope.row.name != null && scope.row.name != ''" class="ellipsis" style="padding-right: 30px;display: inline-block;width: 100%;line-height: 1;">{{
                                            scope.row.name
                                        }}</span>
                                    <a class="swb-btn-link" style="position: absolute;right: 2px;" @click="selectAdoptedDevice(scope.row, scope.$index)" v-if="operateContract !='chakan'">
                                        <span v-if="scope.row.name == null || scope.row.name == ''">选择</span>
                                        <span v-else>更换</span>
                                    </a>
                                </template>
                            </el-table-column>
                            <el-table-column align="left" prop="catName" label="分类" show-overflow-tooltip></el-table-column>
                            <el-table-column align="left" width="100px" prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
                            <el-table-column align="left" prop="model" label="型号" show-overflow-tooltip></el-table-column>
                            <el-table-column align="left" prop="fixedSpec" label="规格" show-overflow-tooltip></el-table-column>
                            <el-table-column align="center" width="60px" prop="unit" label="单位"></el-table-column>
                        </el-table-column>
                        <el-table-column align="center" width="80px" prop="quantity" label="数量" v-if="contract.kindId == 0">
                            <template slot-scope="scope">
                                <el-form-item :prop="'contractGoodsList.' + scope.$index + '.quantity'">
                                    <el-input :maxlength="6" :disabled="(disabled || operateContract=='chakan' || scope.row.bizAreaFlag) && operateContract!='change'" type="text"
                                              @change="goodsAmountOrQuantityChange(scope.row, scope.$index, 'quantity');" v-model.number="scope.row.quantity"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="100" label="是否可定制">
                            <template slot-scope="scope">
                                <input type="checkbox" :disabled="operateContract =='chakan' || scope.row.asmblAccFlag || !scope.row.customizable" v-model="scope.row.customized"/>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="100px" prop="price" label="统一含税价(元)">
                            <template slot-scope="scope">
                                <el-form-item :prop="'contractGoodsList.' + scope.$index + '.price'">
                                    <el-input v-if="checkActionPerm('view_item_price') || operateContract!='chakan'" :maxlength="9" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" type="text"
                                              @change="goodsAmountOrQuantityChange(scope.row, scope.$index, 'price');" v-model="scope.row.price"></el-input>
                                    <el-input v-else disabled type="text" value="没有权限"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="80" label="税率(%)">
                            <template slot-scope="scope">
                                <span v-if="checkActionPerm('view_item_price')">{{ scope.row.taxRate }}</span>
                                <span v-else>没有权限</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="80" prop="taxOffset" label="购置可抵税" v-if="contractType == goodsPurch.value">
                            <template slot-scope="scope">
                                <span v-if="scope.row.taxOffset">是</span>
                                <span v-else>否</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="100px" prop="ntxPrice" label="未税价(元)">
                            <template slot-scope="scope">
                                <div v-if="checkActionPerm('view_item_price')">
                                    <span v-if="scope.row.ntxPrice != null">{{ scope.row.ntxPrice }}</span>
                                    <span v-else>0.00</span>
                                </div>
                                <div v-else>
                                    <span>没有权限</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" width="100px" prop="bizFormNames" label="经营业态">
                            <template slot-scope="scope">
                                <div v-if="scope.row.bizFormNameList != null && scope.row.bizFormNameList.length > 0" v-for="(bizFormName, index) in scope.row.bizFormNameList">
                                    <span class="swb-tags swb-tags-success mr5">{{ bizFormName }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="90" label="启用区域价格">
                            <template slot-scope="scope">
                                <input v-if="checkActionPerm('view_item_price') || operateContract !='chakan'" type="checkbox" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" v-model="scope.row.bizAreaFlag"
                                       @change="bizAreaFlagChange(scope.$index)"/>
                                <span v-else>没有权限</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="100px" prop="amount" label="含税小计(元)" v-if="contract.kindId == 0">
                            <template slot-scope="scope">
                                <div v-if="checkActionPerm('view_item_price')">
                                    <span v-if="scope.row.amount != null">{{ scope.row.amount }}</span>
                                    <span v-else>0.00</span>
                                </div>
                                <div v-else>
                                    <span>没有权限</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="90px" prop="wrntPeriod" label="质保期(月)">
                            <template slot-scope="scope">
                                <el-form-item :prop="'contractGoodsList.' + scope.$index + '.wrntPeriod'" :rules="{validator: inputWrntPeriod, trigger: 'blur'}" v-if="scope.row.skuId != null && scope.row.skuId != -1">
                                    <el-input :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" type="text" v-model.number="scope.row.wrntPeriod"></el-input>
                                </el-form-item>
                                <el-form-item :prop="'contractGoodsList.' + scope.$index + '.wrntPeriod'" v-else>
                                    <el-input :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" type="text" v-model.number="scope.row.wrntPeriod"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="60" prop="asmblAccFlag" label="组装件">
                            <template slot-scope="scope">
                                <el-form-item :prop="'contractGoodsList.' + scope.$index + '.asmblAccFlag'">
                                    <input type="checkbox" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" v-model="scope.row.asmblAccFlag" @change="setAsmblAcc(scope.row, scope.$index)"/>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" width="150px" prop="desc" label="说明">
                            <template slot-scope="scope">
                                <el-form-item :prop="'contractGoodsList.' + scope.$index + '.desc'">
                                    <el-input :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" type="textarea" v-model="scope.row.desc"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column class="fixed" align="left" width="250" label="操作" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <a class="swb-btn-link" v-if="showSave && contract.sndPartyConfirmed == false && contract.srcId == null && contract.srcId == null || operateContract == 'change'" @click="removeGoods(scope.$index)">移除</a>
                                <a class="swb-btn-link"
                                   v-if="operateContract =='chakan' && contract.typeId != integPurch.value && contract.confirmed && contract.curValid && !contract.fullfilled && !contract.closed && contract.lockMode != 1 && !contractterminated "
                                   @click="addAdoptedDevice(scope.$index)">加入入选商品</a>
                                <a class="swb-btn-link" v-if="checkActionPerm('view_item_price') && scope.row.bizAreaFlag" @click="bizAreaOption(scope.row, scope.$index)">经营区域价格</a>
                                <a class="swb-btn-link" v-if="operateContract !='chakan'" @click="setBizForm(scope.row, scope.$index)">设置经营业态</a>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form>
            </div>
            <div class="simple-form flex col-5" v-if="contract.kindId != null && contract.kindId == 0">
                <div class="form-group center">
                    <div class="form-label">
                        <label>预计合同总额</label>
                    </div>
                    <div class="form-value width-2x">
                        <input v-if="checkActionPerm('view_total_price') || operateContract!='chakan'" :disabled="((showBtn ===  false || disabledBtn) && operateContract!='change') && showAmtAndCot"
                               style="border:1px solid #DDDDDD; width: 100px; height: 30px;" v-model.number="contract.estmtAmount"/>
                        <input v-else disabled style="border:1px solid #DDDDDD; width: 65px; height: 30px;" value="没有权限"/><span>元</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>预计商品总数量</label>
                    </div>
                    <div class="form-value width-2x">
                        <input :disabled="true" style="border:1px solid #DDDDDD; width: 65px; height: 30px;" v-model.number="contract.estmtGoodsCount"/><span>件</span>
                    </div>
                </div>
            </div>
        </div>
        <template v-if="contractType != goodsPurch.value">
            <div class="content-caption dashed">
                <span>适用机构(必选)</span>
                <span class="font-red" style="font-size: 16px;" v-if="operateContract=='change'">注意：移除适用机构后，再重新添加将按照新机构计算服务次数和价格，请谨慎操作</span>
                <span class="swb-btn swb-btn-link" v-if="(!disabled && operateContract !='chakan') || operateContract =='change'" @click="selectAppliedShop">选择</span>
                <span class="swb-btn swb-btn-link" v-if="(!disabled && operateContract !='chakan') || operateContract =='change'" @click="generalImport">导入</span>
            </div>
            <el-tag class="mr5" v-for="(contractAppliedShop, index) in contract.contractAppliedShopList" :key="contractAppliedShop.shopName" :closable="(!disabled && operateContract !='chakan') || operateContract =='change'" type="info"
                    @close="deleteAppliedShop(index)">
                <span>{{ contractAppliedShop.shopName }}</span>
            </el-tag>

            <div class="content-caption dashed">
                <span>设备维保服务</span>
                <span class="font-red" style="font-size: 16px;" v-if="operateContract=='change'">注意：移除设备维保服务后，再重新添加将按照新服务重新计算服务次数和价格，请谨慎操作</span>
            </div>
            <div class="table-layout" style="overflow:auto">
                <el-form :model="contract" ref="contractServcList">
                    <table class="custom-tbl error-prompt">
                        <thead class="head">
                        <tr class="row">
                            <th width="200" class="text-align: left;">设备维保分组</th>
                            <th width="150" class="text-align: left;">资产品牌</th>
                            <th width="150" class="text-align: left;">服务类型</th>
                            <th width="150" class="text-align: left;">商品分类</th>
                            <th width="200" class="text-align: left;">服务内容</th>
                            <th width="80" class="text-align: left;">仅部件报修</th>
                            <th width="300" class="text-align: left;">设备部件</th>
                            <th width="200" class="text-align: left;">服务项目</th>
                            <th width="140" class="text-align: right;">上门费(元)</th>
                            <th width="140" class="text-align: right;">服务费(元)</th>
                            <th width="140" class="text-align: right;">要求响应时长(分钟)</th>
                            <th width="140" class="text-align: right;">要求到达时长(分钟)</th>
                            <th width="140" class="text-align: right;">要求维修时长(分钟)</th>
                            <th width="120" class="text-align: right;">要求质保时长(天)</th>
                            <th width="140" class="text-align: right;">电话回询时限(分钟)</th>
                            <th width="200" class="text-align: right;">服务次数</th>
                            <th width="140" class="text-align: right;">服务次数允许修订</th>
                            <th width="140" class="text-align: right;">小计(元)</th>
                            <th width="200" class="text-align: left;">操作</th>
                        </tr>
                        </thead>
                        <tbody class="body">
                        <tr v-for="(item,index) in contract.contractServcList" class="row">
                            <td>
                                <el-form-item :prop="'contractServcList.' + index + '.devcGroupId'" :rules="{validator: checkNull, trigger: 'change'}">
                                    <span class="fl">{{ item.devcGroupFullName || '' }}</span>
                                    <a class="swb-btn-link fr" v-if="operateContract !='chakan' && !disabled" @click="selectDevcGroup(index)">选择</a>
                                </el-form-item>
                            </td>
                            <td>
                                <el-form-item :prop="'contractServcList.' + index + '.innerDevcBrandId'">
                                    <span class="fl">{{ item.innerDevcBrandName || '' }}</span>
                                    <a class="swb-btn-link fr" v-if="operateContract !='chakan' && !disabled" @click="selectInnerDevcBrand(index)">选择</a>
                                </el-form-item>
                            </td>
                            <td>
                                <el-form-item :prop="'contractServcList.' + index + '.servcTypeId'" :rules="{validator: checkNull, trigger: 'change'}">
                                    <el-select v-model="item.servcTypeId" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" @change="servcTypeChange(index, false)"
                                               @visible-change="servcTypeVisChange(index, false)">
                                        <el-option v-for="servcType in servcTypeList" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" :key="servcType.value" :label="servcType.text"
                                                   :value="servcType.value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </td>
                            <td>
                                <el-form-item :prop="'contractServcList.' + index + '.goodsCatId'">
                                    <span class="fl">{{ item.goodsCatName || '' }}</span>
                                    <a class="swb-btn-link fr" v-if="operateContract !='chakan' && !disabled" @click="selectGoodsCat(index)">选择</a>
                                </el-form-item>
                            </td>
                            <td>
                                <el-form-item :prop="'contractServcList.' + index + '.servcSpec'" :rules="{validator: checkNull, trigger: 'blur'}">
                                    <el-input type="textarea" :rows="2" v-model="item.servcSpec" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"></el-input>
                                </el-form-item>
                            </td>
                            <td>
                                <el-form-item :prop="'contractServcList.' + index + '.devcPartsOnly'">
                                    <input type="checkbox" v-model="item.devcPartsOnly" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" @change="devcPartsOnlyChange(index)"/>
                                </el-form-item>
                            </td>
                            <td>
                                <span class="fl">{{ item.devcParts || '' }}</span>
                                <a class="swb-btn-link fr" v-if="operateContract !='chakan' && !disabled && item.devcPartsOnly" @click="selectDevcGroupPart(index)">选择</a>
                            </td>
                            <td>
                                <span class="fl">{{ item.title || '' }}</span>
                                <a class="swb-btn-link fr" v-if="operateContract !='chakan' && !disabled" @click="showMsuListDlg(item, index, false)">选择</a>
                            </td>
                            <td>
                                <el-form-item :prop="'contractServcList.' + index + '.toDoorFee'" :rules="{validator: moneyCheck, trigger: 'blur'}">
                                    <el-input type="number" :min="0" v-model="item.toDoorFee" @change="toDoorFeeChange(index, false)" v-if="checkActionPerm('view_item_price') || operateContract!='chakan'"
                                              :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"></el-input>
                                    <el-input v-else disabled type="text" value="没有权限"></el-input>
                                </el-form-item>
                            </td>
                            <td>
                                <el-form-item :prop="'contractServcList.' + index + '.price'" :rules="{validator: moneyCheck, trigger: 'blur'}">
                                    <el-input type="number" :min="0" v-model="item.price" @change="priceChange(index, false)" v-if="checkActionPerm('view_item_price') || operateContract!='chakan'"
                                              :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"></el-input>
                                    <el-input v-else disabled type="text" value="没有权限"></el-input>
                                </el-form-item>
                            </td>
                            <td>
                                <el-form-item :prop="'contractServcList.' + index + '.rspTimeMi'" :rules="{validator: timeMiCheck, trigger: 'blur'}">
                                    <el-input type="number" :min="0" v-model.number="item.rspTimeMi" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"></el-input>
                                </el-form-item>
                            </td>
                            <td>
                                <el-form-item :prop="'contractServcList.' + index + '.arriveTimeMi'" :rules="{validator: timeMiCheck, trigger: 'blur'}">
                                    <el-input type="number" :min="0" v-model.number="item.arriveTimeMi" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"></el-input>
                                </el-form-item>
                            </td>
                            <td>
                                <el-form-item :prop="'contractServcList.' + index + '.repairedTimeMi'" :rules="{validator: timeMiCheck, trigger: 'blur'}">
                                    <el-input type="number" :min="0" v-model.number="item.repairedTimeMi" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"></el-input>
                                </el-form-item>
                            </td>
                            <td>
                                <el-form-item :prop="'contractServcList.' + index + '.wrntPeriod'" :rules="{validator: timeMiCheck, trigger: 'blur'}">
                                    <el-input type="number" :min="0" v-model.number="item.wrntPeriod" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"></el-input>
                                </el-form-item>
                            </td>
                            <td>
                                <el-form-item :prop="'contractServcList.' + index + '.telCallTimeMi'" :rules="{validator: timeMiCheck, trigger: 'blur'}">
                                    <el-input type="number" :min="0" v-model.number="item.telCallTimeMi" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"></el-input>
                                </el-form-item>
                            </td>
                            <td>
                                <el-form-item :prop="'contractServcList.' + index + '.timesLimitType'" :rules="{validator: checkNull, trigger: 'change'}">
                                    <el-select v-model="item.timesLimitType" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" @change="timesLimitTypeChange(index, false)"
                                               @visible-change="timesLimitTypeVisChange(index, false)">
                                        <el-option v-for="timesLimitType in timesLimitTypeList" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" :key="timesLimitType.value" :label="timesLimitType.text"
                                                   :value="timesLimitType.value"></el-option>
                                    </el-select>
                                </el-form-item>
                                <template v-if="item.timesLimitType == 0">
                                    <el-form-item :prop="'contractServcList.' + index + '.quantity'" :rules="{validator: quantityCheck, trigger: 'blur'}">
                                        <el-input type="number" :min="0" v-model.number="item.quantity" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" @change="quantityChange(index, false)"></el-input>
                                    </el-form-item>
                                </template>
                            </td>
                            <td>
                                <!-- 服务次数允许修订 -->
                                <el-form-item :prop="'contractServcList.' + index + '.quantityRevisible'">
                                    <input type="checkbox" v-model="item.quantityRevisible" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"/>
                                </el-form-item>
                            </td>
                            <td>
                                <span v-if="checkActionPerm('view_item_price')">{{ item.amount }}</span>
                                <span v-else>没有权限</span>
                            </td>
                            <td>
                                <div @click="removeContractServc(index, false);" class="swb-btn swb-btn-link" v-if="showSave && contract.sndPartyConfirmed == false && contract.srcId == null || operateContract == 'change'">
                                    <span>移除</span>
                                </div>
                                <div @click="setOrgSpecInfo(index, item.servcTypeId, item.timesLimitType, item.quantityRevisible, false);" class="swb-btn swb-btn-link" v-if="contract.srcId == null">
                                    <!-- 【保养，检验，巡检】+ 按门店设定次数： 可设定总价-->
                                    <span>{{ item.timesLimitType != 1 ? '设置特定门店价格' : '设置门店次数和价格' }}</span>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                        <tfoot class="foot">
                        <tr class="row">
                            <td colspan="17" style="padding: 10px; border: 1px solid #dfe6ec; text-align: center;"
                                v-if="contract.sndPartyId != null && contract.sndPartyId > 0 && (showBtn === true || !disabledBtn) && operateContract!='chakan'">
                                <div @click="addContractServc(false);" class="swb-btn swb-btn-link">
                                    <i class="icon iconfont icon-jiahao mr5"></i>
                                    <span>添加</span>
                                </div>
                            </td>
                        </tr>
                        </tfoot>
                    </table>
                </el-form>
            </div>
            <div class="content-caption dashed">
                <span>常规服务请求</span>
                <span class="font-red" style="font-size: 16px;" v-if="operateContract=='change'">注意：移除常规服务请求后，再重新添加将按照新服务重新计算服务次数和价格，请谨慎操作</span>
            </div>
            <div class="table-layout" style="overflow:auto">
                <el-form :model="contract" ref="contractServc2List">
                    <table class="custom-tbl error-prompt">
                        <thead class="head">
                        <tr class="row">
                            <th width="150" class="text-align: left;">服务类型</th>
                            <th width="200" class="text-align: left;">常规服务需求</th>
                            <th width="200" class="text-align: left;">服务内容</th>
                            <th width="200" class="text-align: left;">服务项目</th>
                            <th width="140" class="text-align: right;">上门费(元)</th>
                            <th width="140" class="text-align: right;">服务费(元)</th>
                            <th width="140" class="text-align: right;">要求响应时长(分钟)</th>
                            <th width="140" class="text-align: right;">要求到达时长(分钟)</th>
                            <th width="140" class="text-align: right;">要求维修时长(分钟)</th>
                            <th width="120" class="text-align: right;">要求质保时长(天)</th>
                            <th width="140" class="text-align: right;">电话回询时限(分钟)</th>
                            <th width="200" class="text-align: right;">服务次数</th>
                            <th width="140" class="text-align: right;">服务次数允许修订</th>
                            <th width="140" class="text-align: right;">小计(元)</th>
                            <th width="150">操作</th>
                        </tr>
                        </thead>
                        <tbody class="body">
                        <tr v-for="(item,index) in contract.contractServc2List" class="row">
                            <td>
                                <el-form-item :prop="'contractServc2List.' + index + '.servcTypeId'" :rules="{validator: checkNull, trigger: 'change'}">
                                    <el-select v-model="item.servcTypeId" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" @change="servcTypeChange(index, true, item.servcTypeId)"
                                               @visible-change="servcTypeVisChange(index, false)">
                                        <el-option v-for="servcType in servcTypeList" :key="servcType.value" :label="servcType.text" :value="servcType.value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </td>
                            <td>
                                <el-form-item :prop="'contractServc2List.' + index + '.comnRequireId'" :rules="{validator: checkNull, trigger: 'change'}">
                                    <span class="fl">{{ item.comnRequireTitle || '' }}</span>
                                    <a class="swb-btn-link fr" v-if="operateContract !='chakan' && !disabled" @click="selectComnRequire(item, index)">选择</a>
                                </el-form-item>
                            </td>
                            <td>
                                <el-form-item :prop="'contractServc2List.' + index + '.servcSpec'" :rules="{validator: checkNull, trigger: 'blur'}">
                                    <el-input type="textarea" :rows="2" v-model="item.servcSpec" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"></el-input>
                                </el-form-item>
                            </td>
                            <td>
                                <span class="fl">{{ item.title || '' }}</span>
                                <a class="swb-btn-link fr" v-if="operateContract !='chakan' && !disabled" @click="showMsuListDlg(item, index, true)">选择</a>
                            </td>
                            <td>
                                <el-form-item :prop="'contractServc2List.' + index + '.toDoorFee'" :rules="{validator: moneyCheck, trigger: 'blur'}">
                                    <el-input type="number" :min="0" v-model="item.toDoorFee" @change="toDoorFeeChange(index, true)" v-if="checkActionPerm('view_item_price') || operateContract!='chakan'"
                                              :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"></el-input>
                                    <el-input v-else disabled type="text" value="没有权限"></el-input>
                                </el-form-item>
                            </td>
                            <td>
                                <el-form-item :prop="'contractServc2List.' + index + '.price'" :rules="{validator: moneyCheck, trigger: 'blur'}">
                                    <el-input type="number" :min="0" v-model="item.price" @change="priceChange(index, true)" v-if="checkActionPerm('view_item_price') || operateContract!='chakan'"
                                              :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"></el-input>
                                    <el-input v-else disabled type="text" value="没有权限"></el-input>
                                </el-form-item>
                            </td>
                            <td>
                                <el-form-item :prop="'contractServc2List.' + index + '.rspTimeMi'" :rules="{validator: timeMiCheck, trigger: 'blur'}">
                                    <el-input type="number" :min="0" v-model.number="item.rspTimeMi" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"></el-input>
                                </el-form-item>
                            </td>
                            <td>
                                <el-form-item :prop="'contractServc2List.' + index + '.arriveTimeMi'" :rules="{validator: timeMiCheck, trigger: 'blur'}">
                                    <el-input type="number" :min="0" v-model.number="item.arriveTimeMi" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"></el-input>
                                </el-form-item>
                            </td>
                            <td>
                                <el-form-item :prop="'contractServc2List.' + index + '.repairedTimeMi'" :rules="{validator: timeMiCheck, trigger: 'blur'}">
                                    <el-input type="number" :min="0" v-model.number="item.repairedTimeMi" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"></el-input>
                                </el-form-item>
                            </td>
                            <td>
                                <el-form-item :prop="'contractServc2List.' + index + '.wrntPeriod'" :rules="{validator: timeMiCheck, trigger: 'blur'}">
                                    <el-input type="number" :min="0" v-model.number="item.wrntPeriod" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"></el-input>
                                </el-form-item>
                            </td>
                            <td>
                                <el-form-item :prop="'contractServc2List.' + index + '.telCallTimeMi'" :rules="{validator: timeMiCheck, trigger: 'blur'}">
                                    <el-input type="number" :min="0" v-model.number="item.telCallTimeMi" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"></el-input>
                                </el-form-item>
                            </td>
                            <td>
                                <el-form-item :prop="'contractServc2List.' + index + '.timesLimitType'" :rules="{validator: checkNull, trigger: 'change'}">
                                    <el-select v-model="item.timesLimitType" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" @change="timesLimitTypeChange(event, index, true)"
                                               @visible-change="timesLimitTypeVisChange(index, false)">
                                        <el-option v-for="timesLimitType in timesLimitTypeList" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" :key="timesLimitType.value" :label="timesLimitType.text"
                                                   :value="timesLimitType.value"></el-option>
                                    </el-select>
                                </el-form-item>
                                <template v-if="item.timesLimitType == 0">
                                    <el-form-item :prop="'contractServc2List.' + index + '.quantity'" :rules="{validator: quantityCheck, trigger: 'blur'}">
                                        <el-input type="number" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" :min="0" v-model.number="item.quantity" @change="quantityChange(index, true)"></el-input>
                                    </el-form-item>
                                </template>
                            </td>
                            <td>
                                <!-- 服务次数允许修订 -->
                                <el-form-item :prop="'contractServc2List.' + index + '.quantityRevisible'">
                                    <input type="checkbox" v-model="item.quantityRevisible" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"/>
                                </el-form-item>
                            </td>
                            <td>
                                <span v-if="checkActionPerm('view_item_price')">{{ item.amount }}</span>
                                <span v-else>没有权限</span>
                            </td>
                            <td>
                                <div @click="removeContractServc(index, true);" class="swb-btn swb-btn-link" v-if="showSave && contract.sndPartyConfirmed == false && contract.srcId == null || operateContract == 'change'">
                                    <span>移除</span>
                                </div>
                                <div @click="setOrgSpecInfo(index, item.servcTypeId, item.timesLimitType, item.quantityRevisible, true);" class="swb-btn swb-btn-link" v-if="contract.srcId == null">
                                    <!-- 【保养，检验，巡检】+ 按门店设定次数： 可设定总价-->
                                    <span>{{ item.timesLimitType != 1 ? '设置特定门店价格' : '设置门店次数和价格' }}</span>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                        <tfoot class="foot">
                        <tr class="row">
                            <td colspan="14" style="padding: 10px; border: 1px solid #dfe6ec; text-align: center;"
                                v-if="contract.sndPartyId != null && contract.sndPartyId > 0 && (showBtn === true || !disabledBtn) && operateContract!='chakan'">
                                <div @click="addContractServc(true);" class="swb-btn swb-btn-link">
                                    <i class="icon iconfont icon-jiahao mr5"></i>
                                    <span>添加</span>
                                </div>
                            </td>
                        </tr>
                        </tfoot>
                    </table>
                </el-form>
            </div>
            <div class="simple-form label" v-if="contract.kindId != null && contract.kindId == 0">
                <div class="form-group center">
                    <div class="form-label">
                        <label>预计合同总额</label>
                    </div>
                    <div class="form-value">
                        <input v-if="checkActionPerm('view_total_price') || operateContract!='chakan'" :disabled="((showBtn ===  false || disabledBtn) && operateContract!='change') && showAmtAndCot"
                               style="border:1px solid #DDDDDD; width: 100px; height: 30px;" v-model.number="contract.estmtAmount"/>
                        <input v-else disabled style="border:1px solid #DDDDDD; width: 65px; height: 30px;" value="没有权限"/>元
                        <span>(含服务包死价{{
                                (contract.totalServcAmount == null || contract.totalServcAmount == '') ? 0 : ((contract.totalServcAmount).toFixed(0)).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
                            }}元)</span>

                        <el-checkbox :disabled="((showBtn ===  false || disabledBtn) && operateContract!='change') && showAmtAndCot" v-model="contract.servcAmountFixed" @change="servcAmountFixedChange">
                            <span>服务是否包死价</span>
                        </el-checkbox>
                        <span v-if="contract.servcAmountFixed" class="ml15">
                            服务包死价总额: <el-input :disabled="((showBtn ===  false || disabledBtn) && operateContract!='change') && showAmtAndCot" style="border:1px solid #DDDDDD; width: 65px; height: 30px;" @change="servcAmountChange"
                                                      v-model.number="contract.totalServcAmount"/>元
                        </span>
                    </div>
                </div>
            </div>

            <div class="content-caption dashed">
                <span>纳入结算单费用项</span>
            </div>
            <div>
                <el-checkbox-group v-model="contract.settleInvolvedFeeTypeIds" @change="changeWorkFeeType" :disabled="operateContract=='chakan'">
                    <el-checkbox class="mt10" v-for="workFeeType in workFeeTypeList" :label="workFeeType.value">{{ workFeeType.text }}</el-checkbox>
                </el-checkbox-group>
            </div>

            <div class="content-caption dashed">
                <span>配件信息</span>
            </div>
            <div class="simple-form flex col-3 label">
                <div class="form-group center">
                    <div class="form-label">
                        <label>配件审核规则</label>
                    </div>
                    <div class="form-value"></div>
                </div>
            </div>
            <div class="simple-form flex col-3 label">
                <div class="form-group center">
                    <div class="form-label">
                        <label>服务商配件</label>
                    </div>
                    <div class="form-value">
                        <el-select v-model="contract.useAccAuditRule" :disabled="operateContract=='chakan'">
                            <el-option v-for="accAuditRule in accAuditRuleList" :label="accAuditRule.text" :value="accAuditRule.value"></el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="simple-form flex col-3 label" v-if="contract.useAccAuditRule">
                <div class="form-group center">
                    <div class="form-label">
                        <label></label>
                    </div>
                    <div class="form-value">
                        <div>
                            <el-checkbox class="mt10" v-model="contract.sglAccAuditEnabled" :disabled="operateContract=='chakan'"></el-checkbox>
                            <span>单个配件大于</span>
                            <el-input-number v-model="contract.sglAccAmntLimit" :controls="false" :min="0" :disabled="operateContract=='chakan'"></el-input-number>
                            <span>元需要审批</span>
                        </div>
                        <div>
                            <el-checkbox class="mt10" v-model="contract.sumAccAuditEnabled" :disabled="operateContract=='chakan'"></el-checkbox>
                            <span>工单配件总金额大于</span>
                            <el-input-number v-model="contract.sumAccAmntLimit" :controls="false" :min="0" :disabled="operateContract=='chakan'"></el-input-number>
                            <span>元需要审批</span>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <div class="content-caption dashed">
            <span>发票信息</span>
            <span class="swb-btn swb-btn-link" v-if="(!disabled && operateContract !='chakan') || operateContract =='change'" @click="selectInvoiceSubject">常用发票</span>
        </div>
        <el-form :model="contract" :rules="contractRules" ref="contractInvoice" class="demo-ruleForm">
            <div class="simple-form flex col-2">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">发票类型</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="invoiceType">
                            <div v-if="(disabled || operateContract=='chakan') && operateContract!='change'">
                                <ul class="enum-list">
                                    <li class="enum-item" v-bind:class="{checked : (merchantInvoiceType.value == contract.invoiceType)}" v-for="merchantInvoiceType in invoiceTypeList">
                                        {{ merchantInvoiceType.text }}<i></i>
                                    </li>
                                </ul>
                            </div>
                            <div v-else>
                                <ul class="enum-list">
                                    <li class="enum-item" :class="{checked : (merchantInvoiceType.value == contract.invoiceType)}" v-for="merchantInvoiceType in invoiceTypeList" @click="checkInvoiceType(merchantInvoiceType.value)">
                                        {{ merchantInvoiceType.text }}<i></i>
                                    </li>
                                </ul>
                            </div>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>发票抬头</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-input :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" v-model="contract.invoiceTitle"></el-input>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>发票内容标签</label>
                    </div>
                    <div class="form-value width-2x mt5">
                        <el-form-item prop="invoiceContentTag">
                            <div v-if="(disabled || operateContract=='chakan') && operateContract!='change'">
                                <ul class="enum-list">
                                    <li class="enum-item" v-bind:class="{checked : invoiceContentTag.name == contract.invoiceContentTag}" v-for="invoiceContentTag in invoiceContentTagList">
                                        {{ invoiceContentTag.name }}<i></i>
                                    </li>
                                </ul>
                            </div>
                            <div v-else>
                                <ul class="enum-list">
                                    <li class="enum-item" v-bind:class="{checked : invoiceContentTag.name == contract.invoiceContentTag}" v-for="invoiceContentTag in invoiceContentTagList"
                                        @click="checkinvoiceContentTag(invoiceContentTag.name)">
                                        {{ invoiceContentTag.name }}<i></i>
                                    </li>
                                </ul>
                            </div>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">纳税人识别号</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-input :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" v-model="contract.taxPayerNo"></el-input>
                    </div>
                </div>
            </div>
        </el-form>

        <div class="content-caption dashed">
            <span>收款信息</span>
        </div>
        <div class="simple-form flex col-3 label">
            <div class="form-group center">
                <div class="form-label">
                    <label>收款银行卡号</label>
                </div>
                <div class="form-value">
                    <el-input class="width-1-5x bottom-line" :disabled="operateContract=='chakan'" type="text" v-model="contract.sndPartyCardNo"></el-input>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>银行名称</label>
                </div>
                <div class="form-value">
                    <el-input class="width-1-5x bottom-line" :disabled="operateContract=='chakan'" type="text" v-model="contract.sndPartyBankName"></el-input>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>账号名称</label>
                </div>
                <div class="form-value">
                    <el-input class="width-1-5x bottom-line" :disabled="operateContract=='chakan'" type="text" v-model="contract.sndPartyAcctName"></el-input>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>银行账号</label>
                </div>
                <div class="form-value">
                    <el-input class="width-1-5x bottom-line" :disabled="operateContract=='chakan'" type="text" v-model="contract.sndPartyAcctNo"></el-input>
                </div>
            </div>
        </div>

        <div v-if="contract.phaseFlag && !contract.settleCrossOrderAllowed">
            <div class="content-caption dashed">
                <span>履约阶段</span>
            </div>
            <swb-contract-track-phase ref="swb_contract_track_phase" :contractId="contract.id" :offline="contract.offline" :estmtAmount="contract.estmtAmount" :estmtGoodsCount="contract.estmtGoodsCount" :contractType="contractType"
                                      :operate="operateContract"></swb-contract-track-phase>
            <div class="simple-form label">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">是否按阶段履约</label>
                    </div>
                    <div class="form-value width-3x">
                        <el-radio-group :disabled="contract.id != null&& operateContract != 'change'" v-model="contract.trackByPhase">
                            <el-radio :label="false"><span>否</span></el-radio>
                            <el-radio :label="true"><span>是</span></el-radio>
                        </el-radio-group>
                    </div>
                </div>
            </div>
        </div>
        <template v-if="contractType == goodsPurch.value && phasedPaymentAllowed">
            <div class="content-caption dashed">
                <span>付款阶段</span>
            </div>
            <div class="simple-form label">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">付款账期形式</label>
                    </div>
                    <div class="form-value width-3x">
                        <el-radio-group :disabled="operateContract == 'chakan'" v-model="contract.acntPeriodForm" @change="acntPeriodFormChange">
                            <el-radio :label="2" v-if="payPeriodTypesAllowed.indexOf(2) > -1"><span>阶段间隔天数</span></el-radio>
                            <el-radio :label="1" v-if="payPeriodTypesAllowed.indexOf(1) > -1"><span>账期</span></el-radio>
                        </el-radio-group>
                    </div>
                </div>
            </div>
            <el-form :model="contract" ref="contractPhasedPaySettingList">
                <table class="custom-tbl error-prompt">
                    <thead class="head">
                    <tr class="row">
                        <th class="text-align: left; required">阶段名称</th>
                        <th width="200" class="text-align: left; required">阶段类型</th>
                        <th width="200" class="text-align: right; required">账期起算规则</th>
                        <th width="100" class="text-align: right; required" v-if="contract.acntPeriodForm == 1">账期(天)</th>
                        <th width="140" class="text-align: right; required" v-if="contract.acntPeriodForm == 2">当期阶段间隔天数</th>
                        <th width="200" class="text-align: left; required">金额计算依据</th>
                        <th width="120" class="text-align: left; required">付款比例(%)</th>
                        <th width="150" class="text-align: right; required">支付方式</th>
                        <th width="100">操作</th>
                    </tr>
                    </thead>
                    <tbody class="body">
                    <tr v-for="(item,index) in contract.contractPhasedPaySettingList" class="row">
                        <td :rowspan="item.rowspanNum" v-if="item.showPhaseNameAndPhaseType">
                            <el-form-item :prop="'contractPhasedPaySettingList.' + index + '.phaseName'" :rules="{validator: checkNull, trigger: 'blur'}">
                                <el-input class="fl" style="width: 80%;" type="text" v-model="item.phaseName" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" @blur="phaseNameChange(index)"></el-input>
                                <a class="swb-btn-link fr inline-block" @click="addPaySetting(item, index)" v-if="item.rowspanNum < payMethodList.length && (showBtn === true || !disabledBtn) && operateContract!='chakan'">增加付款次数</a>
                            </el-form-item>
                        </td>
                        <td :rowspan="item.rowspanNum" v-if="item.showPhaseNameAndPhaseType">
                            <el-form-item :prop="'contractPhasedPaySettingList.' + index + '.phaseType'" :rules="{validator: checkNull, trigger: 'change'}">
                                <el-select v-model="item.phaseType" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" @change="phaseTypeChange(index)">
                                    <el-option v-for="item in phaseTypeList" :key="item.value" :label="item.text" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </td>
                        <td :rowspan="item.rowspanNum" v-if="item.showPhaseNameAndPhaseType"><!-- 账期起算规则 acntPeriodBasis -->
                            <el-form-item :prop="'contractPhasedPaySettingList.' + index + '.acntPeriodBasis'" :rules="{validator: checkNull, trigger: 'change'}">
                                <el-select v-model="item.acntPeriodBasis" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" @change="acntPeriodBasisChange(index)">
                                    <el-option v-for="item in acntPeriodStartTPList" :key="item.value" :label="item.text" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </td>
                        <td class="text-right" :rowspan="item.rowspanNum" v-if="contract.acntPeriodForm == 1 && item.showPhaseNameAndPhaseType"><!-- 账期(天) acntPeriodDays -->
                            <el-form-item :prop="'contractPhasedPaySettingList.' + index + '.acntPeriodDays'" :rules="{validator: checkNull, trigger: 'blur'}">
                                <el-input type="number" :min="0" v-model="item.acntPeriodDays" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" @blur="acntPeriodDaysChange(index)"></el-input>
                            </el-form-item>
                        </td>
                        <td class="text-right" :rowspan="item.rowspanNum" v-if="contract.acntPeriodForm == 2 && item.showPhaseNameAndPhaseType"> <!-- 当期阶段间隔天数 phaseGapDays -->
                            <el-form-item :prop="'contractPhasedPaySettingList.' + index + '.phaseGapDays'" :rules="{validator: checkNull, trigger: 'blur'}">
                                <el-input type="number" :min="0" v-model.number="item.phaseGapDays" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" @blur="phaseGapDaysChange(index)"></el-input>
                            </el-form-item>
                        </td>
                        <td><!-- 金额计算依据 calcBasis -->
                            <el-form-item :prop="'contractPhasedPaySettingList.' + index + '.calcBasis'" :rules="{validator: checkNull, trigger: 'change'}">
                                <el-select v-model="item.calcBasis" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'">
                                    <el-option v-for="item in amtCalcMethodList" :key="item.value" :label="item.text" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </td>
                        <td class="text-right">
                            <el-form-item :prop="'contractPhasedPaySettingList.' + index + '.ratio'" :rules="{validator: checkNull, trigger: 'blur'}">
                                <el-input v-model="item.ratio" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" @blur="ratioChange(index)"></el-input>
                            </el-form-item>
                        </td>
                        <td><!-- 支付方式 payMethod -->
                            <el-form-item :prop="'contractPhasedPaySettingList.' + index + '.payMethod'" :rules="{validator: checkNull, trigger: 'change'}">
                                <el-select v-model="item.payMethod" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" @change="payMethodChange(index)">
                                    <el-option v-for="item in payMethodList" :key="item.value" :label="item.text" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </td>
                        <td>
                            <div @click="removeContractPhasedPaySetting(index);" class="swb-btn swb-btn-link" v-if="showSave || operateContract == 'change'">
                                <span>移除</span>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                    <tfoot class="foot">
                    <tr class="row">
                        <td colspan="8" style="padding: 10px; border: 1px solid #dfe6ec; text-align: center;"
                            v-if="(showBtn === true || !disabledBtn) && operateContract!='chakan'">
                            <div @click="addContractPhasedPaySetting();" class="swb-btn swb-btn-link">
                                <i class="icon iconfont icon-jiahao mr5"></i>
                                <span>添加阶段</span>
                            </div>
                        </td>
                    </tr>
                    </tfoot>
                </table>
            </el-form>
        </template>

        <div class="content-caption dashed">
            <span>附件信息</span>
        </div>
        <div class="simple-form label">
            <div class="form-group center">
                <div class="form-value" v-if="showUpload || (contract.contractFileList !=null && contract.contractFileList.length > 0)">
                    <swb-save-file :showDelete="showSave" :files="contract.contractFileList" ref="swb_contract_file"></swb-save-file>
                </div>
            </div>
        </div>

        <template v-if="contractType != servcPurch.value">
            <div class="content-caption dashed">
                <span>费用信息</span>
            </div>
            <div class="table-layout">
                <button class="swb-btn swb-btn-mini mr10 mb10 fr" v-if="operateContract!='chakan'" @click="saveContractFeeItem()">新增</button>
                <el-table ref="multipleTable" :data="contract.contractFeeItemList" border tooltip-effect="dark" style="width: 100%">
                    <el-table-column align="left" prop="feeType" label="费用类型">
                        <template slot-scope="rows">
                            <span>{{ purchFeeTypeMap[rows.row.feeType] }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" prop="name" label="名称"></el-table-column>
                    <el-table-column align="left" prop="brandName" label="品牌"></el-table-column>
                    <el-table-column align="left" prop="modelSpec" label="规格"></el-table-column>
                    <el-table-column align="left" prop="unit" label="单位"></el-table-column>
                    <el-table-column align="left" prop="price" label="单价(元)"></el-table-column>
                    <el-table-column class="fixed" align="left" width="400px" label="操作" show-overflow-tooltip v-if="operateContract!='chakan'">
                        <template slot-scope="scope">
                            <a class="swb-btn-link" @click="saveContractFeeItem(scope.row, scope.$index)">编辑</a>
                            <a class="swb-btn-link" @click="removeContractFeeItem(scope.$index)">删除</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </template>

        <template v-if="contract.termsFlag">
            <div class="content-caption dashed">
                <span>条款信息</span>
            </div>
            <swb-create-trade-rule :comparedTradeRuleList="comparedTradeRuleList" :type="tradeType" :operate="tradeOperate" :forBid="forBid" :forContract="forContract" :forGoods="forGoods" :forServc="forServc" :forPriceInqry="forPriceInqry"
                                   ref="swb_create_trade_rule"></swb-create-trade-rule>
        </template>
        <div class="form-toolbar">
            <button v-if="operateContract != 'chakan'" class="swb-btn swb-btn-small swb-btn-primary mr10" @click="prevContract">返回</button>
            <button v-if="showSave && operateContract == 'change'" class="swb-btn swb-btn-small" @click="registerContract">变更</button>
            <button v-if="!contract.closed && operateContract != 'change' && operateContract != 'chakan'" class="swb-btn swb-btn-small" @click="registerContract">
                <span>保存</span>
            </button>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {MsgBox, Routes, Vue} from '../../app.vues'
    import appConf from '../../app.conf';
    import {checkUserActionPerm} from '../index'

    import {openServicerSelectComnDlg} from '../servicer/selectDlg'
    import {openContractGoodsAreaPriceDlg,openContractServcOrgSpecListDlg} from './dialog'
    import {openBizFormSelectionDlg} from '../bizForm/selectDlg'
    import {openDevcDefSaveDlg, showMerchtDevcDefSelectDlg} from '../devcDef/showDlg'
    import {openAccDefSaveDlg, showAsmblAccDefSelectDlg} from '../asmblAcc/dialog'
    import {getMerchantBizParam, getRealCtrlParam} from '../asset/assetMain'
    import {showPayVoucherListForSelectDlg} from '../payment/ActRecDlg'
    import {goodsInSelectDlg} from '../retailer/dialog'
    import {openRetailerComListForSelectDlg} from '../retailer/selectDlg'
    import {openSkuListSelectDlg} from '../goods/selectDlg';
    import {realSignDetailDlg, realSignGroupListSelectDlg, selectMerchantRealComDlg, selectRealAdoptedComDlg} from '../realCom/dialog'
    import {selectInvoiceSubjectDlg} from '../invoiceVoucher/selectDlg'
    import {showDevcBrandSelectDlg, showDevcGroupCatSelectDlg, showDevcGroupPartSelectDlg, showDevcGroupSelectDlg} from '../categ/selectDlg'
    import {openComnSvcRequireListForSelectDlg} from '../shopComnReq/dialog'
    import {fileUploadGroupShowDlg} from '../comn/dialog'
    import {showRouteLayer} from '../ctrl/RouteLayer'

    import merchtFinacApi from '../../api/merchtFinac'
    import userApi from '../../api/user'
    import contractApi from '../../api/contract'
    import tendBidApi from '../../api/tendBid'
    import priceApi from '../../api/price'
    import merchtComnApi from '../../api/merchtComn'
    import vendorApi from '../../api/vendor';
    import servicerApi from '../../api/servicer';
    import merchtQualiApi from '../../api/merchtQuali'
    import devcReqrApi from '../../api/devcReqr'
    import fiscalBizApi from '../../api/fiscalBiz'
    import devcDefApi from '../../api/devcDef'
    import asmblAccApi from '../../api/asmblAcc'
    import servcClaimApi from '../../api/servcClaim'

    import SwbFileUpload from '../ctrl/FileUpload';
    import SwbVendorListForSelect from '../vendor/VendorListForSelect';
    import SwbServicerForSelectList from '../servicer/ServicerForSelectList';
    import SwbMsuListForSelect from '../servc/MsuListForSelect';
    import SwbSaveFile from './SaveFile';
    import SwbCreateTradeRule from '../tradeRule/CreateTradeRule';
    import SwbCallBidDocForSelect from '../callbid/CallBidDocForSelect';
    import SwbContractTrackPhase from './ContractTrackPhase';
    import SwbContractDataMonitoring from './ContractDataMonitoring';
    import SwbContractRecordList from './ContractRecordList';
    import SwbPriceReplyForSelect from '../priceInpry/PriceReplyForSelect';
    import SwbRetailerComListForSelect from '../retailer/RetailerComListForSelect';
    import SwbPropEditor from '../ctrl/PropEditor';
    import SwbGoodsPurchContractList from './GoodsPurchContractList';
    import SwbServcPurchContractList from './ServcPurchContractList';
    import SwbIntegPurchContractList from './IntegPurchContractList';
    import SwbPayVoucherList from '../payment/PayVoucherList';

    Vue.regist(SwbFileUpload);

    Vue.regist(SwbVendorListForSelect);

    Vue.regist(SwbServicerForSelectList);

    Vue.regist(SwbMsuListForSelect);

    Vue.regist(SwbSaveFile);

    Vue.regist(SwbCreateTradeRule);

    Vue.regist(SwbCallBidDocForSelect);

    Vue.regist(SwbContractTrackPhase);

    Vue.regist(SwbContractDataMonitoring);

    Vue.regist(SwbContractRecordList);

    Vue.regist(SwbPriceReplyForSelect);

    Vue.regist(SwbRetailerComListForSelect);

    Vue.regist(SwbPropEditor);

    Routes.add(SwbGoodsPurchContractList);

    Routes.add(SwbServcPurchContractList);

    Routes.add(SwbIntegPurchContractList);

    Routes.add(SwbPayVoucherList);

    export default {
        name: 'swb-register-comn-contract',
        desc: '甲方登记合同',
        props: ['contractId', 'operate', 'contractType', 'selectRealComId', 'merchant', 'onlyView'],
        watch: {
            'contract.taxRate'(newVal, oldVal) {
                this.contract.taxRate = this.filterListValue(this.fiscalTaxMarkList, newVal)
            }
        },
        data: function () {
            let self = this;
            let checkTitle = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    if (value.length > 60) {
                        callback(new Error('合同名称不能超过60个字符!'));
                    } else {
                        callback();
                    }
                }
            };
            let checkSndPartyId = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            };
            let checkAccordHtBh = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            };
            let checkDateStart = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            };
            let checkDateEnd = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            };
            let checkSignDate = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            };
            let checkSrcId = function (rule, value, callback) {
                let srcFlag = self.contract.srcFlag;
                if (srcFlag != 0) {
                    if (Utils.isNoB(value)) {
                        callback(new Error('不能为空!'));
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }
            };
            let checkTaxRate = function (rule, value, callback) {
                self.validateTaxRate(rule, value, callback);
            };
            let checkDesireArriveDays = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback();
                } else if (parseInt(value) < 0) {
                    callback(new Error('请填写正确的天数!'));
                } else {
                    callback();
                }
            };
            return {
                contract: {
                    id: null,
                    kindId: 0, // 0,标准合同，1,框架合同
                    phaseFlag: true,// 是否有履约阶段
                    termsFlag: true,// 是否有条款项
                    originalNo: null,
                    typeId: null,
                    typeName: null,
                    srcFlag: 0,
                    offline: false,
                    fstPartyId: null,
                    fstPartyName: null,
                    signDate: null,
                    sndPartyId: null,
                    sndPartyName: null,
                    sndPartyType: null,
                    contractServcList: [],
                    contractServc2List: [],
                    contractDigest: {},
                    contractFileList: [],
                    dateStart: null,
                    dateEnd: null,
                    contractTermList: [],
                    invoiceType: null,
                    invoiceContentTag: null,
                    contractGoodsList: [],
                    estmtAmount: null,
                    estmtGoodsCount: null,
                    trackByPhase: true,
                    contractTrackPhaseList: [],
                    fstPartyConfirmed: false,
                    sndPartyConfirmed: false,
                    goodsFlag: false,
                    servcFlag: false,

                    acntPeriodForm: 2,
                    contractPhasedPaySettingList: [],

                    checkAuditState: 0,
                    checkApplyState: 0,
                    fulfillAuditState: 0,
                    fulfillApplyState: 0,
                    servcAmountFixed: false,
                    totalServcAmount: null,

                    srcId: null,
                    fstPartyFlag: null,
                    proxied: false,
                    settleCrossOrderAllowed: false,
                    contractAppliedShopList: [],
                    settleAutoFlag: false,
                    settlePeriodDay: 1,
                    settleInvolvedFeeTypeIds: [1],  // 默认选择服务费
                    //
                    useAccAuditRule: false,
                    sglAccAuditEnabled: false,
                    sglAccAmntLimit: 0.00,
                    sumAccAuditEnabled: false,
                    sumAccAmntLimit: 0.00
                },
                accAuditRuleList: [{text: '不需审批', value: false}, {text: '需要审批', value: true}],
                showBtn: false,
                showSave: true,
                comparedTradeRuleList: [],
                tradeType: null,
                tradeOperate: null,
                disabled: false,
                showUpload: false,
                disabledBtn: false,
                showAmtAndCot: true,
                invoiceTypeList: [],
                invoiceContentTagList: [],
                prevChangeContract: {},
                tradeVoucher: {},
                phaseTypeList: getEnumList('payPhaseType') || [],
                payPhaseTypeFinalPayment: getEnumInfoWith('payPhaseType', 'name', 'FinalPayment').value,
                amtCalcMethodList: [],
                acntPeriodStartTPList: getEnumList('acntPeriodStartTP') || [],
                payMethodList: getEnumList('payMethod') || [],
                servcTypeList: getEnumList('servcType') || [],
                timesLimitTypeList: getEnumList('timesLimitType') || [],
                contractRules: {
                    title: [{validator: checkTitle, trigger: 'blur'}],
                    sndPartyId: [{validator: checkSndPartyId, trigger: 'change'}],
                    accordHtBh: [{validator: checkAccordHtBh, trigger: 'change'}],
                    dateStart: [{validator: checkDateStart, trigger: 'change'}],
                    dateEnd: [{validator: checkDateEnd, trigger: 'change'}],
                    signDate: [{validator: checkSignDate, trigger: 'change'}],
                    srcId: [{validator: checkSrcId, trigger: 'change'}],
                    taxRate: [{validator: checkTaxRate, trigger: 'blur'}],
                    desireArriveDays: [{validator: checkDesireArriveDays, trigger: 'blur'}]
                },
                goodsPurch: {},
                servcPurch: {},
                integPurch: {},
                bizSrcFlagList: [],
                //交易规则查询条件
                forBid: null,
                forContract: true,
                forGoods: null,
                forServc: null,
                forPriceInqry: null,

                goodsAmount: 0,
                servcAmount: 0,

                flag: false,
                operateContract: null,
                //
                path: null,
                isLegacyContract: false,
                fiscalTaxMarkList: [],
                normalFlag: false,
                purchFeeTypeMap: getEnumMap('purchFeeType', 'value2text'),
                showAssetInfo: false,
                retailerType: getEnumInfoWith('merchantType', 'name', 'Retailer').value,
                workFeeTypeList: [],
                scopeEntity: {},
                needAudit: false,
                //
                warnContractServcFlag: false,   // 存在相同的设备维保合同服务，仅提示，不拦截
                warnContractServc2Flag: false,   // 存在相同的常规合同服务，仅提示，不拦截
                multipleSelection: [],
                phasedPaymentAllowed: true,
                payPeriodTypesAllowed: [1]
            }
        },
        created: function () {
            let self = this;
            this.operateContract = this.operate;
            this.goodsPurch = getEnumInfoWith('contractType', 'name', 'GoodsPurch');
            this.servcPurch = getEnumInfoWith('contractType', 'name', 'ServcPurch');
            this.integPurch = getEnumInfoWith('contractType', 'name', 'IntegPurch');
            this.bizSrcFlagList = getEnumList('bizSrcFlag');
            let workFeeTypeList = getEnumList('servcFeeType');
            let newWorkFeeTypeList = [];
            for (let i = 0; i < workFeeTypeList.length; i++) {
                let workFeeType = workFeeTypeList[i];
                if (workFeeType.value != 3 && workFeeType.value != 9) {
                    newWorkFeeTypeList.push(workFeeType);
                }
            }
            this.workFeeTypeList = Utils.merge([], newWorkFeeTypeList);
            // 金额计算依据
            let amtCalcMethodList = [];
            let amtCalcMethods = getEnumList('amtCalcMethod') || [];
            let amtCalcMethodByAmount = getEnumInfoWith('amtCalcMethod', 'name', 'ByAmount');
            for (let i = 0; i < amtCalcMethods.length; i++) {
                let amtCalcMethod = amtCalcMethods[i];
                if (amtCalcMethod.name != amtCalcMethodByAmount.name) {
                    amtCalcMethodList.push(amtCalcMethod);
                }
            }
            this.amtCalcMethodList = Utils.merge([], amtCalcMethodList);
            //
            if (this.contractType == this.goodsPurch.value) {
                this.forGoods = true;
            } else if (this.contractType == this.servcPurch.value) {
                this.forServc = true;
            } else if (this.contractType == this.integPurch.value) {
                this.forServc = true;
                this.forGoods = true;
            }
            this.getFiscalTaxMarkList();
            let contractId = this.contractId;
            if (!Utils.isNoB(contractId)) {
                this.getContractById(contractId, function (result) {
                    self.getCurrentUserInfo();
                });
                let operation = this.operateContract;
                this.tradeOperate = operation;
                if (operation == 'chakan') {
                    this.showSave = false;
                    this.showBtn = false;
                } else {
                    this.showSave = true;
                    this.showBtn = true;
                }
            } else {
                this.getContractTypeList();
                this.showUpload = true;
                this.getCurrentUserInfo();
            }
            getMerchantBizParam('display.asset.related.info.in.trading', function (result) {
                self.showAssetInfo = Utils.isTrue(result);
            });
            getMerchantBizParam('asset.definition.create.alter.need.audit', function (result) {  // 新增/变更资产定义是否需要审核
                self.needAudit = Utils.isTrue(result);
            }, 0);
            getRealCtrlParam('contract.settle.phased.payment.allowed', function (result) {
                self.phasedPaymentAllowed = Utils.isTrue(result);
            });
            getRealCtrlParam('contract.allowed.pay.period.types', function (result) {
                self.payPeriodTypesAllowed = result;
                if (Utils.isNoB(contractId) && self.payPeriodTypesAllowed.indexOf(2) == -1) {
                    self.contract.acntPeriodForm = self.payPeriodTypesAllowed[0];
                }
            });
            // 设置需要拦截的路径
            let contractType = this.contractType;
            if (contractType == 1) {
                // 设备采购合同
                this.path = SwbGoodsPurchContractList.path;
            } else if (contractType == 2) {
                // 服务采购合同
                this.path = SwbServcPurchContractList.path;
            } else if (contractType == 3) {
                // 集成合同
                this.path = SwbIntegPurchContractList.path;
            }
            // 发票类型
            let invoiceTypeList = getEnumList('invoiceType');
            for (let i = 0; i < invoiceTypeList.length; i++) {
                let invoiceType = invoiceTypeList[i];
                if (invoiceType.value == 0 || invoiceType.value == 3) {
                    invoiceTypeList.splice(i, 1);
                    i--;
                }
            }
            this.invoiceTypeList = Utils.merge([], invoiceTypeList);
            //
            this.checkLegacyContract();
        },
        methods: {
            filterListValue(listItems, listVal) {
                if (this.operateContract == 'chakan') {
                    return listVal;
                }
                let listValues = listItems.pluck('rate')
                let reval = listValues.indexOf(listVal) == -1 ? null : listVal;
                return reval;
            },
            prevContract: function () {
                let self = this;
                self.$router.back(-1);
            },
            getFiscalTaxMarkList: function () {
                let self = this;
                let postData = {};
                postData.disabled = false;
                postData.type = getEnumInfoWith('taxType', 'name', 'JXS').value;
                if (this.contractType == this.goodsPurch.value) {
                    postData.sysBizLineId = 1;  // 资产税码
                } else if (this.contractType == this.servcPurch.value) {
                    postData.sysBizLineId = 2;  // 服务税码
                } else if (this.contractType == this.integPurch.value) {
                    // TODO 无集成合同，暂不处理
                }
                let theLoad = MsgBox.loading();
                fiscalBizApi.getSyncFiscalTaxMarkPageList(postData, function (result) {
                    theLoad.hide();
                    if (result.type === 'info') {
                        let fiscalTaxMarkList = result.data || [];
                        if (fiscalTaxMarkList.length > 0) {
                            fiscalTaxMarkList.forEach(function (item) {
                                item.rate = parseFloat(item.rate).toFixed(2)
                            })
                        }
                        self.fiscalTaxMarkList = fiscalTaxMarkList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 检查是否是老合同
            checkLegacyContract: function () {
                let self = this;
                contractApi.checkLegacyContract(function (result) {
                    if (result.type == 'info') {
                        self.isLegacyContract = result.data;
                    } else {
                        console.warn(result.message);
                    }
                });
            },
            // 设置合同适用范围
            selectSignGroup: function () {
                let self = this;
                let contract = self.contract || {};
                if (Utils.isNoB(contract.fstPartyRealComId) || contract.fstPartyRealComId <= 0) {
                    MsgBox.warning('请选择买方公司！');
                    return;
                }
                let signGroupId = contract.signGroupId;
                let signGroupIds = [];
                if (!Utils.isNoB(signGroupId) && signGroupId > 0) {
                    signGroupIds.push(signGroupId);
                }
                let params = {
                    realComId: contract.fstPartyRealComId,
                    checkedIds: signGroupIds
                };
                realSignGroupListSelectDlg(params, function (signGroup, theDlg) {
                    // 适用范围发生变化，清空适用机构
                    if (self.contractType == self.servcPurch.value && signGroupId != signGroup.id) {
                        contract.contractAppliedShopList = [];
                        // 清空适用机构对应的特定门店价格信息
                        let contractServcList = contract.contractServcList || [];
                        if (contractServcList.length > 0) {
                            for (let i = 0; i < contractServcList.length; i++) {
                                let contractServc = contractServcList[i];
                                contractServc.servcOrgSpecList = [];
                            }
                        }
                        let contractServc2List = contract.contractServc2List || [];
                        if (contractServc2List.length > 0) {
                            for (let i = 0; i < contractServc2List.length; i++) {
                                let contractServc = contractServc2List[i];
                                contractServc.servcOrgSpecList = [];
                            }
                        }
                    }
                    contract.signGroupId = signGroup.id;
                    contract.signGroupName = signGroup.name;
                    self.contract = Utils.merge({}, contract);
                });
            },
            // 查看合同适用范围
            viewSignGroup: function (signGroupId) {
                if (!Utils.isNoB(signGroupId) && signGroupId > 0) {
                    realSignDetailDlg(signGroupId);
                }
            },
            checkTime: function () {
                let self = this;
                let contract = self.contract;
                if (!Utils.isNoB(contract.dateStart) && !Utils.isNoB(contract.dateEnd)) {
                    // 判断时间大小
                    let dateStart = contract.dateStart.format('yyyy-MM-dd');
                    let dateEnd = contract.dateEnd.format('yyyy-MM-dd');
                    if (dateStart >= dateEnd) {
                        MsgBox.warning('请输入有效的合同开始结束时间');
                        return false;
                    }
                }
            },
            checkActionPerm: function (action) {
                return checkUserActionPerm(this.path, action, null);
            },
            editable: function () {
                this.operateContract = 'edit';
                // this.contract.dirty = true;
                this.tradeOperate = null;
                if (this.contract.srcWinId != null || this.contract.srcWinId != null) {
                    this.disabledBtn = true;
                } else {
                    this.disabledBtn = false;
                }
                this.showSave = true;
                this.showBtn = true;
            },
            inputQuantity: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('请输入商品数量'));
                } else {
                    if (!Utils.isNumber(value) || value <= 0) {
                        callback(new Error('请输入大于0的数'));
                    } else {
                        callback();
                    }
                }
            },
            inputWrntPeriod: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('请输入质保期'));
                } else {
                    if (!Utils.isNumber(value) || value < 0) {
                        callback(new Error('请输入整数'));
                    } else {
                        callback();
                    }
                }
            },
            checkDateStart: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            },
            checkDateEnd: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            },
            changeSignDate: function () {
                let self = this;
                let signDate = self.contract.signDate;
                let dueDate = new Date(signDate);
                let contractTrackPhaseList = self.contract.contractTrackPhaseList;
                if (contractTrackPhaseList.length > 0) {
                    for (let i = 0; i < contractTrackPhaseList.length; i++) {
                        let absDate = contractTrackPhaseList[i].absDate;
                        if (!absDate) {
                            contractTrackPhaseList[i].dueDate = dueDate.addDays(contractTrackPhaseList[i].incrDays).format('yyyy-MM-dd');
                        }
                    }
                }
                self.contract.contractTrackPhaseList = Utils.merge([], contractTrackPhaseList);
            },
            // 含税金额
            goodsAmountOrQuantityChange: function (item, index, changeFlag) {
                let self = this;
                let goodsAmount = 0;
                let estmtGoodsCount = 0;
                let contractGoodsList = self.contract.contractGoodsList;
                for (let i = 0; i < contractGoodsList.length; i++) {
                    let quantity = contractGoodsList[i].quantity;
                    let price = contractGoodsList[i].price;
                    if (i == index && changeFlag == 'quantity') {
                        if (Utils.isNoB(quantity)) {
                            MsgBox.warning('请输入商品数量！');
                        } else if (!Utils.isInt(quantity) || quantity < 0) {
                            MsgBox.warning('只能输入大于0的整数！');
                            quantity = null;
                        } else {
                            contractGoodsList[i].amount = ((Utils.isNoB(price) ? 0 : parseFloat(price)) * parseInt(quantity)).toFixed(2);
                        }
                    }
                    if (i == index && changeFlag == 'price') {
                        if (Utils.isNoB(price)) {
                            MsgBox.warning('请输入金额！');
                            price = null;
                        } else if (!Utils.isMoneyStr(price)) {
                            MsgBox.warning('请输入正确的金额！');
                            price = null;
                        }
                        // 未税价格
                        if (!Utils.isNoB(price)) {
                            let taxRate = contractGoodsList[i].taxRate || 0;
                            contractGoodsList[i].ntxPrice = (parseFloat(price) / (1 + (parseFloat(taxRate) * 0.01))).toFixed(2);
                            contractGoodsList[i].amount = ((Utils.isNoB(quantity) ? 0 : parseInt(quantity)) * parseFloat(price)).toFixed(2);
                        } else {
                            contractGoodsList[i].ntxPrice = null;
                        }
                    }
                    if (!Utils.isNoB(quantity)) {
                        estmtGoodsCount += quantity;
                    }
                    if (!Utils.isNoB(price) && !Utils.isNoB(quantity)) {
                        let amount = contractGoodsList[i].amount;
                        if (!Utils.isNoB(amount)) {
                            goodsAmount += parseFloat(amount);
                        }
                    }
                    contractGoodsList[i].quantity = quantity;
                    contractGoodsList[i].price = Utils.isNoB(price) ? null : parseFloat(price).toFixed(2);
                    contractGoodsList[i].amount = Utils.isNoB(contractGoodsList[i].amount) ? 0.00 : parseFloat(contractGoodsList[i].amount).toFixed(2);
                }
                //
                self.contract.contractGoodsList = Utils.merge([], contractGoodsList);
                //
                self.goodsAmount = goodsAmount.toFixed(2);
                self.contract.estmtAmount = ParseFloat(self.goodsAmount) + ParseFloat(self.servcAmount);
                self.contract.estmtGoodsCount = estmtGoodsCount;
            },
            // 税率校验
            validateTaxRate: function (rule, value, callback) {
                if (Utils.isTrue(this.normalFlag)) {
                    if (Utils.isNoB(value)) {
                        callback(new Error('请输入税率，大于等于0的数！'));
                    } else {
                        if (!Utils.isMoneyStr(value)) {
                            callback(new Error('请输入正确的税率！'));
                        } else {
                            let taxRate = parseFloat(value);
                            if (taxRate > 100) {
                                callback(new Error('税率不能超过100！'));
                            } else {
                                callback();
                            }
                        }
                    }
                } else {
                    callback();
                }
            },
            // 税率变化事件
            taxRateChange: function (taxRate) {
                if (!Utils.isNoB(taxRate)) {
                    if (!Utils.isMoneyStr(taxRate)) {
                        taxRate = null;
                    } else {
                        let taxRateF = parseFloat(taxRate);
                        if (taxRateF > 100) {
                            taxRate = null;
                        } else {
                            taxRate = taxRateF.toFixed(2);
                        }
                    }
                }
                //
                let contract = this.contract || {};
                contract.taxRate = taxRate;
                let contractGoodsList = contract.contractGoodsList || [];
                for (let i = 0; i < contractGoodsList.length; i++) {
                    let item = contractGoodsList[i];
                    //
                    item.taxRate = taxRate;
                    if (Utils.isNoB(taxRate) || Utils.isNoB(item.price)) {
                        item.ntxPrice = item.price;
                    } else {
                        item.ntxPrice = (parseFloat(item.price) / (1 + (parseFloat(taxRate) * 0.01))).toFixed(2);
                    }
                }
                contract.contractGoodsList = Utils.merge([], contractGoodsList);
                this.contract = Utils.merge({}, contract);
            },
            selectRateChange: function () {
                let self = this;
                openSwbFiscalTaxMarkListForSelectDlg(function (result) {
                    let fiscalTaxMark = result;
                    self.taxRateChange(fiscalTaxMark.rate);
                })
            },
            // 计算服务价格
            servcAmountOrQuantityChange: function () {
                let self = this;
                let servcAmount = 0;
                let contract = self.contract || {};
                // 常规服务请求
                let contractServc2List = contract.contractServc2List || [];
                for (let i = 0; i < contractServc2List.length; i++) {
                    let amount = contractServc2List[i].amount || 0;
                    servcAmount += parseFloat(amount);
                }
                // 设备维保服务
                let contractServcList = contract.contractServcList || [];
                for (let i = 0; i < contractServcList.length; i++) {
                    let amount = contractServcList[i].amount || 0;
                    servcAmount += parseFloat(amount);
                }
                //
                self.servcAmount = servcAmount.toFixed(2);
                self.contract.estmtAmount = (parseFloat(self.servcAmount || 0) + parseFloat(self.goodsAmount || 0)).toFixed(2);
            },
            setGoodsAndServcAmount() {
                let self = this;
                //
                let goodsAmount = 0;
                let contractGoodsList = self.contract.contractGoodsList;
                for (let i = 0; i < contractGoodsList.length; i++) {
                    let quantity = contractGoodsList[i].quantity;
                    let price = contractGoodsList[i].price;
                    if (!Utils.isNoB(quantity)) {
                        if (!Utils.isInt(quantity) || quantity < 0) {
                            return;
                        }
                    }
                    if (!Utils.isNoB(price) && !Utils.isNoB(quantity)) {
                        goodsAmount += quantity * price;
                    }
                }
                self.goodsAmount = goodsAmount.toFixed(2);
                //
                let servcAmount = 0;
                // 设备维保服务
                let contractServcList = self.contract.contractServcList || [];
                if (contractServcList.length > 0) {
                    for (let i = 0; i < contractServcList.length; i++) {
                        let contractServc = contractServcList[i];
                        let quantity = contractServc.quantity || 0;
                        let price = contractServc.price || 0;
                        let toDoorFee = contractServc.toDoorFee || 0;
                        let amount = contractServc.amount || 0;
                        //
                        servcAmount += parseInt(quantity) * parseFloat(amount);
                        contractServc.toDoorFee = parseFloat(toDoorFee).toFixed(2);
                        contractServc.price = parseFloat(price).toFixed(2);
                        contractServc.amount = parseFloat(amount).toFixed(2);
                    }
                    self.contract.contractServcList = Utils.merge([], contractServcList);
                }
                // 常规服务请求
                let contractServc2List = self.contract.contractServc2List || [];
                if (contractServc2List.length > 0) {
                    for (let i = 0; i < contractServc2List.length; i++) {
                        let contractServc = contractServc2List[i];
                        let quantity = contractServc.quantity || 0;
                        let price = contractServc.price || 0;
                        let toDoorFee = contractServc.toDoorFee || 0;
                        let amount = contractServc.amount || 0;
                        //
                        servcAmount += parseInt(quantity) * parseFloat(amount);
                        contractServc.toDoorFee = parseFloat(toDoorFee).toFixed(2);
                        contractServc.price = parseFloat(price).toFixed(2);
                        contractServc.amount = parseFloat(amount).toFixed(2);
                    }
                    self.contract.contractServc2List = Utils.merge([], contractServc2List);
                }
                self.servcAmount = parseFloat(servcAmount || 0).toFixed(2);
            },
            // 服务包死价
            servcAmountFixedChange() {
                let self = this;
                let servcAmountFixed = self.contract.servcAmountFixed;
                //
                let servcAmount = 0;
                if (servcAmountFixed) {
                    if (self.contract.totalServcAmount != null && self.contract.totalServcAmount != '') {
                        servcAmount = self.contract.totalServcAmount;
                    }
                } else {
                    self.contract.totalServcAmount = null;
                    // 设备维保服务
                    let contractServcList = self.contract.contractServcList || [];
                    if (contractServcList.length > 0) {
                        for (let i = 0; i < contractServcList.length; i++) {
                            let contractServc = contractServcList[i];
                            let amount = contractServc.amount || 0;
                            //
                            servcAmount += parseFloat(amount);
                        }
                    }
                    // 常规服务请求
                    let contractServc2List = self.contract.contractServc2List || [];
                    if (contractServc2List.length > 0) {
                        for (let i = 0; i < contractServc2List.length; i++) {
                            let contractServc = contractServc2List[i];
                            let amount = contractServc.amount || 0;
                            //
                            servcAmount += parseFloat(amount);
                        }
                    }
                }
                self.servcAmount = parseFloat(servcAmount || 0).toFixed(2);
                self.contract.estmtAmount = (parseFloat(self.servcAmount) + parseFloat(self.goodsAmount || 0)).toFixed(2);
            },
            // 设置包死价金额
            servcAmountChange: function () {
                let self = this;
                let estmtAmount = 0;
                if (!Utils.isNoB(self.contract.totalServcAmount)) {
                    estmtAmount = self.contract.totalServcAmount;
                } else {
                    self.contract.totalServcAmount = null;
                }
                self.servcAmount = parseFloat(estmtAmount || 0).toFixed(2);
                self.contract.estmtAmount = (parseFloat(self.goodsAmount || 0) + ParseFloat(self.servcAmount)).toFixed(2);
            },
            getInvoiceContentTagList: function (modifyFlag) {
                let self = this;
                let postData = {};
                postData.merchantRealId = self.contract.sndPartyRealId;
                postData.realComId = self.contract.sndPartyRealComId;
                if (self.contractType == self.goodsPurch.value) {
                    postData.merchantType = self.goodsPurch.sndPartyType;
                } else if (self.contractType == self.servcPurch.value) {
                    postData.merchantType = self.servcPurch.sndPartyType;
                } else if (self.contractType == self.integPurch.value) {
                    postData.merchantType = self.integPurch.sndPartyType;
                }
                merchtFinacApi.getMerchantInvoiceCtntTagList(postData, function (result) {
                    if (result.type == 'info') {
                        if (result.data != null && result.data.length > 0) {
                            self.invoiceContentTagList = result.data;
                        } else {
                            if (!Utils.isTrue(modifyFlag)) {
                                self.contract.invoiceContentTag = null;
                                self.invoiceContentTagList = [];
                                self.contract = Utils.merge({}, self.contract);
                            }
                        }
                    }
                });
            },
            checkInvoiceType: function (value) {
                this.contract.invoiceType = value;
                if (!Utils.isNoB(value) && !Utils.isNoB(this.contract.fstPartyRealComId)) {
                    this.getTaxOffSetVal(value);
                }
                //
                this.getMerchantInvoiceSubjectByOnly();
            },
            getTaxOffSetVal: function (invoiceType) {
                let self = this;
                let params = {
                    invoiceType: invoiceType,
                    realComId: self.contract.fstPartyRealComId
                };
                merchtComnApi.getTaxDeductible(params, function (result) {
                    if (result.type == 'info') {
                        let data = result.data;
                        //
                        let contract = self.contract || {};
                        contract.taxOffset = Utils.isTrue(data);
                        //
                        let contractGoodsList = contract.contractGoodsList || [];
                        let len = contractGoodsList.length;
                        if (len > 0) {
                            for (let i = 0; i < len; i++) {
                                let contractGoods = contractGoodsList[i];
                                contractGoods.taxOffset = contract.taxOffset;
                            }
                            contract.contractGoodsList = Utils.merge([], contractGoodsList);
                        }
                        //
                        self.contract = Utils.merge({}, contract);
                    }
                });
            },
            getMerchantInvoiceSubjectByOnly: function () {
                let self = this;
                let postData = {};
                postData.realComId = self.contract.fstPartyRealComId;
                postData.invoiceType = self.contract.invoiceType;
                merchtFinacApi.getMerchantInvoiceSubjectList(postData, function (result) {
                    if (result.type == 'info') {
                        let invoiceSubjectList = Utils.merge([], result.data);
                        if (invoiceSubjectList.length > 0) {
                            let invoiceSubjectInfo = null;
                            for (let i = 0; i < invoiceSubjectList.length; i++) {
                                if (Utils.isTrue(invoiceSubjectList[i].defaulted)) {
                                    invoiceSubjectInfo = invoiceSubjectList[i];
                                    break;
                                }
                            }
                            self.contract.invoiceTitle = invoiceSubjectInfo.invoiceTitle;
                            self.contract.taxPayerNo = invoiceSubjectInfo.taxPayerNo;
                            //self.contract.invoiceContentTag = data.invoiceContentTag;
                            self.contract = Utils.merge({}, self.contract);
                        } else {
                            self.contract.invoiceTitle = null;
                            self.contract.taxPayerNo = null;
                            //self.contract.invoiceContentTag = null;
                            self.contract = Utils.merge({}, self.contract);
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            checkinvoiceContentTag: function (name) {
                let self = this;
                self.contract.invoiceContentTag = name;
            },
            getCurrentUserInfo: function () {
                let self = this;
                let postData = {};
                userApi.getUserInfoByContext(postData, function (result) {
                    if (result.type == 'info') {
                        let scopeEntity = result.data.scopeEntity || {};
                        if (Utils.isNoB(self.contractId)) {
                            self.contract.fstPartyName = scopeEntity.name;
                            self.contract.fstPartyComId = scopeEntity.comId;
                            self.contract.fstPartyId = scopeEntity.id;
                            self.contract.fstPartyType = scopeEntity.type;
                        }
                        //
                        self.scopeEntity = Utils.merge({}, scopeEntity);
                        //
                        self.getRealCom();
                    }
                });
            },
            getRealCom() {
                let self = this;
                let postData = {};
                postData.id = this.selectRealComId || null;
                let theLoading = MsgBox.loading();
                merchtComnApi.getRealCom(postData, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        let realCom = result.data;
                        //
                        if (Utils.isNoB(self.contractId)) {
                            self.contract.fstPartyRealComId = realCom.id;
                            self.contract.fstPartyRealComName = realCom.name;
                            //
                            let contractType = self.contractType;
                            if (contractType == 1) {
                                // 设备采购合同
                                // 发票类型默认为 增值税-专用发票
                                self.checkInvoiceType(2);
                            } else if (contractType == 2) {
                                // 服务采购合同
                                // 发票类型默认为 增值税-普通发票
                                self.checkInvoiceType(1);
                            }
                        }
                        // 框架合同获取集团业务参数
                        if (!Utils.isNoB(self.contract) && self.contract.kindId == 1) {
                            getMerchantBizParam('finac.mgmt.enabled', function (result) {
                                self.normalFlag = Utils.isTrue(result);
                            }, 0);
                        } else {
                            // 标准合同获取对应的实体公司的业务参数
                            getMerchantBizParam('asset.finac.enabled', function (result) {
                                self.normalFlag = Utils.isTrue(result);
                            }, 2, null, realCom.id);
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getContractTypeList: function () {
                let self = this;
                if (self.contractType == self.goodsPurch.value) {
                    self.contract.typeId = self.goodsPurch.value;
                    self.contract.typeName = self.goodsPurch.text;
                } else if (self.contractType == self.servcPurch.value) {
                    self.contract.typeId = self.servcPurch.value;
                    self.contract.typeName = self.servcPurch.text;
                } else if (self.contractType == self.integPurch.value) {
                    self.contract.typeId = self.integPurch.value;
                    self.contract.typeName = self.integPurch.text;
                }
            },
            // 获取供方商户信息
            getVendor(realId, realComId, callback) {
                let postData = {};
                postData.pagination = {
                    pageSize: 1,
                    pageNumber: 1,
                };
                let filterItems = {};
                filterItems.realId = realId;
                filterItems.realComId = realComId;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = [];
                postData.sortItems = {};
                //
                let theLoad = MsgBox.loading();
                vendorApi.getMerchantDtoList(postData, function (result) {
                    theLoad.hide();
                    if (result.type == 'info') {
                        let rows = result.data.rows;
                        if (Utils.isNoB(rows) || rows.length == 0) {
                            MsgBox.warning('无法获取供应商');
                        } else {
                            callback(rows[0]);
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 获取服务商户信息
            getServicer(realId, realComId, callback) {
                let postData = {};
                postData.pagination = {
                    pageSize: 1,
                    pageNumber: 1,
                };
                let filterItems = {};
                filterItems.realId = realId;
                filterItems.realComId = realComId;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = [];
                postData.sortItems = {};
                //
                let theLoad = MsgBox.loading();
                servicerApi.getMerchantDtoList(postData, function (result) {
                    theLoad.hide();
                    if (result.type == 'info') {
                        let rows = result.data.rows;
                        if (Utils.isNoB(rows) || rows.length == 0) {
                            MsgBox.warning('无法获取供应商');
                        } else {
                            callback(rows[0]);
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //
            showMerchantDlg() {
                let self = this;
                let sndPartyId = self.contract.sndPartyId;  // 乙方id
                let params = {
                    initCheckedId: sndPartyId,
                    multiSelect: false,
                    showContract: true, // 合同
                    showOrder: true, // 订单
                    showAmbilateralBizRel: false, // 双方关联
                    showBizRel: true, // 备选
                    showAdverseBizRel: false, // 卖方关联，备选其他
                    showNoScoreBizRel: false, // 待入围
                    showShieldedBizRel: false, // 加黑
                    showAll: true // 全部
                };
                if (self.contractType == self.goodsPurch.value || self.contractType == self.servcPurch.value) {
                    let peerMerchantType = getEnumInfoWith('merchantType', 'name', 'Vendor').value;
                    if (self.contractType == self.servcPurch.value) {
                        peerMerchantType = getEnumInfoWith('merchantType', 'name', 'Servicer').value;
                    }
                    // 选择入选供方公司
                    selectRealAdoptedComDlg({
                        checkBox: false,
                        filter: {
                            peerMerchantType: peerMerchantType,
                            adoptedType: 1 // 准入类型：入选
                        }
                    }, function (realAdoptedCom, theDlg) {
                        theDlg.close();
                        realAdoptedCom = realAdoptedCom || {};
                        // 获取对应的供应商分管商户 sellerId sellerName
                        if (self.contractType == self.servcPurch.value) {
                            self.getServicer(realAdoptedCom.peerRealMerchantId, realAdoptedCom.peerRealComId, function (servicer) {
                                self.setSelectMerchtInfo(servicer);
                            });
                        } else {
                            self.getVendor(realAdoptedCom.peerRealMerchantId, realAdoptedCom.peerRealComId, function (vendor) {
                                self.setSelectMerchtInfo(vendor);
                            });
                        }
                    });

                } else {
                    // 选择服务商
                    openServicerSelectComnDlg(self, params, function (result) {
                        let resultData = result.checkedList;
                        self.setSelectMerchtInfo(resultData);
                    });
                }
            },
            setSelectMerchtInfo: function (object) {
                let self = this;
                //
                self.contract.sndPartyId = object.id;
                self.contract.sndPartyName = object.name;
                self.contract.sndPartyRealId = object.realId;
                self.contract.sndPartyRealComId = object.realComId;
                self.contract.sndPartyRealComName = object.realComName;
                if (self.contractType == self.goodsPurch.value) {
                    self.contract.sndPartyType = self.goodsPurch.sndPartyType;
                } else {
                    self.contract.sndPartyType = self.servcPurch.sndPartyType;
                }
                self.contract.srcId = null;
                self.contract.srcName = null;
                self.contract.srcWinId = null;
                self.forBid = null;
                self.contract.contractServcList = [];
                self.contract.contractGoodsList = [];
                self.showBtn = true;
                self.disabledBtn = false;
                self.getInvoiceContentTagList();
            },
            //
            removeGoods: function (index) {
                let self = this;
                let contractGoodsList = self.contract.contractGoodsList;
                for (let i = 0; i < contractGoodsList.length; i++) {
                    if (i == index) {
                        contractGoodsList.remove(contractGoodsList[i]);
                    }
                }
                self.contract.contractGoodsList = Utils.merge([], contractGoodsList);
                //
                self.goodsAmountOrQuantityChange();
            },
            // 设置经营区域价格
            bizAreaOption: function (row, index) {
                let self = this;
                let params = {
                    operateContract: self.operateContract,
                    disabled: self.disabled,
                    taxRate: self.contract.taxRate,
                    areaPrices: row.contractGoodsAreaPrices || [],
                    bizFormNameList: row.bizFormNameList || [],
                    kindId: self.contract.kindId,
                    price: row.price
                };
                if (self.operateContract == 'chakan') {
                    params.contractGoodsItemId = row.id;
                }
                openContractGoodsAreaPriceDlg(params, function (areaPriceList, theDlg) {
                    theDlg.close();
                    areaPriceList = areaPriceList || [];
                    row.contractGoodsAreaPrices = areaPriceList;
                    if (self.contract.kindId != null && self.contract.kindId == 0) {
                        let quantity = 0;
                        let amount = 0;
                        for (let i = 0; i < areaPriceList.length; i++) {
                            let areaPrice = areaPriceList[i];
                            quantity = quantity + parseInt(areaPrice.quantity);
                            amount = amount + parseFloat(areaPrice.amount);
                        }
                        row.quantity = quantity;
                        row.amount = amount.toFixed(2);
                    }
                    //
                    let estmtGoodsCount = 0;
                    let goodsAmount = 0;
                    let contractGoodsList = self.contract.contractGoodsList || [];
                    for (let i = 0; i < contractGoodsList.length; i++) {
                        if (i == index) {
                            contractGoodsList[i] = row;
                        }
                        if (self.contract.kindId != null && self.contract.kindId == 0) {
                            estmtGoodsCount = estmtGoodsCount + parseInt(Utils.isNoB(contractGoodsList[i].quantity) ? 0 : contractGoodsList[i].quantity);
                            goodsAmount = goodsAmount + parseFloat(Utils.isNoB(contractGoodsList[i].amount) ? 0 : contractGoodsList[i].amount);
                        }
                    }
                    self.contract.contractGoodsList = Utils.merge([], contractGoodsList);
                    //
                    if (self.contract.kindId != null && self.contract.kindId == 0) {
                        self.goodsAmount = goodsAmount.toFixed(2);
                        self.contract.estmtAmount = ParseFloat(self.goodsAmount) + ParseFloat(self.servcAmount);
                        self.contract.estmtGoodsCount = estmtGoodsCount;
                    }
                });
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            // 批量设置经营业态
            setBizFormBatch: function () {
                let self = this;
                let multipleSelection = this.multipleSelection;
                if (multipleSelection == null || multipleSelection.length <= 0) {
                    MsgBox.warning('请选择要设置的数据');
                    return;
                }
                //
                let checkedIds = [];
                let params = {
                    checkedIds: checkedIds,
                    isShowSelection: true
                };
                openBizFormSelectionDlg(params, function (bizFormList, theDlg) {
                    //
                    bizFormList = bizFormList || [];
                    if (bizFormList.length > 5) {
                        MsgBox.warning('最多可设置5个经营业态！');
                        return;
                    }
                    theDlg.close();
                    let bizFormIds = '';
                    let bizFormNames = '';
                    for (let i = 0; i < bizFormList.length; i++) {
                        let bizForm = bizFormList[i];
                        if (bizFormIds.length <= 0) {
                            bizFormIds = '|' + bizForm.id + '|';
                            bizFormNames = '|' + bizForm.name + '|';
                        } else {
                            bizFormIds += bizForm.id + '|';
                            bizFormNames += bizForm.name + '|';
                        }
                    }
                    //
                    multipleSelection.forEach(function (item) {
                        item.bizFormIds = bizFormIds;
                        item.bizFormNames = bizFormNames;
                        if (!Utils.isNoB(bizFormNames)) {
                            let bizFormNameStr = bizFormNames;
                            let bizFormNameList = [];
                            if (!Utils.isNoB(bizFormNameStr)) {
                                if (bizFormNameStr.indexOf('|') >= 0) {
                                    bizFormNameStr = bizFormNameStr.substring(1, bizFormNameStr.length - 1);
                                    bizFormNameList = bizFormNameStr.split('|') || [];
                                }
                            }
                            item.bizFormNameList = bizFormNameList;
                        } else {
                            item.bizFormNameList = [];
                        }
                    });
                    self.contract = Utils.merge({}, self.contract);
                });
            },
            // 设置经营业态
            setBizForm: function (row, index) {
                let self = this;
                let bizFormIdStr = row.bizFormIds;
                let checkedIds = [];
                if (!Utils.isNoB(bizFormIdStr)) {
                    if (bizFormIdStr.indexOf('|') >= 0) {
                        bizFormIdStr = bizFormIdStr.substring(1, bizFormIdStr.length - 1);
                        checkedIds = bizFormIdStr.split('|') || [];
                    }
                }
                let params = {
                    checkedIds: checkedIds,
                    isShowSelection: true
                };
                openBizFormSelectionDlg(params, function (bizFormList, theDlg) {
                    //
                    bizFormList = bizFormList || [];
                    if (bizFormList.length > 5) {
                        MsgBox.warning('最多可设置5个经营业态！');
                        return;
                    }
                    theDlg.close();
                    let bizFormIds = '';
                    let bizFormNames = '';
                    for (let i = 0; i < bizFormList.length; i++) {
                        let bizForm = bizFormList[i];
                        if (bizFormIds.length <= 0) {
                            bizFormIds = '|' + bizForm.id + '|';
                            bizFormNames = '|' + bizForm.name + '|';
                        } else {
                            bizFormIds += bizForm.id + '|';
                            bizFormNames += bizForm.name + '|';
                        }
                    }
                    //
                    let contractGoodsList = self.contract.contractGoodsList || [];
                    for (let i = 0; i < contractGoodsList.length; i++) {
                        let contractGoods = contractGoodsList[i];
                        if (i == index) {
                            contractGoods.bizFormIds = bizFormIds;
                            contractGoods.bizFormNames = bizFormNames;
                            if (!Utils.isNoB(bizFormNames)) {
                                let bizFormNameList = [];
                                if (!Utils.isNoB(bizFormNames)) {
                                    if (bizFormNames.indexOf('|') >= 0) {
                                        bizFormNames = bizFormNames.substring(1, bizFormNames.length - 1);
                                        bizFormNameList = bizFormNames.split('|') || [];
                                    }
                                }
                                contractGoods.bizFormNameList = bizFormNameList;
                            } else {
                                contractGoods.bizFormNameList = [];
                            }
                        }
                    }
                    self.contract.contractGoodsList = Utils.merge([], contractGoodsList);
                });
            },
            //
            addAdoptedDevice: function (index) {
                let self = this;
                let contractGoods = {};
                let contract = self.contract;
                let contractGoodsList = self.contract.contractGoodsList;
                for (let i = 0; i < contractGoodsList.length; i++) {
                    if (i == index) {
                        contractGoods = contractGoodsList[i];
                    }
                }
                let bizFormList = [];
                let bizFormIds = contractGoods.bizFormIds;
                if (!Utils.isNoB(bizFormIds) && bizFormIds != '') {
                    bizFormIds = bizFormIds.substring(1, bizFormIds.length - 1);
                    bizFormList = bizFormIds.split('|');
                }
                let list = [];
                let contractGoodsAreaPrices = contractGoods.contractGoodsAreaPrices || [];
                if (contractGoodsAreaPrices.length > 0) {
                    for (let i = 0; i < contractGoodsAreaPrices.length; i++) {
                        let contractGoodsArea = contractGoodsAreaPrices[i];
                        let adoptedDevice = {};
                        adoptedDevice.signGroupId = contract.signGroupId;
                        adoptedDevice.signGroupName = contract.signGroupName;
                        adoptedDevice.contractId = contract.id;
                        adoptedDevice.contractNo = contract.no;
                        adoptedDevice.contractFstHtBh = contract.fstPartyHtBh;
                        adoptedDevice.contractKindId = contract.kindId;
                        adoptedDevice.contractRealComId = contract.fstPartyRealComId;
                        adoptedDevice.customized = contractGoods.customized;
                        adoptedDevice.contractTitle = contract.title;
                        adoptedDevice.contractDateStart = new Date(contract.dateStart).format('yyyy-MM-dd');
                        adoptedDevice.contractDateEnd = new Date(contract.dateEnd).format('yyyy-MM-dd');
                        adoptedDevice.assetDefId = contractGoods.assetDefId;
                        adoptedDevice.skuId = contractGoods.skuId;
                        adoptedDevice.goodsCatId = contractGoods.catId;
                        adoptedDevice.goodsBrandId = contractGoods.brandId;
                        adoptedDevice.wrntPeriod = contractGoods.wrntPeriod;
                        adoptedDevice.asmblAccFlag = contractGoods.asmblAccFlag;
                        adoptedDevice.vendorId = contract.sndPartyId;
                        adoptedDevice.price = contractGoodsArea.price;
                        adoptedDevice.bizAreaId = contractGoodsArea.bizAreaId;
                        adoptedDevice.ntxPrice = contractGoodsArea.ntxPrice;
                        adoptedDevice.taxRate = contractGoods.taxRate;
                        adoptedDevice.bizFormIds = bizFormList;
                        list.push(adoptedDevice);
                    }
                } else {
                    let adoptedDevice = {};
                    adoptedDevice.signGroupId = contract.signGroupId;
                    adoptedDevice.signGroupName = contract.signGroupName;
                    adoptedDevice.contractId = contract.id;
                    adoptedDevice.contractNo = contract.no;
                    adoptedDevice.contractFstHtBh = contract.fstPartyHtBh;
                    adoptedDevice.contractKindId = contract.kindId;
                    adoptedDevice.customized = contractGoods.customized;
                    adoptedDevice.contractTitle = contract.title;
                    adoptedDevice.contractDateStart = new Date(contract.dateStart).format('yyyy-MM-dd');
                    adoptedDevice.contractDateEnd = new Date(contract.dateEnd).format('yyyy-MM-dd');
                    adoptedDevice.contractRealComId = contract.fstPartyRealComId;
                    adoptedDevice.assetDefId = contractGoods.assetDefId;
                    adoptedDevice.skuId = contractGoods.skuId;
                    adoptedDevice.ntxPrice = contractGoods.ntxPrice;
                    adoptedDevice.goodsCatId = contractGoods.catId;
                    adoptedDevice.goodsBrandId = contractGoods.brandId;
                    adoptedDevice.price = contractGoods.price;
                    adoptedDevice.taxRate = contractGoods.taxRate;
                    adoptedDevice.wrntPeriod = contractGoods.wrntPeriod;
                    adoptedDevice.asmblAccFlag = contractGoods.asmblAccFlag;
                    adoptedDevice.vendorId = contract.sndPartyId;
                    adoptedDevice.bizFormIds = bizFormList;
                    list.push(adoptedDevice);
                }

                devcReqrApi.saveContractAdoptedDevice(list, function (result) {
                    if (result.type == 'info') {
                        MsgBox.success('添加成功');
                    } else {
                        MsgBox.warning(result.message);
                    }

                })
            },
            addAdoptedServc: function (index, comnRequire) {
                let self = this;
                let adoptedServc = {};
                let contractServc = {};
                let contract = self.contract || {};
                if (Utils.isTrue(comnRequire)) {
                    // 常规服务请求
                    let contractServc2List = contract.contractServc2List || [];
                    contractServc = contractServc2List[index];
                } else {
                    // 设备维保服务
                    let contractServcList = contract.contractServcList;
                    contractServc = contractServcList[index];
                }
                adoptedServc.contractId = contract.id;
                adoptedServc.contractTitle = contract.title;
                adoptedServc.contractDateStart = contractServc.dateStart;
                adoptedServc.contractDateEnd = contractServc.dateEnd;
                adoptedServc.ssuId = contractServc.ssuId;
                adoptedServc.rspTimeMi = contractServc.rspTimeMi;
                adoptedServc.price = contractServc.price;
                adoptedServc.arriveTimeMi = contractServc.arriveTimeMi;
                adoptedServc.repairedTimeMi = contractServc.repairedTimeMi;
                adoptedServc.servicerId = contract.sndPartyId;
                devcReqrApi.saveAdoptedServc(adoptedServc, function (result) {
                    if (result.type == 'info') {
                        MsgBox.success('添加成功');
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            showMkuListDlg: function () {
                let self = this;
                let contract = self.contract;
                let contractGoodsList = contract.contractGoodsList;
                let skuIds = [];
                if (contractGoodsList != null && contractGoodsList.length > 0) {
                    for (let i = 0; i < contractGoodsList.length; i++) {
                        skuIds.push(contractGoodsList[i].skuId);
                    }
                }
                let filter = {};
                filter.merchantId = contract.sndPartyId;
                if (self.contractType == self.goodsPurch.value) {
                    filter.merchantType = self.goodsPurch.sndPartyType;
                } else {
                    filter.merchantType = self.servcPurch.sndPartyType;
                }
                filter.saleHalted = false;
                openSkuListSelectDlg(true, filter, skuIds, function (data) {
                    let resultData = data;
                    if (resultData != null && resultData.length > 0) {
                        for (let i = 0; i < resultData.length > 0; i++) {
                            let sku = resultData[i];
                            if (sku.goodsId != null && sku.title != null) {
                                let item = {};
                                item.mkuId = sku.mkuId;
                                item.skuId = sku.id;
                                item.model = sku.model;
                                item.fixedSpec = sku.fixedSpec;
                                item.name = sku.title;
                                item.title = item.name || '' + sku.fixedSpec || '';
                                item.goodsId = sku.goodsId;
                                item.catId = sku.catId;
                                item.catName = sku.catName;
                                item.brandId = sku.brandId;
                                item.brandName = sku.brandName;
                                if (sku.priceNegoFlag) {
                                    item.price = null;
                                } else {
                                    item.price = Utils.isNoB(sku.salePrice) ? null : parseFloat(sku.salePrice).toFixed(2);
                                }
                                item.taxRate = contract.taxRate || 0.00;
                                if (Utils.isNoB(item.price)) {
                                    item.ntxPrice = item.price;
                                } else {
                                    item.ntxPrice = (parseFloat(item.price) / (1 + (parseFloat(item.taxRate) * 0.01))).toFixed(2);
                                }
                                item.bizAreaFlag = contract.bizAreaFlag;
                                item.wrntPeriod = sku.wrntPeriod;
                                item.unit = sku.unit;
                                item.fileBrowseUrl = sku.defaultImageUrl;
                                if (item.asmblAccFlag) {
                                    item.customized = false;
                                    item.customizable = false;
                                } else {
                                    item.customized = sku.customized;
                                    item.customizable = sku.customized;
                                }
                                item.taxOffset = Utils.isTrue(contract.taxOffset);
                                contractGoodsList.push(item);
                            }
                        }
                        self.sortContractGoods(contractGoodsList);
                        self.contract.contractGoodsList = Utils.merge([], contractGoodsList);
                    }
                });
            },
            // 商品排序
            sortContractGoods: function (contractGoodsList) {
                contractGoodsList = contractGoodsList || [];
                for (let i = 0; i < contractGoodsList.length > 0; i++) {
                    let contractGoods = contractGoodsList[i];
                    contractGoods.seqNo = i + 1;
                }
            },
            // 新增合同服务条目，comnRequire：为true代表常规服务请求，为false代表设备维保服务
            addContractServc: function (comnRequire) {
                let contractServc = {
                    devcGroupId: null,
                    devcGroupFullName: null,
                    innerDevcBrandId: null,
                    innerDevcBrandName: null,
                    goodsBrandId: null,
                    goodsBrandName: null,
                    servcTypeId: null,
                    servcSpec: null,
                    title: null,
                    toDoorFee: null,
                    price: null,
                    rspTimeMi: null,
                    arriveTimeMi: null,
                    repairedTimeMi: null,
                    wrntPeriod: null,
                    telCallTimeMi: null,
                    timesLimitType: 0,
                    srcTimesLimitType: 0,
                    quantityRevisible: false,
                    quantity: 0,
                    amount: null,
                    servcOrgSpecList: [],
                };
                let contract = this.contract || {};
                if (Utils.isTrue(comnRequire)) {
                    // 常规服务请求
                    let contractServc2List = contract.contractServc2List || [];
                    contractServc2List.push(contractServc);
                    contract.contractServc2List = Utils.merge([], contractServc2List);
                } else {
                    // 设备维保服务
                    contractServc.devcPartsOnly = false;
                    contractServc.devcParts = null;
                    //
                    let contractServcList = contract.contractServcList || [];
                    contractServcList.push(contractServc);
                    contract.contractServcList = Utils.merge([], contractServcList);
                }
                this.contract = Utils.merge({}, contract);
            },
            // 设置服务特定
            setOrgSpecInfo: function (index, servcType, timesLimitType, quantityRevisible, comnRequire) {
                let self = this;
                let contract = this.contract || {};
                let contractAppliedShopList = contract.contractAppliedShopList || [];
                if (contractAppliedShopList.length <= 0) {
                    MsgBox.warning('请先选择适用机构');
                    return false;
                }
                let contractServc = {};
                if (comnRequire) {
                    contractServc = contract.contractServc2List[index] || {};
                } else {
                    contractServc = contract.contractServcList[index] || {};
                }
                let quantityFlag = timesLimitType == 1;     // 按门店设定次数：可设定服务次数。
                let amountFlag = timesLimitType == 1 && (servcType == 1 || servcType == 3 || servcType == 6);   // 【保养，检验，巡检】+ 按门店设定次数： 可设定总价
                let params = {
                    showDetail: !this.showSave,
                    bianengFlag: this.showSave && this.operateContract == 'change',
                    comnRequire: comnRequire,
                    quantityFlag: quantityFlag,
                    amountFlag: amountFlag,
                    quantityRevisible: quantityRevisible,
                    servcOrgSpecList: contractServc.servcOrgSpecList || [],
                    contractAppliedShopList: contractAppliedShopList,
                    filterMerchantId: contract.kindId == 0,
                    title: timesLimitType != 1 ? '设置特定门店价格' : '设置门店次数和价格',
                };
                openContractServcOrgSpecListDlg(params, function (servcOrgSpecList) {
                    contractServc.servcOrgSpecList = Utils.merge([], servcOrgSpecList);
                    //
                    if (comnRequire) {
                        contract.contractServc2List[index] = Utils.merge({}, contractServc);
                    } else {
                        contract.contractServcList[index] = Utils.merge({}, contractServc);
                    }
                    self.contract = Utils.merge({}, contract);
                });
            },
            // 移除合同服务
            removeContractServc: function (index, comnRequire) {
                let contract = this.contract || {};
                if (Utils.isTrue(comnRequire)) {
                    // 常规服务请求
                    let contractServc2List = contract.contractServc2List || [];
                    for (let i = 0; i < contractServc2List.length; i++) {
                        if (i == index) {
                            contractServc2List.splice(i, 1);
                            break;
                        }
                    }
                    contract.contractServc2List = Utils.merge([], contractServc2List);
                } else {
                    // 设备维保服务
                    let contractServcList = contract.contractServcList || [];
                    for (let i = 0; i < contractServcList.length; i++) {
                        if (i == index) {
                            contractServcList.splice(i, 1);
                            break;
                        }
                    }
                    contract.contractServcList = Utils.merge([], contractServcList);
                }
                this.contract = Utils.merge({}, contract);
                //
                this.servcAmountOrQuantityChange();
            },
            // 选择设备维保分组
            selectDevcGroup: function (index) {
                let self = this;
                let params = {
                    filter: {
                        level: 2
                    },
                    checkBox: false
                };
                showDevcGroupSelectDlg(params, function (devcGroup, theDlg) {
                    theDlg.close();
                    let contract = self.contract || {};
                    let contractServcList = contract.contractServcList || [];
                    let servcList = Utils.merge([], contractServcList);
                    let contractServc = contractServcList[index];
                    if (devcGroup.id != contractServc.devcGroupId) {
                        contractServc.devcGroupId = devcGroup.id;
                        contractServc.devcGroupId1 = devcGroup.parentId;
                        contractServc.devcGroupId2 = devcGroup.id;
                        contractServc.devcGroupName = devcGroup.name;
                        contractServc.devcGroupFullName = devcGroup.fullName;
                        if (!Utils.isNoB(contractServc.devcParts)) {
                            contractServc.devcParts = null;
                        }
                        if (!Utils.isNoB(contractServc.goodsCatId)) {
                            contractServc.goodsCatId = null;
                            contractServc.goodsCatId1 = null;
                            contractServc.goodsCatId2 = null;
                            contractServc.goodsCatId3 = null;
                            contractServc.goodsCatName = null;
                        }
                        // 校验服务条目
                        let errMsg = self.checkContractServcItem(contractServc, servcList, false);
                        if (!Utils.isNoB(errMsg)) {
                            MsgBox.warning(errMsg);
                            return false;
                        }
                        contract.contractServcList = Utils.merge([], contractServcList);
                        self.contract = Utils.merge({}, contract);
                        // 重新匹配价格质量要求
                        if (!Utils.isNoB(contractServc.devcGroupId) && contractServc.devcGroupId > 0 && !Utils.isNoB(contractServc.servcTypeId)) {
                            self.getServcBasicClaim(contractServc.devcGroupId, contractServc.goodsCatId, contractServc.servcTypeId, index, false);
                        }
                        // 计算金额
                        self.servcAmountFixedChange();
                    }
                });
            },
            // 选择自有品牌
            selectInnerDevcBrand: function (index) {
                let self = this;
                let contract = self.contract || {};
                let contractServcList = contract.contractServcList || [];
                let contractServc = contractServcList[index];
                let selectIds = [];
                if (!Utils.isNoB(contractServc) && Utils.isNoB(contractServc.innerDevcBrandId) && contractServc.innerDevcBrandId > -1) {
                    selectIds.push(contractServc.innerDevcBrandId);
                }
                showDevcBrandSelectDlg({
                    filter: {
                        disabled: false
                    },
                    selectIds: selectIds
                }, function (devcBrand, theDlg) {
                    theDlg.close();
                    contractServc.innerDevcBrandId = devcBrand.id;
                    contractServc.innerDevcBrandName = devcBrand.name;
                    contractServc.goodsBrandId = devcBrand.sysBrandId;
                    contractServc.goodsBrandName = devcBrand.sysBrandName;
                    //
                    contract.contractServcList = Utils.merge([], contractServcList);
                    self.contract = Utils.merge({}, contract);
                });
            },
            // 选择商品分类
            selectGoodsCat: function (index) {
                let self = this;
                let contract = self.contract || {};
                let contractServcList = contract.contractServcList || [];
                let servcList = Utils.merge([], contractServcList);
                let contractServc = contractServcList[index] || {};
                if (Utils.isNoB(contractServc.devcGroupId) || contractServc.devcGroupId <= 0) {
                    MsgBox.warning('请选择维保分组！');
                    return;
                }
                let params = {
                    filter: {
                        groupId: contractServc.devcGroupId,
                        catLevel: 3
                    },
                    checkBox: false
                };
                showDevcGroupCatSelectDlg(params, function (goodsCat, theDlg) {
                    theDlg.close();
                    goodsCat = goodsCat || {};
                    //
                    if (goodsCat.catId != contractServc.goodsCatId) {
                        contractServc.goodsCatId = goodsCat.catId;
                        contractServc.goodsCatId1 = goodsCat.catId1;
                        contractServc.goodsCatId2 = goodsCat.catId2;
                        contractServc.goodsCatId3 = goodsCat.catId3;
                        contractServc.goodsCatName = goodsCat.catName;
                        // 校验服务条目
                        let errMsg = self.checkContractServcItem(contractServc, servcList, false);
                        if (!Utils.isNoB(errMsg)) {
                            MsgBox.warning(errMsg);
                            return false;
                        }
                        contract.contractServcList = Utils.merge([], contractServcList);
                        self.contract = Utils.merge({}, contract);
                        // 重新匹配价格质量要求
                        if (!Utils.isNoB(contractServc.devcGroupId) && contractServc.devcGroupId > 0 && !Utils.isNoB(contractServc.servcTypeId)) {
                            self.getServcBasicClaim(contractServc.devcGroupId, contractServc.goodsCatId, contractServc.servcTypeId, index, false);
                        }
                        // 计算金额
                        self.servcAmountFixedChange();
                    }
                });
            },
            // 服务类型变化事件
            servcTypeVisChange: function (index, comnRequire) {
                let contract = this.contract || {};
                let contractServcList = contract.contractServcList || [];
                let contractServc2List = contract.contractServc2List || [];
                let contractServc = {};
                if (comnRequire) {
                    contractServc = contractServc2List[index];
                } else {
                    contractServc = contractServcList[index];
                }
                contractServc.srcServcTypeId = contractServc.servcTypeId;
                if (comnRequire) {
                    contract.contractServc2List = Utils.merge([], contractServc2List);
                } else {
                    contract.contractServcList = Utils.merge([], contractServcList);
                }
                this.contract = Utils.merge({}, contract);
            },
            servcTypeChange: function (index, comnRequire) {
                let self = this;
                let contract = self.contract;
                let devcGroupId = null;
                let goodsCatId = null;
                let servcTypeId = null;
                let comnRequireId = null;
                let servcList = [];
                let timesLimitType = 0;
                let srcServcTypeId = 0;
                if (Utils.isTrue(comnRequire)) {
                    // 常规服务请求
                    let contractServc2List = contract.contractServc2List || [];
                    servcList = Utils.merge([], contractServc2List);
                    let contractServc2 = contractServc2List[index];
                    contractServc2 = self.clearServc(contractServc2);
                    servcTypeId = contractServc2.servcTypeId;
                    comnRequireId = contractServc2.comnRequireId;
                    timesLimitType = contractServc2.timesLimitType;
                    srcServcTypeId = contractServc2.srcServcTypeId;
                    // 校验服务条目
                    let errMsg = self.checkContractServcItem(contractServc2, servcList, comnRequire);
                    if (!Utils.isNoB(errMsg)) {
                        MsgBox.warning(errMsg);
                        return false;
                    }
                    contract.contractServc2List = Utils.merge([], contractServc2List);
                } else {
                    // 设备维保服务
                    let contractServcList = contract.contractServcList || [];
                    servcList = Utils.merge([], contractServcList);
                    let contractServc = contractServcList[index];
                    contractServc = self.clearServc(contractServc);
                    devcGroupId = contractServc.devcGroupId;
                    goodsCatId = contractServc.goodsCatId;
                    servcTypeId = contractServc.servcTypeId;
                    timesLimitType = contractServc.timesLimitType;
                    srcServcTypeId = contractServc.srcServcTypeId;
                    // 校验服务条目
                    let errMsg = self.checkContractServcItem(contractServc, servcList, comnRequire);
                    if (!Utils.isNoB(errMsg)) {
                        MsgBox.warning(errMsg);
                        return false;
                    }
                    contract.contractServcList = Utils.merge([], contractServcList);
                }
                //
                if ((srcServcTypeId == 1 || srcServcTypeId == 3 || srcServcTypeId == 6) && servcTypeId != 1 && servcTypeId != 3 && servcTypeId != 6 && timesLimitType == 1) {
                    MsgBox.warning("修改后，特定门店总价将失效，请重新设置");
                    // 机构总价自动失效
                    let contractServc = {};
                    if (comnRequire) {
                        contractServc = contract.contractServc2List[index] || {};
                    } else {
                        contractServc = contract.contractServcList[index] || {};
                    }
                    let servcOrgSpecList = contractServc.servcOrgSpecList;
                    for (let i = 0; i < servcOrgSpecList.length; i++) {
                        let selectCom = servcOrgSpecList[i];
                        if (selectCom.priceSpecFlag == 2) {  // 按照总价
                            selectCom.priceSpecFlag = 0;
                            selectCom.amount = 0;
                        }
                    }
                    contractServc.servcOrgSpecList = Utils.merge([], servcOrgSpecList);
                    if (comnRequire) {
                        contract.contractServc2List[index] = Utils.merge({}, contractServc);
                    } else {
                        contract.contractServcList[index] = Utils.merge({}, contractServc);
                    }
                }
                self.contract = Utils.merge({}, contract);
                // 重新匹配价格质量要求
                if (!Utils.isNoB(devcGroupId) && devcGroupId > 0 && !Utils.isNoB(servcTypeId)) {
                    self.getServcBasicClaim(devcGroupId, goodsCatId, servcTypeId, index, comnRequire);
                } else if (Utils.isTrue(comnRequire) && !Utils.isNoB(servcTypeId)) {
                    self.getServcBasicClaim(null, null, servcTypeId, index, comnRequire, comnRequireId);
                }
                // 计算金额
                this.servcAmountFixedChange();
            },
            // 清空服务项目
            clearServc: function (contractServc) {
                contractServc.ssuId = null;
                contractServc.name = null;
                contractServc.fixedSpec = null;
                contractServc.title = null;
                contractServc.wrntPeriod = null;
                contractServc.servcId = null;
                contractServc.toDoorFee = null;
                contractServc.price = null;
                contractServc.rspTimeMi = null;
                contractServc.arriveTimeMi = null;
                contractServc.repairedTimeMi = null;
                contractServc.telCallTimeMi = null;
                contractServc.dateStart = null;
                contractServc.dateEnd = null;
                contractServc.useBasicClaim = null;
                contractServc.amount = null;
                //
                return contractServc;
            },
            // 服务次数
            timesLimitTypeVisChange: function (index, comnRequire) {
                let contract = this.contract || {};
                let contractServcList = contract.contractServcList || [];
                let contractServc2List = contract.contractServc2List || [];
                let contractServc = {};
                if (comnRequire) {
                    contractServc = contractServc2List[index];
                } else {
                    contractServc = contractServcList[index];
                }
                contractServc.srcTimesLimitType = contractServc.timesLimitType;
                if (comnRequire) {
                    contract.contractServc2List = Utils.merge([], contractServc2List);
                } else {
                    contract.contractServcList = Utils.merge([], contractServcList);
                }
                this.contract = Utils.merge({}, contract);
            },
            timesLimitTypeChange: function (index, comnRequire) {
                let self = this;
                let contract = self.contract || {};
                let contractServcList = contract.contractServcList || [];
                let contractServc2List = contract.contractServc2List || [];
                let contractServc = {};
                if (comnRequire) {
                    contractServc = contractServc2List[index];
                } else {
                    contractServc = contractServcList[index];
                }
                if (contractServc.timesLimitType == 1) {
                    let contractAppliedShopList = contract.contractAppliedShopList || [];
                    //
                    let srcServcOrgSpecList = contractServc.servcOrgSpecList;
                    let srcServcOrgSpecMap = srcServcOrgSpecList.pluck("bizUnitId");
                    if (contractAppliedShopList.length > 0) {
                        for (let i = 0; i < contractAppliedShopList.length; i++) {
                            let contractAppliedShop = contractAppliedShopList[i];
                            if (srcServcOrgSpecMap.indexOf(contractAppliedShop.shopId) < 0) {
                                srcServcOrgSpecList.push({
                                    bizUnitId: contractAppliedShop.shopId,
                                    bizUnitName: contractAppliedShop.shopName,
                                    shopFlag: contractAppliedShop.shopFlag,
                                    bizAreaId: contractAppliedShop.bizAreaId,
                                    bizAreaName: contractAppliedShop.bizAreaName,
                                    bizFormId: contractAppliedShop.bizFormId,
                                    bizFormName: contractAppliedShop.bizFormName,
                                    mgmtSmlAreaId: contractAppliedShop.mgmtSmlAreaId,
                                    mgmtSmlAreaName: contractAppliedShop.mgmtSmlAreaName,
                                    //
                                    priceSpecFlag: 0,
                                    price: 0.00,
                                    toDoorFee: 0.00,
                                    quantitySpecFlag: true,
                                    quantity: 0,
                                    srcQuantity: 0,
                                    amount: 0.00
                                });
                            }
                        }
                        contractServc.servcOrgSpecList = Utils.merge([], srcServcOrgSpecList);
                    }
                } else {
                    let srcServcOrgSpecList = contractServc.servcOrgSpecList;
                    for (let i = 0; i < srcServcOrgSpecList.length; i++) {
                        let srcServcOrgSpec = srcServcOrgSpecList[i];
                        srcServcOrgSpec.srcQuantity = 0;    // 用于数量比较
                        srcServcOrgSpec.quantity = 0;
                        srcServcOrgSpec.quantitySpecFlag = false;
                    }
                    contractServc.servcOrgSpecList = Utils.merge([], srcServcOrgSpecList);
                }
                let srcTimesLimitType = contractServc.srcTimesLimitType;
                let servcTypeId = contractServc.servcTypeId;
                if ((servcTypeId == 1 || servcTypeId == 3 || servcTypeId == 6) && srcTimesLimitType == 1) {
                    MsgBox.warning("修改后，特定门店总价将失效，请重新设置");
                    let servcOrgSpecList = contractServc.servcOrgSpecList;
                    for (let i = 0; i < servcOrgSpecList.length; i++) {
                        let selectCom = servcOrgSpecList[i];
                        if (selectCom.priceSpecFlag == 2) {  // 按照总价
                            selectCom.priceSpecFlag = 0;
                            selectCom.amount = 0;
                        }
                    }
                    contractServc.servcOrgSpecList = Utils.merge([], servcOrgSpecList);
                }
                contractServc.quantity = 0;
                contractServc.amount = 0.00;
                if (comnRequire) {
                    contract.contractServc2List = Utils.merge([], contractServc2List);
                } else {
                    contract.contractServcList = Utils.merge([], contractServcList);
                }

                self.contract = Utils.merge({}, contract);
            },
            // 维保服务价格质量要求匹配
            getServcBasicClaim: function (devcGroupId, goodsCatId, servcTypeId, index, comnRequire, comnRequireId) {
                let self = this;
                let contract = self.contract;
                // 获取价格质量要求
                if (Utils.isTrue(comnRequire)) {
                    // 常规服务请求，获取服务常规价格质量要求
                    let postData = {};
                    postData.servcTypeId = servcTypeId;
                    postData.svcItemId = comnRequireId;
                    servcClaimApi.getServcBasicClaim2ByAppliedShop(postData, function (result) {
                        if (result.type == 'info') {
                            let servcBasicClaim2List = result.data || [];
                            if (!Utils.isNoB(servcBasicClaim2List) && servcBasicClaim2List.length > 0) {
                                let servcBasicClaim2 = servcBasicClaim2List[0];
                                let contractServc2List = contract.contractServc2List || [];
                                let contractServc2 = contractServc2List[index];
                                contractServc2.wrntPeriod = servcBasicClaim2.wrntPeriod;
                                contractServc2.toDoorFee = Utils.isNoB(servcBasicClaim2.toDoorFee) ? null : parseFloat(servcBasicClaim2.toDoorFee).toFixed(2);
                                contractServc2.price = Utils.isNoB(servcBasicClaim2.generallFee) ? null : parseFloat(servcBasicClaim2.generallFee).toFixed(2);
                                contractServc2.rspTimeMi = servcBasicClaim2.rspTimeMi;
                                contractServc2.arriveTimeMi = servcBasicClaim2.arriveTimeMi;
                                contractServc2.repairedTimeMi = servcBasicClaim2.repairedTimeMi;
                                contractServc2.telCallTimeMi = servcBasicClaim2.telCallTimeMi;
                                contractServc2.useBasicClaim = true;
                                contract.contractServc2List = Utils.merge([], contractServc2List);
                                self.contract = Utils.merge({}, contract);
                            }
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                } else {
                    // 设备维保服务
                    let postData = {};
                    postData.servcTypeId = servcTypeId;
                    postData.devcGroupId = devcGroupId;
                    postData.goodsCatId = goodsCatId;
                    servcClaimApi.getServcBasicClaimByAppliedShop(postData, function (result) {
                        if (result.type == 'info') {
                            let servcBasicClaims = result.data || [];
                            if (servcBasicClaims.length > 0) {
                                let servcBasicClaim = servcBasicClaims[0];
                                let contractServcList = contract.contractServcList || [];
                                let contractServc = contractServcList[index];
                                contractServc.wrntPeriod = servcBasicClaim.wrntPeriod;
                                contractServc.toDoorFee = Utils.isNoB(servcBasicClaim.toDoorFee) ? null : parseFloat(servcBasicClaim.toDoorFee).toFixed(2);
                                contractServc.price = Utils.isNoB(servcBasicClaim.generallFee) ? null : parseFloat(servcBasicClaim.generallFee).toFixed(2);
                                contractServc.rspTimeMi = servcBasicClaim.rspTimeMi;
                                contractServc.arriveTimeMi = servcBasicClaim.arriveTimeMi;
                                contractServc.repairedTimeMi = servcBasicClaim.repairedTimeMi;
                                contractServc.telCallTimeMi = servcBasicClaim.telCallTimeMi;
                                contractServc.useBasicClaim = true;
                                contract.contractServcList = Utils.merge([], contractServcList);
                                self.contract = Utils.merge({}, contract);
                            }
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }
            },
            // 选择常规服务需求
            selectComnRequire: function (currContractServc, index) {
                let self = this;
                if (Utils.isNoB(currContractServc.servcTypeId)) {
                    MsgBox.warning('请选择服务类型');
                    return;
                }
                let params = {
                    filter: {
                        servcTypeId: parseInt(currContractServc.servcTypeId),
                        disabled: false
                    },
                    checkBox: false
                };
                openComnSvcRequireListForSelectDlg(params, function (comnSvcRequire, theDlg) {
                    theDlg.close();
                    let contract = self.contract || {};
                    let contractServc2List = contract.contractServc2List || [];
                    let servcList = Utils.merge([], contractServc2List);
                    let contractServc2 = contractServc2List[index];
                    if (comnSvcRequire.id != contractServc2.comnRequireId) {
                        contractServc2.comnRequireId = comnSvcRequire.id;
                        contractServc2.comnRequireTitle = comnSvcRequire.title;
                        // 校验服务条目
                        let errMsg = self.checkContractServcItem(contractServc2, servcList, true);
                        if (!Utils.isNoB(errMsg)) {
                            MsgBox.warning(errMsg);
                            return false;
                        }
                        contract.contractServc2List = Utils.merge([], contractServc2List);
                        self.contract = Utils.merge({}, contract);
                        // 匹配服务常规价格质量要求
                        self.getServcBasicClaim(null, null, currContractServc.servcTypeId, index, true, contractServc2.comnRequireId);
                    }
                });
            },
            // 报修部件变化事件
            devcPartsOnlyChange: function (index) {
                let contract = this.contract || {};
                let contractServcList = contract.contractServcList || [];
                let contractServc = contractServcList[index];
                if (!Utils.isTrue(contractServc.devcPartsOnly)) {
                    contractServc.devcParts = null;
                }
                contract.contractServcList = Utils.merge([], contractServcList);
                this.contract = Utils.merge({}, contract);
            },
            // 选择设备部件
            selectDevcGroupPart: function (index) {
                let self = this;
                let contract = self.contract || {};
                let contractServcList = contract.contractServcList || [];
                let servcList = Utils.merge([], contractServcList);
                let contractServc = contractServcList[index];
                if (Utils.isNoB(contractServc.devcGroupId) || contractServc.devcGroupId <= 0) {
                    MsgBox.warning('请选择维保分组！');
                    return;
                }
                let params = {
                    filter: {
                        devcGroupId: contractServc.devcGroupId
                    },
                    checkBox: true,
                    selectIds: []
                };
                showDevcGroupPartSelectDlg(params, function (devcGroupParts, theDlg) {
                    theDlg.close();
                    devcGroupParts = devcGroupParts || [];
                    devcGroupParts = self.reSortDevcParts(devcGroupParts, false);
                    let devcParts = '';
                    for (let i = 0; i < devcGroupParts.length; i++) {
                        let devcGroupPart = devcGroupParts[i];
                        if (Utils.isNoB(devcParts)) {
                            devcParts = '|' + devcGroupPart.name + '|';
                        } else {
                            devcParts += (devcGroupPart.name + '|');
                        }
                    }
                    contractServc.devcParts = devcParts;
                    // 校验服务条目
                    let errMsg = self.checkContractServcItem(contractServc, servcList, true);
                    if (!Utils.isNoB(errMsg)) {
                        MsgBox.warning(errMsg);
                        return false;
                    }
                    contract.contractServcList = Utils.merge([], contractServcList);
                    self.contract = Utils.merge({}, contract);
                });
            },
            // 设备部件排序
            reSortDevcParts: function (devcGroupParts, bDesc) {
                //
                devcGroupParts = devcGroupParts || [];
                bDesc = bDesc === true;

                if (devcGroupParts.length < 1) {
                    return devcGroupParts;
                }

                for (let i = 0; i < devcGroupParts.length - 1; i++) {
                    let devcPart = devcGroupParts[i];
                    let devcPartId = devcPart.id;
                    let mxnIndex = i;
                    let tmpDevcPart = null;
                    for (let j = i + 1; j < devcGroupParts.length; j++) {
                        tmpDevcPart = devcGroupParts[j];
                        let tmpDevcPartId = tmpDevcPart.id;
                        if (bDesc ? tmpDevcPartId > devcPartId : tmpDevcPartId < devcPartId) {
                            devcPartId = tmpDevcPartId;
                            mxnIndex = j;
                        }
                    }
                    if (mxnIndex != i) {
                        tmpDevcPart = devcGroupParts[i];
                        devcGroupParts[i] = devcPart;
                        devcGroupParts[mxnIndex] = tmpDevcPart;
                    }
                }
                return devcGroupParts;
            },
            // 选择服务项目
            showMsuListDlg: function (contractServc, index, comnRequire) {
                let self = this;
                if (Utils.isNoB(contractServc.servcTypeId)) {
                    MsgBox.warning('请选择服务类型');
                    return;
                }
                let contract = self.contract || {};
                //
                let objectType = self.servcPurch.sndPartyType;
                Vue.$showDialog({
                    title: '选择服务',
                    showCloseBtn: true,
                    width: 1200,
                    height: 800,
                    template: '<swb-msu-list-for-select :objectId="objectId" :objectType="objectType" :checkBox="checkBox" :checkedIds="childEventList" :type="type" :comnOnlyFlag="comnOnlyFlag" ref="swb_msu_list"></swb-msu-list-for-select>',
                    data: {
                        checkBox: false,
                        childEventList: [],
                        objectId: null,
                        objectType: objectType,
                        type: contractServc.servcTypeId,
                        comnOnlyFlag: comnRequire
                    },
                    okClicked: function () {
                        let selfDlg = this;
                        let result = selfDlg.$refs.swb_msu_list.getDlgResult() || {};
                        if (result.type === 'info') {
                            let msu = result.data;
                            if (!Utils.isNoB(msu) && msu.id > 0) {
                                if (Utils.isTrue(comnRequire)) {
                                    // 常规服务请求
                                    let contractServc2List = contract.contractServc2List || [];
                                    let servcList = Utils.merge([], contractServc2List);
                                    let contractServc2 = contractServc2List[index];
                                    contractServc2.ssuId = msu.ssuId;
                                    contractServc2.name = msu.title;
                                    contractServc2.fixedSpec = msu.fixedSpec;
                                    contractServc2.title = contractServc2.name || '' + msu.fixedSpec || '';
                                    contractServc2.servcId = msu.servcId;
                                    if (!Utils.isTrue(contractServc2.useBasicClaim)) {
                                        if (Utils.isNoB(contractServc2.wrntPeriod)) {
                                            contractServc2.wrntPeriod = msu.wrntPeriod;
                                        }
                                        if (Utils.isNoB(contractServc2.toDoorFee)) {
                                            contractServc2.toDoorFee = Utils.isNoB(msu.toDoorFee) ? null : parseFloat(msu.toDoorFee).toFixed(2);
                                        }
                                        if (Utils.isNoB(contractServc2.price)) {
                                            contractServc2.price = Utils.isNoB(msu.generallFee) ? null : parseFloat(msu.generallFee).toFixed(2);
                                        }
                                        if (Utils.isNoB(contractServc2.rspTimeMi)) {
                                            contractServc2.rspTimeMi = msu.rspTimeMi;
                                        }
                                        if (Utils.isNoB(contractServc2.arriveTimeMi)) {
                                            contractServc2.arriveTimeMi = msu.arriveTimeMi;
                                        }
                                        if (Utils.isNoB(contractServc2.repairedTimeMi)) {
                                            contractServc2.repairedTimeMi = msu.repairedTimeMi;
                                        }
                                        if (Utils.isNoB(contractServc2.telCallTimeMi)) {
                                            contractServc2.telCallTimeMi = msu.telCallTimeMi;
                                        }
                                    }
                                    contractServc2.dateStart = null;
                                    contractServc2.dateEnd = null;
                                    let errMsg = self.checkContractServcItem(contractServc2, servcList, comnRequire);
                                    if (!Utils.isNoB(errMsg)) {
                                        MsgBox.warning(errMsg);
                                        return false;
                                    }
                                    contract.contractServc2List = Utils.merge([], contractServc2List);
                                    self.contract = Utils.merge({}, contract);
                                } else {
                                    // 设备维保服务
                                    let contractServcList = contract.contractServcList || [];
                                    let servcList = Utils.merge([], contractServcList);
                                    let contractServcInfo = contractServcList[index];
                                    contractServcInfo.ssuId = msu.ssuId;
                                    contractServcInfo.name = msu.title;
                                    contractServcInfo.fixedSpec = msu.fixedSpec;
                                    contractServcInfo.title = contractServcInfo.name || '' + msu.fixedSpec || '';
                                    contractServcInfo.servcId = msu.servcId;
                                    if (!Utils.isTrue(contractServcInfo.useBasicClaim)) {
                                        if (Utils.isNoB(contractServcInfo.wrntPeriod)) {
                                            contractServcInfo.wrntPeriod = msu.wrntPeriod;
                                        }
                                        if (Utils.isNoB(contractServcInfo.toDoorFee)) {
                                            contractServcInfo.toDoorFee = Utils.isNoB(msu.toDoorFee) ? null : parseFloat(msu.toDoorFee).toFixed(2);
                                        }
                                        if (Utils.isNoB(contractServcInfo.price)) {
                                            contractServcInfo.price = Utils.isNoB(msu.generallFee) ? null : parseFloat(msu.generallFee).toFixed(2);
                                        }
                                        if (Utils.isNoB(contractServcInfo.rspTimeMi)) {
                                            contractServcInfo.rspTimeMi = msu.rspTimeMi;
                                        }
                                        if (Utils.isNoB(contractServcInfo.arriveTimeMi)) {
                                            contractServcInfo.arriveTimeMi = msu.arriveTimeMi;
                                        }
                                        if (Utils.isNoB(contractServcInfo.repairedTimeMi)) {
                                            contractServcInfo.repairedTimeMi = msu.repairedTimeMi;
                                        }
                                        if (Utils.isNoB(contractServcInfo.telCallTimeMi)) {
                                            contractServcInfo.telCallTimeMi = msu.telCallTimeMi;
                                        }
                                    }
                                    contractServcInfo.dateStart = null;
                                    contractServcInfo.dateEnd = null;
                                    let errMsg = self.checkContractServcItem(contractServcInfo, servcList, comnRequire);
                                    if (!Utils.isNoB(errMsg)) {
                                        MsgBox.warning(errMsg);
                                        return false;
                                    }
                                    contract.contractServcList = Utils.merge([], contractServcList);
                                    self.contract = Utils.merge({}, contract);
                                }
                            }
                            return true;
                        } else {
                            MsgBox.warning(result.message);
                        }
                        return false;
                    },
                    lifecycle: {
                        created: function () {
                            let selfDlg = this;
                            let msuIds = [];
                            if (Utils.isTrue(comnRequire)) {
                                // 常规服务请求
                                let contractServc2List = contract.contractServc2List || [];
                                if (contractServc2List.length > 0) {
                                    msuIds = contractServc2List.pluck('ssuId') || [];
                                }
                            } else {
                                // 设备维保服务
                                let contractServcList = contract.contractServcList || [];
                                if (contractServcList.length > 0) {
                                    msuIds = contractServcList.pluck('ssuId') || [];
                                }
                            }
                            //
                            selfDlg.childEventList = Utils.merge([], msuIds);
                            selfDlg.objectId = self.contract.sndPartyId;
                        }
                    }
                });
            },
            // 校验合同服务条目
            checkContractServcItem: function (contractServc, servcList, comnRequire) {
                let errMsg = '';
                servcList = servcList || [];
                for (let i = 0; i < servcList.length; i++) {
                    let contractServcInfo = servcList[i];
                    if (Utils.isTrue(comnRequire)) {
                        // 常规服务请求
                        if (contractServc.comnRequireId > 0 && contractServcInfo.comnRequireId == contractServc.comnRequireId //
                            && !Utils.isNoB(contractServc.servcTypeId) && !Utils.isNoB(contractServcInfo.servcTypeId) && parseInt(contractServcInfo.servcTypeId) == parseInt(contractServc.servcTypeId) //
                            && !Utils.isNoB(contractServc.ssuId) && contractServc.ssuId > 0 && !Utils.isNoB(contractServcInfo.ssuId) && parseInt(contractServcInfo.ssuId) == parseInt(contractServc.ssuId)
                        ) {
                            errMsg = '有重复的常规服务请求条目！';
                            break;
                        }
                    } else {
                        // 设备维保服务
                        let goodsCatId = contractServc.goodsCatId;
                        if (Utils.isNoB(goodsCatId)) {
                            goodsCatId = -1;
                        }
                        let goodsCatIdX = contractServcInfo.goodsCatId;
                        if (Utils.isNoB(goodsCatIdX)) {
                            goodsCatIdX = -1;
                        }
                        if (contractServc.devcGroupId > 0 && contractServcInfo.devcGroupId == contractServc.devcGroupId //
                            && goodsCatId == goodsCatIdX //
                            && !Utils.isNoB(contractServc.servcTypeId) && !Utils.isNoB(contractServcInfo.servcTypeId) && parseInt(contractServcInfo.servcTypeId) == parseInt(contractServc.servcTypeId) //
                            && !Utils.isNoB(contractServc.ssuId) && contractServc.ssuId > 0 && !Utils.isNoB(contractServcInfo.ssuId) && parseInt(contractServcInfo.ssuId) == parseInt(contractServc.ssuId) //
                            && contractServc.devcPartsOnly == contractServcInfo.devcPartsOnly && contractServc.devcParts == contractServcInfo.devcParts
                        ) {
                            errMsg = '有重复的设备维保服务条目！';
                            break;
                        }
                    }
                }
                return errMsg;
            },
            // 校验
            checkNull: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不可为空!'));
                } else {
                    callback();
                }
            },
            timeMiCheck: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不可为空!'));
                } else {
                    if (Utils.isNaturalStr(value, true) && value > 0) {
                        callback();
                    } else {
                        callback(new Error('必须为大于0的整数!'));
                    }
                }
            },
            quantityCheck: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不可为空!'));
                } else {
                    if (Utils.isNaturalStr(value, true) && value > 0) {
                        callback();
                    } else {
                        callback(new Error('必须为大于0的整数!'));
                    }
                }
            },
            // 费用校验
            moneyCheck: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不可为空'));
                } else {
                    if (!Utils.isMoneyStr(value)) {
                        callback(new Error('请输入正确的金额'));
                    } else {
                        callback();
                    }
                }
            },
            // 上门费变化事件
            toDoorFeeChange: function (index, comnRequire) {
                let contract = this.contract;
                if (Utils.isTrue(comnRequire)) {
                    // 常规服务请求
                    let contractServc2List = contract.contractServc2List || [];
                    let contractServc2 = contractServc2List[index];
                    contractServc2.toDoorFee = Utils.isNoB(contractServc2.toDoorFee) ? null : parseFloat(contractServc2.toDoorFee).toFixed(2);
                    contractServc2.amount = ((parseFloat(contractServc2.price || 0) + parseFloat(contractServc2.toDoorFee || 0)) * parseInt(contractServc2.quantity || 0)).toFixed(2);
                    contract.contractServc2List = Utils.merge([], contractServc2List);
                } else {
                    // 设备维保服务
                    let contractServcList = contract.contractServcList || [];
                    let contractServc = contractServcList[index];
                    contractServc.toDoorFee = Utils.isNoB(contractServc.toDoorFee) ? null : parseFloat(contractServc.toDoorFee).toFixed(2);
                    contractServc.amount = ((parseFloat(contractServc.price || 0) + parseFloat(contractServc.toDoorFee || 0)) * parseInt(contractServc.quantity || 0)).toFixed(2);
                    contract.contractServcList = Utils.merge([], contractServcList);
                }
                //
                this.contract = Utils.merge({}, contract);
                this.servcAmountOrQuantityChange();
            },
            // 服务费变化事件
            priceChange: function (index, comnRequire) {
                let contract = this.contract;
                if (Utils.isTrue(comnRequire)) {
                    // 常规服务请求
                    let contractServc2List = contract.contractServc2List || [];
                    let contractServc2 = contractServc2List[index];
                    contractServc2.price = Utils.isNoB(contractServc2.price) ? null : parseFloat(contractServc2.price).toFixed(2);
                    contractServc2.amount = ((parseFloat(contractServc2.price || 0) + parseFloat(contractServc2.toDoorFee || 0)) * parseInt(contractServc2.quantity || 0)).toFixed(2);
                    contract.contractServc2List = Utils.merge([], contractServc2List);
                } else {
                    // 设备维保服务
                    let contractServcList = contract.contractServcList || [];
                    let contractServc = contractServcList[index];
                    contractServc.price = Utils.isNoB(contractServc.price) ? null : parseFloat(contractServc.price).toFixed(2);
                    contractServc.amount = ((parseFloat(contractServc.price || 0) + parseFloat(contractServc.toDoorFee || 0)) * parseInt(contractServc.quantity || 0)).toFixed(2);
                    contract.contractServcList = Utils.merge([], contractServcList);
                }
                //
                this.contract = Utils.merge({}, contract);
                this.servcAmountOrQuantityChange();
            },
            // 服务次数变化事件
            quantityChange: function (index, comnRequire) {
                let contract = this.contract;
                if (Utils.isTrue(comnRequire)) {
                    // 常规服务请求
                    let contractServc2List = contract.contractServc2List || [];
                    let contractServc2 = contractServc2List[index];
                    if (!Utils.isNoB(contractServc2.usedQuantity) && contractServc2.usedQuantity > 0 && contractServc2.quantity < contractServc2.usedQuantity) {
                        MsgBox.warning('不可小于已发生次数');
                        return;
                    }
                    contractServc2.amount = ((parseFloat(contractServc2.price || 0) + parseFloat(contractServc2.toDoorFee || 0)) * parseInt(contractServc2.quantity || 0)).toFixed(2);
                    contract.contractServc2List = Utils.merge([], contractServc2List);
                } else {
                    // 设备维保服务
                    let contractServcList = contract.contractServcList || [];
                    let contractServc = contractServcList[index];
                    if (!Utils.isNoB(contractServc.usedQuantity) && contractServc.usedQuantity > 0 && contractServc.quantity < contractServc.usedQuantity) {
                        MsgBox.warning('不可小于已发生次数');
                        return;
                    }
                    contractServc.amount = ((parseFloat(contractServc.price || 0) + parseFloat(contractServc.toDoorFee || 0)) * parseInt(contractServc.quantity || 0)).toFixed(2);
                    contract.contractServcList = Utils.merge([], contractServcList);
                }
                //
                this.contract = Utils.merge({}, contract);
                this.servcAmountOrQuantityChange();
            },
            // 选择适用机构
            selectAppliedShop: function () {
                let self = this;
                let contract = self.contract || {};
                let realComId = contract.fstPartyRealComId;
                if (Utils.isNoB(realComId) || realComId <= 0) {
                    MsgBox.warning('请选择买方公司');
                    return;
                }
                let contractAppliedShopList = contract.contractAppliedShopList || [];
                let shopIds = [];
                if (contractAppliedShopList.length > 0) {
                    shopIds = contractAppliedShopList.pluck('shopId') || [];
                }
                let queryFilter = {
                    disabledIds: shopIds,
                    realComId: realComId,
                    signGroupId: contract.signGroupId,
                    orgType: getEnumInfoWith('orgType', 'name', 'BizUnit').value,
                    filterMerchantId: contract.kindId == 0,
                    states: [1]
                };
                if (Utils.isNoB(realComId)) {
                    queryFilter.comLevel = 1;
                    queryFilter.comId = self.scopeEntity.comId1;
                }
                openRetailerComListForSelectDlg(queryFilter, function (comList, theDlg) {
                    theDlg.close();
                    let contractServcList = contract.contractServcList || [];
                    let contractServc2List = contract.contractServc2List || [];
                    for (let i = 0; i < comList.length; i++) {
                        let comInfo = comList[i];
                        let contractAppliedShop = {
                            shopId: comInfo.id,
                            shopName: comInfo.name,
                            shopLevel: comInfo.level,
                            shopFlag: comInfo.shopFlag,
                            bizAreaId: comInfo.bizAreaId,
                            bizAreaName: comInfo.bizAreaName,
                            bizFormId: comInfo.bizFormId,
                            bizFormName: comInfo.bizFormName,
                            mgmtSmlAreaId: comInfo.mgmtSmlAreaId,
                            mgmtSmlAreaName: comInfo.mgmtSmlAreaName,
                        };
                        contractAppliedShopList.push(contractAppliedShop);
                        // 检查并补充特定门店价格、特定服务次数信息。支持次数的才新增。
                        self.makeServcOrgSpecForQuantity(comInfo, contractServcList, contractServc2List);
                    }
                    contract.contractAppliedShopList = Utils.merge([], contractAppliedShopList);
                    self.contract = Utils.merge({}, contract);
                });
            },
            // 检查并补充特定门店价格、特定服务次数信息。支持次数的才新增。
            makeServcOrgSpecForQuantity: function (comInfo, contractServcList, contractServc2List) {
                let self = this;
                if (contractServcList.length > 0) {
                    for (let j = 0; j < contractServcList.length; j++) {
                        let contractServc = contractServcList[j];
                        if (contractServc.timesLimitType == 1) {  //按机构限定次数
                            let servcOrgSpecList = contractServc.servcOrgSpecList || [];
                            let bizUnitIds = [];
                            if (servcOrgSpecList.length > 0) {
                                bizUnitIds = servcOrgSpecList.pluck("bizUnitId");
                            }
                            if (bizUnitIds.indexOf(comInfo.id) < 0) {
                                servcOrgSpecList.push({
                                    bizUnitId: comInfo.id,
                                    bizUnitName: comInfo.name,
                                    shopFlag: comInfo.shopFlag,
                                    bizAreaId: comInfo.bizAreaId,
                                    bizAreaName: comInfo.bizAreaName,
                                    bizFormId: comInfo.bizFormId,
                                    bizFormName: comInfo.bizFormName,
                                    mgmtSmlAreaId: comInfo.mgmtSmlAreaId,
                                    mgmtSmlAreaName: comInfo.mgmtSmlAreaName,
                                    //
                                    priceSpecFlag: 0,
                                    price: 0.00,
                                    toDoorFee: 0.00,
                                    quantitySpecFlag: true,
                                    quantity: 0,
                                    srcQuantity: 0,
                                    amount: 0.00
                                });
                                contractServc.servcOrgSpecList = Utils.merge([], servcOrgSpecList);
                            }
                        }
                    }
                }
                if (contractServc2List.length > 0) {
                    for (let j = 0; j < contractServc2List.length; j++) {
                        let contractServc = contractServc2List[j];
                        if (contractServc.timesLimitType == 1) {  //按机构限定次数
                            let servcOrgSpecList = contractServc.servcOrgSpecList || [];
                            let bizUnitIds = [];
                            if (servcOrgSpecList.length > 0) {
                                bizUnitIds = servcOrgSpecList.pluck("bizUnitId");
                            }
                            if (bizUnitIds.indexOf(comInfo.id) < 0) {
                                servcOrgSpecList.push({
                                    bizUnitId: comInfo.id,
                                    bizUnitName: comInfo.name,
                                    shopFlag: comInfo.shopFlag,
                                    bizAreaId: comInfo.bizAreaId,
                                    bizAreaName: comInfo.bizAreaName,
                                    bizFormId: comInfo.bizFormId,
                                    bizFormName: comInfo.bizFormName,
                                    mgmtSmlAreaId: comInfo.mgmtSmlAreaId,
                                    mgmtSmlAreaName: comInfo.mgmtSmlAreaName,
                                    //
                                    priceSpecFlag: 0,
                                    price: 0.00,
                                    toDoorFee: 0.00,
                                    quantitySpecFlag: true,
                                    quantity: 0,
                                    srcQuantity: 0,
                                    amount: 0.00
                                });
                                contractServc.servcOrgSpecList = Utils.merge([], servcOrgSpecList);
                            }
                        }
                    }
                }
            },
            generalImport: function () {
                let self = this;
                let contract = self.contract || {};
                let realComId = null;
                if (contract.kindId == 0) {
                    realComId = contract.fstPartyRealComId;
                    if (Utils.isNoB(realComId) || realComId <= 0) {
                        MsgBox.warning('请选择买方公司');
                        return;
                    }
                }
                //
                let uploadParams = {
                    title: '适用机构导入',
                    fileFor: 'contract.applied.shop.import',
                    fileGroup: 'contract.applied.shop.import',
                    multipleFile: false,
                    usage: 'contract.applied.shop.import' //
                };
                fileUploadGroupShowDlg(uploadParams, null, function (result, theDlg) {
                    theDlg.close();
                    if (result.type === 'info') {
                        let files = result.data.files;
                        self.file = files[0];
                        // 文件是否按模版导入
                        let errorMsgList = self.file.extra.errorMsgList;
                        if (!Utils.isNoB(errorMsgList) && errorMsgList.length > 0) {
                            MsgBox.warning(errorMsgList.join('<br/>'));
                            return;
                        }
                        //
                        let appliedShopList = self.file.extra.appliedShopList || [];
                        if (appliedShopList.length <= 0) {
                            MsgBox.warning('文件中未解析机构信息');
                            return;
                        }
                        //
                        for (let i = 0; i < appliedShopList.length; i++) {
                            let appliedShop = appliedShopList[i];
                            appliedShop.realComId = realComId;
                            appliedShop.signGroupId = contract.signGroupId;
                        }
                        //
                        self.checkContractAppliedShopList(appliedShopList, function (dbAppliedShopList) {
                            let contractAppliedShopList = [];
                            let contractServcList = contract.contractServcList || [];
                            let contractServc2List = contract.contractServc2List || [];
                            for (let i = 0; i < dbAppliedShopList.length; i++) {
                                let comInfo = dbAppliedShopList[i];
                                let contractAppliedShop = {
                                    shopId: comInfo.id,
                                    shopName: comInfo.name,
                                    shopLevel: comInfo.level,
                                    shopFlag: comInfo.shopFlag,
                                    bizAreaId: comInfo.bizAreaId,
                                    bizAreaName: comInfo.bizAreaName,
                                    bizFormId: comInfo.bizFormId,
                                    bizFormName: comInfo.bizFormName,
                                    mgmtSmlAreaId: comInfo.mgmtSmlAreaId,
                                    mgmtSmlAreaName: comInfo.mgmtSmlAreaName
                                };
                                contractAppliedShopList.push(contractAppliedShop);
                                // 检查并补充特定门店价格、特定服务次数信息。支持次数的才新增。
                                self.makeServcOrgSpecForQuantity(comInfo, contractServcList, contractServc2List);
                            }
                            contract.contractAppliedShopList = Utils.merge([], contractAppliedShopList);
                            self.contract = Utils.merge({}, contract);
                        });
                    } else {
                        MsgBox.warning(result.message);
                    }
                }, function () {
                    let params = {
                        contractId: contract.id,
                        realComId: realComId,
                        signGroupId: contract.signGroupId,
                        filterMerchantId: contract.kindId == 0
                    };
                    let downloadUrl = Utils.makeUrl('/api/contract/applied/shop/imp/template/download', params);
                    //
                    Utils.setPageUrl(getAppUrl(downloadUrl), '_blank');
                });
            },
            checkContractAppliedShopList: function (postData, callback) {
                let theLoad = MsgBox.loading();
                contractApi.checkContractAppliedShopInfo(postData, function (result) {
                    theLoad.hide();
                    if (result.type == 'info') {
                        callback(result.data || []);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 移除适用机构
            deleteAppliedShop: function (index) {
                let contract = this.contract || {};
                let contractAppliedShopList = contract.contractAppliedShopList || [];
                let removeAppliedShops = contractAppliedShopList.splice(index, 1);
                let removeAppliedShopInfo = removeAppliedShops[0];
                contract.contractAppliedShopList = Utils.merge([], contractAppliedShopList);
                // 处理-合同服务门店次数
                let contractServcList = contract.contractServcList || [];
                if (contractServcList.length > 0) {
                    for (let i = 0; i < contractServcList.length; i++) {
                        let contractServc = contractServcList[i];
                        // 门店价格
                        let lengthPrice = contractServc.servcOrgSpecList.length;
                        for (let j = 0; j < lengthPrice; j++) {
                            let orgPrice = contractServc.servcOrgSpecList[j];
                            if (removeAppliedShopInfo.shopId == orgPrice.bizUnitId) {
                                contractServc.servcOrgSpecList.splice(j, 1);
                                break;
                            }
                        }
                    }
                    contract.contractServcList = Utils.merge([], contractServcList);
                }
                // 处理-合同服务门店次数
                let contractServc2List = contract.contractServc2List || [];
                if (contractServc2List.length > 0) {
                    for (let i = 0; i < contractServc2List.length; i++) {
                        let contractServc = contractServc2List[i];
                        // 门店价格
                        let lengthPrice = contractServc.servcOrgSpecList.length;
                        for (let j = 0; j < lengthPrice; j++) {
                            let orgPrice = contractServc.servcOrgSpecList[j];
                            if (removeAppliedShopInfo.shopId == orgPrice.bizUnitId) {
                                contractServc.servcOrgSpecList.splice(j, 1);
                                break;
                            }
                        }
                    }
                    contract.contractServc2List = Utils.merge([], contractServc2List);
                }
                this.contract = Utils.merge({}, contract);
            },
            registerContract: function () {
                let self = this;
                self.warnContractServcFlag = false;
                self.warnContractServc2Flag = false;
                //
                let isValid = Utils.repeatChecker.isValidFor('registerContract', 1000);
                if (!isValid) {
                    return;
                }
                let contract = self.contract;
                if ((Utils.isNoB(contract.signGroupId) || contract.signGroupId == -1) && (self.contractType == self.goodsPurch.value || self.contractType == self.servcPurch.value)) {
                    MsgBox.warning('请选择合同适用范围');
                    return;
                }
                if (Utils.isTrue(contract.useAccAuditRule) && !Utils.isTrue(contract.sglAccAuditEnabled) && !Utils.isTrue(contract.sumAccAuditEnabled)) {
                    MsgBox.warning('至少选择一个配件审核规则');
                    return;
                }
                if (Utils.isNoB(contract.invoiceType)) {
                    MsgBox.warning("发票信息[发票类型]不可为空");
                    return;
                }
                if (Utils.isNoB(contract.taxPayerNo)) {
                    MsgBox.warning("发票信息[纳税人识别号]不可为空");
                    return;
                }
                self.$refs['contract'].validate(function (valid) {
                    if (valid) {
                        contract.signDate = contract.signDate.format('yyyy-MM-dd');
                        contract.dateStart = contract.dateStart.format('yyyy-MM-dd');
                        contract.dateEnd = contract.dateEnd.format('yyyy-MM-dd');
                        if (contract.dateStart >= contract.dateEnd) {
                            MsgBox.warning('请输入有效的合同开始结束时间！');
                            return false;
                        }
//                        if(Utils.isNoB(contract.invoiceTitle) || Utils.isNoB(contract.taxPayerNo)) {
//                            MsgBox.warning("请填写发票相关信息");
//                            return false;
//                        }
                        //
                        if (self.contractType == self.goodsPurch.value || self.contractType == self.integPurch.value) {
                            if (contract.contractGoodsList.length == 0) {
                                MsgBox.warning('无商品信息！');
                                return false;
                            }
                            let goodsFlag = false;
                            self.$refs['contractGoodsList'].validate(function (valid) {
                                if (valid) {
                                    let contractGoodsList = contract.contractGoodsList || [];
                                    for (let i = 0; i < contractGoodsList.length; i++) {
                                        let contractGoods = contractGoodsList[i];
                                        if (Utils.isTrue(self.showAssetInfo) && (contractGoods.assetDefId == null || contractGoods.assetDefId == -1)) {
                                            MsgBox.warning('请为商品【' + contractGoods.title + '】关联定义！');
                                            return false;
                                        }
                                        if (Utils.isTrue(contractGoods.bizAreaFlag)) {
                                            let contractGoodsAreaPrices = contractGoods.contractGoodsAreaPrices || [];
                                            if (contractGoodsAreaPrices.length <= 0) {
                                                MsgBox.warning('请为商品【' + contractGoods.title + '】设置区域价格！');
                                                return false;
                                            }
                                        } else {
                                            let quantity = contractGoods.quantity;
                                            if (Utils.isNoB(quantity) && !Utils.isNoB(self.contract.kindId) && self.contract.kindId == 0) {
                                                MsgBox.warning('请为商品【' + contractGoods.title + '】设置具体的商品数量！');
                                                return false;
                                            }
                                            let price = contractGoods.price;
                                            if (Utils.isNoB(price) || parseFloat(price) <= 0) {
                                                MsgBox.warning('请为商品【' + contractGoods.title + '】设置具体的含税价！');
                                                return false;
                                            }
                                        }
                                    }
                                    goodsFlag = true;
                                }
                            });
                            if (!goodsFlag) {
                                return false;
                            }
                        }
                        if (self.contractType == self.servcPurch.value || self.contractType == self.integPurch.value) {
                            let contractServcList = contract.contractServcList || [];
                            let contractServc2List = contract.contractServc2List || [];
                            if (contractServcList.length <= 0 && contractServc2List.length <= 0) {
                                MsgBox.warning('请设置设备维保服务或者常规服务请求信息！');
                                return false;
                            }
                            let errFlag = false;
                            if (contractServcList.length > 0) {
                                let contractServcMap = {};
                                let warnContractServcMap = {};
                                for (let i = 0; i < contractServcList.length; i++) {
                                    let contractServc = contractServcList[i];
                                    if (Utils.isNoB(contractServc.devcGroupId) || contractServc.devcGroupId <= 0) {
                                        let msg = '请为服务【' + contractServc.title + '】设置维保分组！';
                                        if (Utils.isNoB(contractServc.title)) {
                                            msg = '请为设备维保服务中的服务设置维保分组！';
                                        }
                                        errFlag = true;
                                        MsgBox.warning(msg);
                                        return false;
                                    }
                                    if (Utils.isNoB(contractServc.servcTypeId)) {
                                        let msg = '请为服务【' + contractServc.title + '】设置服务类型！';
                                        if (Utils.isNoB(contractServc.title)) {
                                            msg = '请为设备维保服务中的服务设置服务类型！';
                                        }
                                        errFlag = true;
                                        MsgBox.warning(msg);
                                        return false;
                                    }
                                    if (Utils.isTrue(contractServc.devcPartsOnly) && Utils.isNoB(contractServc.devcParts)) {
                                        let msg = '请为服务【' + contractServc.title + '】设置设备部件！';
                                        if (Utils.isNoB(contractServc.title)) {
                                            msg = '请为设备维保服务中的服务设置设备部件！';
                                        }
                                        errFlag = true;
                                        MsgBox.warning(msg);
                                        return false;
                                    }
                                    // 唯一键校验 ["devcGroupId", "goodsCatId", "innerDevcBrandId", "servcTypeId", "ssuId", "devcPartsOnly", "devcParts"]
                                    let key = contractServc.devcGroupId + '_' + (Utils.isNoB(contractServc.goodsCatId) ? -1 : contractServc.goodsCatId) + (Utils.isNoB(contractServc.innerDevcBrandId) ? -1 : contractServc.innerDevcBrandId) + '_' + contractServc.servcTypeId + '_' + (Utils.isNoB(contractServc.ssuId) ? -1 : contractServc.ssuId) + '_' + Utils.isTrue(contractServc.devcPartsOnly);
                                    if (Utils.isTrue(contractServc.devcPartsOnly)) {
                                        key = key + '_' + contractServc.devcParts;
                                    }
                                    let contractServcX = contractServcMap[key];
                                    if (contractServcX != null) {
                                        errFlag = true;
                                        MsgBox.warning('请勿添加重复的设备维保服务！');
                                        return false;
                                    } else {
                                        contractServcMap[key] = Utils.merge({}, contractServc);
                                    }
                                    if (!self.warnContractServcFlag) {
                                        // 检查并提示，不做强制拦截
                                        let warnKey = contractServc.devcGroupId + '_' + (Utils.isNoB(contractServc.goodsCatId) ? -1 : contractServc.goodsCatId) + (Utils.isNoB(contractServc.innerDevcBrandId) ? -1 : contractServc.innerDevcBrandId) + '_' + contractServc.servcTypeId + '_' + Utils.isTrue(contractServc.devcPartsOnly);
                                        if (Utils.isTrue(contractServc.devcPartsOnly)) {
                                            warnKey = warnKey + '_' + contractServc.devcParts;
                                        }
                                        let warnContractServc = warnContractServcMap[warnKey];
                                        if (warnContractServc != null) {
                                            self.warnContractServcFlag = true;
                                        } else {
                                            warnContractServcMap[warnKey] = Utils.merge({}, contractServc);
                                        }
                                    }
                                }
                                if (Utils.isTrue(errFlag)) {
                                    return;
                                }
                                self.$refs['contractServcList'].validate(function (valid) {
                                    if (!valid) {
                                        errFlag = true;
                                        MsgBox.warning('请设置设备维保服务相关信息！');
                                        return false;
                                    }
                                });
                                if (Utils.isTrue(errFlag)) {
                                    return;
                                }
                            }
                            if (contractServc2List.length > 0) {
                                let contractServc2Map = {};
                                let warnContractServc2Map = {};
                                for (let i = 0; i < contractServc2List.length; i++) {
                                    let contractServc = contractServc2List[i];
                                    if (Utils.isNoB(contractServc.servcTypeId)) {
                                        let msg = '请为服务【' + contractServc.title + '】设置服务类型！';
                                        if (Utils.isNoB(contractServc.title)) {
                                            msg = '请为常规服务请求中的服务设置服务类型！';
                                        }
                                        errFlag = true;
                                        MsgBox.warning(msg);
                                        return false;
                                    }
                                    if (Utils.isNoB(contractServc.comnRequireId) || contractServc.comnRequireId <= 0) {
                                        let msg = '请为服务【' + contractServc.title + '】设置常规服务需求！';
                                        if (Utils.isNoB(contractServc.title)) {
                                            msg = '请为常规服务请求中的服务设置常规服务需求！';
                                        }
                                        errFlag = true;
                                        MsgBox.warning(msg);
                                        return false;
                                    }
                                    // 拦截校验 "comnRequireId", "servcTypeId", "ssuId"
                                    let key = contractServc.servcTypeId + '_' + contractServc.comnRequireId + '_' + (Utils.isNoB(contractServc.ssuId) ? -1 : contractServc.ssuId);
                                    let contractServc2 = contractServc2Map[key];
                                    if (contractServc2 != null) {
                                        errFlag = true;
                                        MsgBox.warning('请勿添加重复的常规服务请求！');
                                        return false;
                                    } else {
                                        contractServc2Map[key] = Utils.merge({}, contractServc);
                                    }
                                    if (!self.warnContractServc2Flag) {
                                        // 检查并提示，不做强制拦截
                                        let warnKey = contractServc.servcTypeId + '_' + contractServc.comnRequireId;
                                        let warnContractServc = warnContractServc2Map[warnKey];
                                        if (warnContractServc != null) {
                                            self.warnContractServc2Flag = true;
                                        } else {
                                            warnContractServc2Map[warnKey] = Utils.merge({}, contractServc);
                                        }
                                    }
                                }
                                if (Utils.isTrue(errFlag)) {
                                    return;
                                }
                                self.$refs['contractServc2List'].validate(function (valid) {
                                    if (!valid) {
                                        errFlag = true;
                                        MsgBox.warning('请设置常规服务请求相关信息！');
                                        return false;
                                    }
                                });
                                if (Utils.isTrue(errFlag)) {
                                    return;
                                }
                            }
                            if (!Utils.isNoB(self.contract.kindId) && self.contract.kindId == 0) {
                                if (Utils.isTrue(contract.servcAmountFixed)) {
                                    if (Utils.isNoB(contract.totalServcAmount) || !Utils.isMoneyStr(contract.totalServcAmount) || contract.totalServcAmount < 0) {
                                        MsgBox.warning('请输入正确的服务包死价总额！');
                                        return;
                                    }
                                }
                            }
                            // 校验适用机构
                            let contractAppliedShopList = contract.contractAppliedShopList || [];
                            if (contractAppliedShopList.length <= 0) {
                                MsgBox.warning('请选择适用机构！');
                                return;
                            }
                        }
                        if (!Utils.isNoB(self.contract.kindId) && self.contract.kindId == 0) {
                            if (Utils.isNoB(contract.estmtAmount) || !Utils.isMoneyStr(contract.estmtAmount) || contract.estmtAmount < 0) {
                                MsgBox.warning('请输入正确的预计合同总额！');
                                return;
                            }
                        }
                        //
                        if (!Utils.isNoB(contract.sndPartyCardNo) && (contract.sndPartyCardNo.length < 9 || contract.sndPartyCardNo.length > 20)) {
                            MsgBox.warning('请输入正确的银行卡号，长度大于8小于21');
                            return;
                        }
                        if (!Utils.isNoB(contract.sndPartyAcctNo) && (contract.sndPartyAcctNo.length < 9 || contract.sndPartyAcctNo.length > 20)) {
                            MsgBox.warning('请输入正确的银行账号，长度大于8小于21');
                            return;
                        }
                        let result = self.$refs.swb_contract_file.getDlgResult() || [];
                        if (result.type == 'info') {
                            contract.contractFileList = result.data;
                        }
                        if (contract.termsFlag) {
                            let ruleResult = self.$refs.swb_create_trade_rule.getResult() || [];
                            if (ruleResult.type == 'info') {
                                let srcFlag = contract.srcFlag;
                                if (srcFlag == 2) {
                                    contract.contractTermList = ruleResult.data;
                                    let contractTermList = contract.contractTermList;
                                    for (let i = 0; i < contractTermList.length; i++) {
                                        let bidTermValueList = contractTermList[i].bidTermValueList;
                                        if (bidTermValueList != null) {
                                            contractTermList[i].contractTermValueList = Utils.copyAsArray(contractTermList[i].bidTermValueList);
                                        }
                                    }
                                } else if (srcFlag == 3) {
                                    contract.contractTermList = ruleResult.data;
                                    let contractTermList = contract.contractTermList;
                                    for (let i = 0; i < contractTermList.length; i++) {
                                        let priceReplyTermValueList = contractTermList[i].priceReplyTermValueList;
                                        if (priceReplyTermValueList != null) {
                                            contractTermList[i].contractTermValueList = Utils.copyAsArray(contractTermList[i].priceReplyTermValueList);
                                        }
                                    }
                                } else {
                                    contract.contractTermList = ruleResult.data;
                                }
                            } else {
                                return;
                            }
                        }
                        if (contract.estmtAmount == null) {
                            contract.estmtAmount = 0;
                        }
                        // 获取合同履约阶段
                        if (contract.phaseFlag) {
                            let phaseResult = self.$refs.swb_contract_track_phase.getDlgResult();
                            if (phaseResult.type == 'info') {
                                let contractTrackPhaseList = phaseResult.data;
                                let amountPayPctSum = 0;
                                let goodsDeliverCountPctSum = 0;
                                let amountPaySum = 0;
                                let goodsDeliverCountSum = 0;
                                if (contractTrackPhaseList != null && contractTrackPhaseList.length > 0) {
                                    for (let i = 0; i < contractTrackPhaseList.length; i++) {
                                        let contractTrackPhase = contractTrackPhaseList[i];
                                        //
                                        let amountPayPct = contractTrackPhase.amountPayPct || 0;
                                        let goodsDeliverCountPct = contractTrackPhase.goodsDeliverCountPct || 0;
                                        amountPayPctSum += Utils.ParseFloat(amountPayPct);
                                        goodsDeliverCountPctSum += Utils.ParseFloat(goodsDeliverCountPct);
                                        //
                                        let amountPay = contractTrackPhase.amountPay || 0;
                                        let goodsDeliverCount = contractTrackPhase.goodsDeliverCount || 0;
                                        amountPaySum += amountPay;
                                        goodsDeliverCountSum += goodsDeliverCount;
                                    }
                                    if (amountPayPctSum > 100 && amountPaySum > contract.estmtAmount) {
                                        MsgBox.warning('支付金额百分比不能超过100%！');
                                        return;
                                    }
                                    if (goodsDeliverCountPctSum > 100 && goodsDeliverCountSum > contract.estmtGoodsCount) {
                                        MsgBox.warning('商品交付件数百分比不能超过100%！');
                                        return;
                                    }
                                    contract.contractTrackPhaseList = contractTrackPhaseList;
                                } else {
                                    MsgBox.warning('请设置履约阶段！');
                                    return;
                                }
                            } else {
                                return;
                            }
                        }
                        // 校验付款阶段，目前只有商品合同有付款阶段
                        let ratioMsg = '';
                        if (self.contractType == self.goodsPurch.value) {
                            let contractPhasedPaySettingList = contract.contractPhasedPaySettingList || [];
                            if (contractPhasedPaySettingList.length > 0) {
                                let payPhaseFlag = true;
                                self.$refs['contractPhasedPaySettingList'].validate(function (valid) {
                                    if (valid) {
                                        let ratioSum = 0;
                                        for (let i = 0; i < contractPhasedPaySettingList.length; i++) {
                                            let contractPhasedPaySetting = contractPhasedPaySettingList[i];
                                            //
                                            if (contract.acntPeriodForm == 2) {
                                                contractPhasedPaySetting.acntPeriodDays = null;
                                            } else {
                                                contractPhasedPaySetting.phaseGapDays = null;
                                            }
                                            contractPhasedPaySetting.seqNo = i;
                                            //
                                            let ratio = contractPhasedPaySetting.ratio;
                                            if (ratio != null && parseFloat(ratio) > 0) {
                                                ratioSum += parseFloat(ratio);
                                            } else {
                                                payPhaseFlag = false;
                                            }
                                        }
                                        if (ratioSum > 100) {
                                            payPhaseFlag = false;
                                            ratioMsg = '付款比例总和不能超过100%！';
                                        } else if (ratioSum != 100) {
                                            ratioMsg = '当前付款阶段比例不是100%，确认要继续操作吗？';
                                        }
                                    } else {
                                        payPhaseFlag = false;
                                    }
                                });
                                if (!payPhaseFlag) {
                                    if (ratioMsg != '') {
                                        MsgBox.warning(ratioMsg);
                                    } else {
                                        MsgBox.warning('请输入付款阶段相关内容！');
                                    }
                                    return false;
                                }
                            }
                        }
                        if (ratioMsg.length > 0) {
                            self.$confirm(ratioMsg, '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(function () {
                                //
                                if (Utils.isNoB(contract.id)) {
                                    let postData = {};
                                    postData.merchantId = contract.sndPartyId;
                                    postData.merchantType = contract.sndPartyType;
                                    merchtQualiApi.existMerchantQualiTrade(postData, function (result) {
                                        if (result.type == 'info') {
                                            let existTrade = result.data;
                                            if (existTrade) {
                                                self.contract = Utils.merge({}, contract);
                                                self.saveContract();
                                            } else {
                                                MsgBox.warning('卖家平台交易资质未认证，相关业务不能执行！');
                                            }
                                        } else {
                                            MsgBox.warning(result.message);
                                        }
                                    });
                                } else {
                                    self.contract = Utils.merge({}, contract);
                                    self.saveContract();
                                }
                            }).catch(function () {
                            });
                        } else {
                            //
                            if (Utils.isNoB(contract.id)) {
                                let postData = {};
                                postData.merchantId = contract.sndPartyId;
                                postData.merchantType = contract.sndPartyType;
                                merchtQualiApi.existMerchantQualiTrade(postData, function (result) {
                                    if (result.type == 'info') {
                                        let existTrade = result.data;
                                        if (existTrade) {
                                            self.contract = Utils.merge({}, contract);
                                            self.saveContract();
                                        } else {
                                            MsgBox.warning('卖家平台交易资质未认证，相关业务不能执行！');
                                        }
                                    } else {
                                        MsgBox.warning(result.message);
                                    }
                                });
                            } else {
                                self.contract = Utils.merge({}, contract);
                                self.saveContract();
                            }
                        }
                    }
                });
            },
            saveContract: function () {
                let self = this;
                self.flag = false;
                let postData = self.contract;
                if (postData.version == null) {
                    postData.version = 1;
                }
                if (self.operateContract == 'change') {
                    postData.id = null;
                    let version = postData.version;
                    postData.version = version + 1;
                }
                let path = '';
                if (self.contractType == self.goodsPurch.value) {
                    path = SwbGoodsPurchContractList.path;
                } else if (self.contractType == self.servcPurch.value) {
                    path = SwbServcPurchContractList.path;
                } else if (self.contractType == self.integPurch.value) {
                    path = SwbIntegPurchContractList.path;
                }

                if (postData.id != null) {
                    if (self.warnContractServcFlag || self.warnContractServc2Flag) {
                        self.$confirm((self.warnContractServcFlag ? '维保分组' : '常规服务') + '已存在，是否继续创建吗', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(function () {
                            //
                            self.modifyContract(postData, path);
                        }).catch(function () {
                        });
                    } else {
                        self.modifyContract(postData, path);
                    }
                } else {
                    let contractGoodsList = postData.contractGoodsList || [];
                    if (self.contractType == self.goodsPurch.value || (self.contractType == self.integPurch.value && contractGoodsList.length > 0)) {
                        if (contractGoodsList.length <= 0) {
                            MsgBox.warning('请选择商品信息');
                            return;
                        }
                        let checkPostData = {
                            fstPartyRealComId: postData.fstPartyRealComId,
                            sndPartyRealComId: postData.sndPartyRealComId,
                            kindId: postData.kindId,
                            dateStart: postData.dateStart,
                            dateEnd: postData.dateEnd,
                            contractGoodsList: contractGoodsList
                        };
                        self.getCheckContractGoodsUkInfo(checkPostData, function (msgList) {
                            if (!Utils.isNoB(msgList) && msgList.length > 0) {
                                let theDlg = Vue.$showDialog({
                                    title: '请您确认是否继续保存合同',
                                    width: 500,
                                    height: 250,
                                    showCloseBtn: true,
                                    template: '<div class="simple-form">' +
                                        '   <div v-for="msg in msgList">' +
                                        '      <span>{{ msg }}</span>' +
                                        '   </div>' +
                                        '</div>',
                                    data: {
                                        msgList: msgList
                                    },
                                    okClicked: function () {
                                        self.registContract(postData, path);
                                        return true;
                                    }
                                });
                            } else {
                                self.registContract(postData, path);
                            }
                        });
                    } else {
                        self.registContract(postData, path);
                    }
                }
            },
            modifyContract: function (postData, path) {
                let self = this;
                let theLoad = MsgBox.loading('数据修改中.....');
                contractApi.updateContractInfo(postData, function (result) {
                    if (result.type == 'info') {
                        MsgBox.success('修改成功');
                        self.$router.push({
                            query: {
                                currentRealComId: self.selectRealComId,
                            },
                            path: path
                        });
                        // RouteLayerMgr.popLayer(path, true);
                    } else {
                        MsgBox.warning(result.message);
                    }
                    theLoad.hide();
                });
            },
            getCheckContractGoodsUkInfo: function (postData, callbackFunc) {
                let theLoad = MsgBox.loading();
                contractApi.getCheckContractGoodsUkInfo(postData, function (result) {
                    if (result.type == 'info') {
                        callbackFunc(result.data || [])
                    } else {
                        MsgBox.warning(result.message);
                    }
                    theLoad.hide();
                });
            },
            registContract: function (postData, path) {
                let self = this;
                if (self.warnContractServcFlag || self.warnContractServc2Flag) {
                    self.$confirm((self.warnContractServcFlag ? '维保分组' : '常规服务') + '已存在，是否继续创建吗', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(function () {
                        let theLoad = MsgBox.loading('数据登记中.....');
                        contractApi.registContract(postData, function (result) {
                            if (result.type == 'info') {
                                MsgBox.success('登记成功');
                                self.$router.push({
                                    query: {
                                        currentRealComId: self.selectRealComId,
                                    },
                                    path: path
                                });
                                // RouteLayerMgr.popLayer(path, true);
                            } else {
                                MsgBox.warning(result.message);
                            }
                            theLoad.hide();
                        });
                    }).catch(function () {
                    });
                } else {
                    let theLoad = MsgBox.loading('数据登记中.....');
                    contractApi.registContract(postData, function (result) {
                        if (result.type == 'info') {
                            MsgBox.success('登记成功');
                            self.$router.push({
                                query: {
                                    currentRealComId: self.selectRealComId,
                                },
                                path: path
                            });
                            // RouteLayerMgr.popLayer(path, true);
                        } else {
                            MsgBox.warning(result.message);
                        }
                        theLoad.hide();
                    });
                }
            },
            // 费用信息
            saveContractFeeItem: function (row, index) {
                let self = this;
                let title = Utils.isNoB(row) ? '新增' : '修改';
                row = Utils.isNoB(row) ? {} : row;
                //
                let purchFeeTypeList = getEnumList('purchFeeType');
                let purchFeeTypes = [];
                for (let i = 0; i < purchFeeTypeList.length; i++) {
                    let purchFeeType = purchFeeTypeList[i];
                    purchFeeTypes.push({'label': purchFeeType.text, 'value': purchFeeType.value});
                }
                let theDlg = Vue.$showDialog({
                    title: title + '费用信息',
                    showCloseBtn: true,
                    width: 600,
                    height: 500,
                    template: '<swb-prop-editor ref="prop_editor" :title="editorTitle" :noGrid="true" :showBtnBar="false" :width="430" :widthForLabel="120" :propList="propList" :viewMode="false" :readOnly="false"></swb-prop-editor>',
                    data: {
                        editorTitle: '',
                        propList: [{
                            label: '费用类型', code: 'feeType', inputType: 'Single', value: row.feeType, valueType: 'Integer', tooltip: '', maxLength: 15,
                            required: true, dataList: purchFeeTypes, asDropdown: true, width: 300
                        }, {
                            label: '名称', code: 'name', value: row.name, valueType: 'String', tooltip: '', maxLength: 60, required: true, width: 300
                        }, {
                            label: '品牌', code: 'brandName', value: row.brandName, valueType: 'String', tooltip: '', maxLength: 30, required: true, width: 300
                        }, {
                            label: '规格', code: 'modelSpec', value: row.modelSpec, valueType: 'String', tooltip: '', maxLength: 60, required: false, width: 300
                        }, {
                            label: '单位', code: 'unit', value: row.unit, valueType: 'String', tooltip: '', maxLength: 5, required: true, width: 300
                        }, {
                            label: '单价(元)', code: 'price', inputType: 'Num', value: row.price, valueType: 'Float', tooltip: '', maxLength: 15, required: true,
                            width: 300
                        }]
                    },
                    okClicked: function () {
                        let propEditor = this.$refs['prop_editor'];
                        if (propEditor.validate()) {
                            let contractFeeItem = propEditor.getPropValues();
                            //
                            let contractInfo = self.contract || {};
                            let contractFeeItemList = contractInfo.contractFeeItemList || [];
                            if (Utils.isNoB(index)) {
                                contractFeeItemList.push(contractFeeItem);
                            } else {
                                let currentContractFeeItem = contractFeeItemList[index];
                                //
                                contractFeeItem.id = currentContractFeeItem.id;
                                contractFeeItemList[index] = Utils.merge({}, contractFeeItem);
                            }
                            contractInfo.contractFeeItemList = Utils.merge([], contractFeeItemList);
                            self.contract = Utils.merge({}, contractInfo);
                            return true;
                        } else {
                            return false;
                        }
                    }
                });
            },
            removeContractFeeItem: function (index) {
                let contractInfo = this.contract || {};
                //
                let contractFeeItemList = contractInfo.contractFeeItemList || [];
                contractFeeItemList.splice(index, 1);
                //
                contractInfo.contractFeeItemList = Utils.merge([], contractFeeItemList);
                this.contract = Utils.merge({}, contractInfo);
            },
            //
            getContractById: function (contractId, callback) {
                let self = this;
                let postData = {};
                postData.id = contractId;
                let theLoad = MsgBox.loading();
                contractApi.getContractInfo(postData, function (result) {
                    theLoad.hide();
                    if (result.type == 'info') {
                        let contract = result.data;
                        //
                        if (contract.contractDigest == null) {
                            contract.contractDigest = {content: null};
                        }
                        let operation = self.operateContract;
                        if (operation != 'chakan') {
                            // contract.dirty = true;
                        }
                        // if (operation == 'change') {
                        //     contract.fstPartyHtBh = null;
                        // }
                        if (contract.srcWinId != null || contract.srcWinId != null) {
                            self.disabledBtn = true;
                        } else {
                            self.disabledBtn = false;
                        }
                        //
                        contract.taxRate = Utils.isNoB(contract.taxRate) ? 0.00 : parseFloat(contract.taxRate).toFixed(2);
                        let contractGoodsList = contract.contractGoodsList;
                        for (let i = 0; i < contractGoodsList.length; i++) {
                            let item = contractGoodsList[i];
                            let taxRate = item.taxRate;
                            if (Utils.isNoB(taxRate)) {
                                taxRate = 0.00;
                                item.ntxPrice = Utils.isNoB(item.price) ? 0.00 : parseFloat(item.price).toFixed(2);
                            } else {
                                taxRate = parseFloat(taxRate).toFixed(2);
                                if (Utils.isNoB(item.price)) {
                                    item.ntxPrice = null;
                                } else {
                                    item.ntxPrice = (parseFloat(item.price) / (1 + (parseFloat(taxRate) * 0.01))).toFixed(2);
                                }
                            }
                            item.taxRate = taxRate;
                            item.price = Utils.isNoB(item.price) ? 0.00 : parseFloat(item.price).toFixed(2);
                            item.amount = Utils.isNoB(item.amount) ? 0.00 : parseFloat(item.amount).toFixed(2);
                            //
                            let bizFormNames = item.bizFormNames;
                            if (!Utils.isNoB(bizFormNames)) {
                                let bizFormNameList = [];
                                if (!Utils.isNoB(bizFormNames)) {
                                    if (bizFormNames.indexOf('|') >= 0) {
                                        bizFormNames = bizFormNames.substring(1, bizFormNames.length - 1);
                                        bizFormNameList = bizFormNames.split('|') || [];
                                    }
                                }
                                item.bizFormNameList = bizFormNameList;
                            }
                        }
                        contract.contractGoodsList = Utils.merge([], contractGoodsList);
                        // 付款阶段
                        let acntPeriodForm = contract.acntPeriodForm;
                        let contractPhasedPaySettingList = contract.contractPhasedPaySettingList || [];
                        if (contractPhasedPaySettingList.length > 0) {
                            let index = null;
                            let phaseName = '';
                            let rowFlag = '';
                            for (let i = 0; i < contractPhasedPaySettingList.length; i++) {
                                let contractPhasedPaySetting = contractPhasedPaySettingList[i];
                                contractPhasedPaySetting.originalPhaseName = contractPhasedPaySetting.phaseName;
                                if (acntPeriodForm == 1) {
                                    // 账期
                                    let acntPeriodDays = contractPhasedPaySetting.acntPeriodDays;
                                    if (parseInt(acntPeriodDays) == 0) {
                                        contractPhasedPaySetting.acntPeriodDays = null;
                                    }
                                } else if (acntPeriodForm == 2) {
                                    // 阶段间隔天数
                                    let phaseGapDays = contractPhasedPaySetting.phaseGapDays;
                                    if (parseInt(phaseGapDays) == 0) {
                                        contractPhasedPaySetting.phaseGapDays = null;
                                    }
                                }
                                if (i == 0) {
                                    contractPhasedPaySetting.rowspanNum = 1;
                                    contractPhasedPaySetting.showPhaseNameAndPhaseType = true;
                                    contractPhasedPaySetting.rowFlag = 'row' + i;
                                    phaseName = contractPhasedPaySetting.phaseName;
                                    rowFlag = contractPhasedPaySetting.rowFlag;
                                    index = i;
                                } else {
                                    if (phaseName == contractPhasedPaySetting.phaseName) {
                                        contractPhasedPaySettingList[index].rowspanNum += 1;
                                        contractPhasedPaySetting.rowspanNum = 1;
                                        contractPhasedPaySetting.showPhaseNameAndPhaseType = false;
                                        contractPhasedPaySetting.rowFlag = rowFlag;
                                    } else {
                                        contractPhasedPaySetting.rowspanNum = 1;
                                        contractPhasedPaySetting.showPhaseNameAndPhaseType = true;
                                        contractPhasedPaySetting.rowFlag = 'row' + i;
                                        phaseName = contractPhasedPaySetting.phaseName;
                                        rowFlag = contractPhasedPaySetting.rowFlag;
                                        index = i;
                                    }
                                }
                            }
                            contract.contractPhasedPaySettingList = Utils.merge([], contractPhasedPaySettingList);
                        }
                        //
                        if (!Utils.isNoB(contract.estmtAmount)) {
                            contract.estmtAmount = parseFloat(contract.estmtAmount).toFixed(2);
                        }
                        self.contract = Utils.merge({}, contract);

                        let contractTermList = self.contract.contractTermList;
                        if (contractTermList != null && contractTermList.length > 0) {
                            self.comparedTradeRuleList = contractTermList;
                            self.$refs.swb_create_trade_rule.getTradeRule();
                        }
                        if (contract.version > 1) {
                            self.getPrevContract(contract.prevNo);
                        }
                        if (!Utils.isNoB(contract.servcType)) {
                            self.servcType = contract.servcType;
                        }

                        self.showUpload = true;
                        self.getInvoiceContentTagList(true);
                        self.setGoodsAndServcAmount();
                    }
                    callback();
                });
            },
            getPrevContract: function (no) {
                let self = this;
                let postData = {};
                postData.no = no;
                //
                contractApi.getContractInfo(postData, function (result) {
                    if (result.type == 'info') {
                        self.prevChangeContract = result.data;
                    }
                });
            },
            showCallBidDocDlg: function () {
                let self = this;
                let type = null;
                if (self.contractType == self.goodsPurch.value) {
                    type = 'goods';
                }
                if (self.contractType == self.integPurch.value) {
                    type = 'goodsAndServc';
                }
                Vue.$showDialog({
                    title: '招标书信息',
                    width: '75%',
                    height: 700,
                    showCloseBtn: true,
                    template: '<div>' +
                        '<swb-call-bid-doc-for-select :rowId = "rowId" :showSelect="showSelect" :type="type" :isAll="isAll" ref="swb_callBidDoc_select"></swb-call-bid-doc-for-select>' +
                        '</div>',
                    data: {
                        showSelect: true,
                        rowId: null,
                        type: type,
                        isAll: false
                    },
                    methods: {},
                    okClicked: function () {
                        let selfDlg = this;
                        let result = selfDlg.$refs.swb_callBidDoc_select.getDlgResult() || {};
                        if (result.type === 'info') {
                            let callBidDoc = result.data;
                            if (callBidDoc.winBidDocId != null) {
                                self.contract.srcId = callBidDoc.id;
                                self.contract.srcName = callBidDoc.title;
                                self.contract.srcWinId = callBidDoc.winBidDocId;
                                self.contract.srcFixed = true;
                                tendBidApi.getBidDocInfo(callBidDoc.winBidDocId, function (result) {
                                    if (result.type == 'info') {
                                        let bidDoc = result.data;
                                        self.contract.sndPartyId = bidDoc.merchantId;
                                        self.contract.sndPartyType = bidDoc.merchantType;
                                        self.contract.sndPartyName = bidDoc.merchantName;
                                        self.contract.estmtAmount = bidDoc.offerPrice;
                                        let sumQuantity = 0;
                                        let sumAmount = 0;
                                        if (self.contractType == self.goodsPurch.value || self.contractType == self.integPurch.value) {
                                            let bidGoodsList = bidDoc.bidGoodsList;
                                            let contractGoodsList = self.contract.contractGoodsList;
                                            contractGoodsList = [];
                                            if (bidGoodsList != null && bidGoodsList.length > 0) {
                                                for (let i = 0; i < bidGoodsList.length; i++) {
                                                    let bidGood = bidGoodsList[i];
                                                    let item = {};
                                                    item.skuId = bidGood.skuId;
                                                    item.name = bidGood.name;
                                                    item.goodsId = bidGood.goodsId;
                                                    item.brandId = bidGood.brandId;
                                                    item.brandName = bidGood.brandName;
                                                    item.wrntPeriod = bidGood.wrntPeriod;
                                                    item.unit = bidGood.callUnit;
                                                    item.price = bidGood.price;
                                                    item.quantity = bidGood.callQuantity;
                                                    if (bidGood.callQuantity != null) {
                                                        sumQuantity += bidGood.callQuantity;
                                                    }
                                                    if (bidGood.price != null && bidGood.callQuantity != null) {
                                                        sumAmount += bidGood.callQuantity * bidGood.price;
                                                    }

                                                    item.fileBrowseUrl = bidGood.skuDefaultImageUrl;

                                                    contractGoodsList.push(item);
                                                }
                                            }
                                            self.contract.estmtGoodsCount = sumQuantity;
                                            self.contract.goodsFlag = true;
                                            self.contract.contractGoodsList = Utils.merge([], contractGoodsList);
                                        }
                                        if (self.contractType == self.integPurch.value || self.contractType == self.servcPurch.value) {
                                            let bidServcList = bidDoc.bidServcList;
                                            let contractServcList = self.contract.contractServcList;
                                            contractServcList = [];
                                            if (bidServcList != null && bidServcList.length > 0) {
                                                for (let i = 0; i < bidServcList.length; i++) {
                                                    let bidServc = bidServcList[i];
                                                    let item = {};
                                                    item.ssuId = bidServc.ssuId;
                                                    item.name = bidServc.name;
                                                    item.servcId = bidServc.servcId;
                                                    item.wrntPeriod = bidServc.wrntPeriod;
                                                    item.price = bidServc.price;
                                                    item.dateStart = null;
                                                    item.dateEnd = null;

                                                    contractServcList.push(item);
                                                }
                                            }
                                            self.contract.servcFlag = true;
                                            self.contract.contractServcList = Utils.merge([], contractServcList);
                                        }
                                        self.contract.estmtAmount = parseFloat(sumAmount || 0).toFixed(2);
                                        self.contract.invoiceType = null;
                                        self.contract.invoiceTitle = null;
                                        self.contract.taxPayerNo = null;
                                        self.disabledBtn = true;
                                        self.showAmtAndCot = false;
                                        self.getInvoiceContentTagList();
                                    }
                                    return true;
                                });

                                //获取中标书的交易规则
                                let postData = {};
                                postData.docId = callBidDoc.winBidDocId;
                                tendBidApi.getBidTermList(postData, function (result) {
                                    if (result.type == 'info') {
                                        let bidTermList = result.data;
                                        if (bidTermList != null && bidTermList.length > 0) {
                                            self.comparedTradeRuleList = bidTermList;
                                            self.tradeType = 'bid';
                                            self.forBid = true;
                                            self.$refs.swb_create_trade_rule.getTradeRule();
                                        }
                                    }
                                });
                            }
                        }
                    },
                    lifecycle: {
                        created: function () {
                            let selfDlg = this;
                            selfDlg.rowId = self.contract.srcId;
                        }
                    }
                });
            },
            deleteCall: function () {
                let contract = this.contract;
                contract.srcId = null;
                contract.srcName = null;
                contract.srcWinId = null;
                contract.srcFixed = null;
                contract.contractServcList = [];
                contract.contractGoodsList = [];
                contract.sndPartyId = null;
                contract.sndPartyName = null;
                contract.estmtAmount = null;
                contract.estmtGoodsCount = null;
                contract.servcAmountFixed = false;
                contract.totalServcAmount = null;
                this.showAmtAndCot = true;
                this.disabledBtn = false;
                this.showBtn = false;
                this.comparedTradeRuleList = null;
                this.tradeType = null;
                this.forBid = null;
                this.$refs.swb_create_trade_rule.getTradeRule();
                contract.invoiceType = null;
                contract.invoiceTitle = null;
                contract.taxPayerNo = null;
                //contract.invoiceContentTag = null;
                this.invoiceContentTagList = [];
                this.contract = Utils.merge({}, contract);
            },
            showPriceReplyDocDlg: function () {
                let self = this;
                Vue.$showDialog({
                    title: '报价单信息',
                    width: '75%',
                    height: 700,
                    showCloseBtn: true,
                    template: '<div>' +
                        '<swb-price-reply-for-select :merchantId="merchantId" :merchantType="merchantType" :inqryMerchantId="inqryMerchantId" :inqryMerchantType="inqryMerchantType" :rowId = "rowId" ref="swb_price_reply_for_select"></swb-price-reply-for-select>' +
                        '</div>',
                    data: {
                        merchantId: null,
                        merchantType: null,
                        inqryMerchantId: null,
                        inqryMerchantType: null,
                        rowId: null
                    },
                    methods: {},
                    okClicked: function () {
                        let selfDlg = this;
                        let result = selfDlg.$refs.swb_price_reply_for_select.getDlgResult() || {};
                        if (result.type === 'info') {
                            let checkPriceReply = result.data;
                            if (checkPriceReply.id != null) {
                                self.contract.srcWinId = checkPriceReply.id;
                                self.contract.srcName = checkPriceReply.inqryTitle;
                                self.contract.srcId = checkPriceReply.inqryVoucherId;
                                self.contract.srcFixed = true;
                                let sumQuantity = 0;
                                let sumAmount = 0;
                                if (self.contractType == self.goodsPurch.value) {
                                    let goodsList = checkPriceReply.goodsList;
                                    let contractGoodsList = self.contract.contractGoodsList;
                                    contractGoodsList = [];
                                    if (goodsList != null && goodsList.length > 0) {
                                        for (let i = 0; i < goodsList.length; i++) {
                                            let goods = goodsList[i];
                                            let item = {};
                                            item.skuId = goods.skuId;
                                            item.name = goods.name;
                                            item.goodsId = goods.goodsId;
                                            item.brandId = goods.brandId;
                                            item.brandName = goods.brandName;
                                            item.wrntPeriod = goods.replyWrntPeriod;
                                            item.unit = goods.unit;
                                            item.price = ParseFloat(goods.replyPrice);
                                            item.quantity = goods.quantity;
                                            if (goods.quantity != null) {
                                                sumQuantity += goods.quantity;
                                            }
                                            if (goods.replyPrice != null && goods.quantity != null) {
                                                sumAmount += goods.quantity * goods.replyPrice;
                                            }

                                            contractGoodsList.push(item);
                                        }
                                    }

                                    self.contract.estmtGoodsCount = sumQuantity;
                                    self.contract.goodsFlag = true;
                                    self.contract.contractGoodsList = Utils.merge([], contractGoodsList);
                                }
                                if (self.contractType == self.servcPurch.value) {
                                    let servcList = checkPriceReply.servcList;
                                    let contractServcList = self.contract.contractServcList;
                                    contractServcList = [];
                                    if (servcList != null && servcList.length > 0) {
                                        for (var i = 0; i < servcList.length; i++) {
                                            let servc = servcList[i];
                                            let item = {};
                                            item.ssuId = servc.ssuId;
                                            item.name = servc.name;
                                            item.servcId = servc.servcId;
                                            //item.wrntPeriod = servc.wrntPeriod;
                                            item.price = ParseFloat(servc.replyPrice);
                                            item.dateStart = null;
                                            item.dateEnd = null;

                                            contractServcList.push(item);
                                        }
                                    }
                                    self.contract.servcFlag = true;
                                    self.contract.contractServcList = Utils.merge([], contractServcList);
                                }
                                self.contract.estmtAmount = sumAmount;
                                self.disabledBtn = true;
                                self.showAmtAndCot = false;

                                //获取交易规则
                                let postData = {};
                                postData.voucherId = checkPriceReply.id;
                                priceApi.getPriceReplyTermList(postData, function (result) {
                                    if (result.type == 'info') {
                                        let priceReplyTermList = result.data;
                                        if (priceReplyTermList != null && priceReplyTermList.length > 0) {
                                            self.comparedTradeRuleList = priceReplyTermList;
                                            self.tradeType = 'priceReply';
                                            self.forPriceInqry = true;
                                            self.$refs.swb_create_trade_rule.getTradeRule();
                                        }
                                    }
                                });
                                return true;
                            }
                        }
                    },
                    lifecycle: {
                        created: function () {
                            let selfDlg = this;
                            selfDlg.rowId = self.contract.srcWinId;
                            selfDlg.merchantId = self.contract.sndPartyId;
                            selfDlg.merchantType = self.contract.sndPartyType;
                            selfDlg.inqryMerchantId = self.contract.fstPartyId;
                            selfDlg.inqryMerchantType = self.contract.fstPartyType;
                        }
                    }
                });
            },
            deletePrice: function () {
                let contract = this.contract;
                contract.srcWinId = null;
                contract.srcName = null;
                contract.srcId = null;
                contract.srcFixed = null;
                contract.contractServcList = [];
                contract.contractGoodsList = [];
                contract.estmtAmount = null;
                contract.estmtGoodsCount = null;
                contract.servcAmountFixed = false;
                contract.totalServcAmount = null;
                this.showAmtAndCot = true;
                this.disabledBtn = false;
                this.showBtn = false;
                this.comparedTradeRuleList = null;
                this.tradeType = null;
                this.forPriceInqry = null;
                this.$refs.swb_create_trade_rule.getTradeRule();
                this.contract = Utils.merge({}, contract);
            },
            monitoringData: function () {
                let self = this;
                let type = self.contractType;
                Vue.$showDialog({
                    title: '合同数据监控',
                    width: '90%',
                    height: 700,
                    showCloseBtn: true,
                    okVisible: false,
                    cancelVisible: false,
                    template: '<div>' +
                        '<swb-contract-data-monitoring :contractId = "contractId" :contractNo = "contractNo" :contractType="type" ref="swb_contract_data_monitoring"></swb-contract-data-monitoring>' +
                        '</div>',
                    data: {
                        contractId: null,
                        contractNo: null,
                        type: null
                    },
                    methods: {},
                    okClicked: function () {

                    },
                    lifecycle: {
                        created: function () {
                            let selfDlg = this;
                            selfDlg.contractId = self.contract.id;
                            selfDlg.contractNo = self.contract.no;
                            selfDlg.type = type;
                        }
                    }
                });
            },
            showContractRecord: function () {
                let self = this;
                Vue.$showDialog({
                    title: '合同操作记录',
                    width: '90%',
                    height: '80%',
                    showCloseBtn: true,
                    okVisible: false,
                    cancelVisible: false,
                    template: '<swb-contract-record-list :contractId="contractId" :contractNo="contractNo" ref="swb_contract_record_list"></swb-contract-record-list>',
                    data: {
                        contractId: self.contract.id,
                        contractNo: self.contract.no
                    }
                });
            },
            // 预付功能
            doPayPre(row) {
                let self = this;
                let params = {
                    title: '合同金额 - 预付',
                    doPrePay: true,
                    showBtn: true,
                    payPreFilter: {
                        contractId: row.id,
                        contractNo: row.no,
                        sellerRealComId: row.sndPartyRealComId,
                        buyerRealComId: row.fstPartyRealComId,
                        payPhaseTplId: row.payPhaseTplId,
                        amount: parseFloat(row.estmtAmount || 0)
                    },
                    filter: {
                        contractNo: row.no,
                        lockMode: row.lockMode
                    },
                    parentSelf: self,
                    parentPath: self.path
                };
                showPayVoucherListForSelectDlg(params, function (refresh) {
                });
            },
            toTradeVoucherList: function () {
                let no = this.contract.no;
                let data = {contractNo: no};
                let hashUrl = Utils.makeUrl('/trade/voucher/list', data);
                appConf.openPageRouteUrl(null, '/bench/home', hashUrl);
            },
            toPayVoucherList: function () {
                let id = this.contract.id;
                let srcVoucherType = getEnumInfoWith("srcVoucherType", "name", "Contract").value;
                let query = {srcVoucherType: srcVoucherType, srcVoucherId: id};
                showRouteLayer({
                    title: '付款明细',
                    query: query,
                    template: SwbPayVoucherList
                });
            },
            // 合同类型
            kindChange(kindId) {
                let self = this;
                if (kindId == 0) {
                    this.contract.settleCrossOrderAllowed = false;   // 标准合同默认：false
                    this.contract.phaseFlag = true;
                    this.contract.termsFlag = true;
                    // 标准合同获取对应的实体公司的业务参数
                    getMerchantBizParam('asset.finac.enabled', function (result) {
                        self.normalFlag = Utils.isTrue(result);
                    }, 2, null, self.selectRealComId);
                } else {
                    this.contract.settleCrossOrderAllowed = true;   // 框架合同默认：true
                    this.contract.phaseFlag = false;
                    this.contract.termsFlag = false;
                    //
                    getMerchantBizParam('finac.mgmt.enabled', function (result) {
                        self.normalFlag = Utils.isTrue(result);
                    }, 0);
                }
                this.settleChange(this.contract.settleCrossOrderAllowed);
                //
                let contractGoodsList = this.contract.contractGoodsList || [];
                if (contractGoodsList.length <= 0) {
                    if (kindId == 0) {
                        this.contract.bizAreaFlag = false;
                    } else {
                        this.contract.bizAreaFlag = true;
                    }
                }
            },
            //是否跨订单结算
            settleChange: function (settleCrossOrderAllowed) {
                if (!Utils.isNoB(this.contract.kindId) && this.contract.kindId == 0) {
                    if (settleCrossOrderAllowed) {
                        this.contract.phaseFlag = false;
                    } else {
                        this.contract.phaseFlag = true;
                    }
                }
            },
            // 启用区域价格
            bizAreaFlagChange: function (index) {
                //
                let contract = this.contract || {};
                let contractGoodsList = contract.contractGoodsList || [];
                if (!Utils.isNoB(index)) {
                    let bizAreaFlag = false;
                    for (let i = 0; i < contractGoodsList.length; i++) {
                        let contractGoods = contractGoodsList[i];
                        if (Utils.isTrue(contractGoods.bizAreaFlag)) {
                            bizAreaFlag = true;
                        }
                    }
                    contract.bizAreaFlag = bizAreaFlag;
                } else {
                    for (let i = 0; i < contractGoodsList.length; i++) {
                        let contractGoods = contractGoodsList[i];
                        contractGoods.bizAreaFlag = contract.bizAreaFlag;
                    }
                }
                //
                contract.contractGoodsList = Utils.merge([], contractGoodsList);
                this.contract = Utils.merge({}, contract);
            },
            // 付款账期形式校验
            acntPeriodFormChange: function () {
                let contract = this.contract || {};
                let acntPeriodForm = contract.acntPeriodForm;
                let contractPhasedPaySettingList = contract.contractPhasedPaySettingList || [];
                for (let i = 0; i < contractPhasedPaySettingList.length; i++) {
                    let contractPhasedPaySetting = contractPhasedPaySettingList[i];
                    if (acntPeriodForm == 1) {
                        // 账期
                        let acntPeriodDays = contractPhasedPaySetting.acntPeriodDays;
                        if (parseInt(acntPeriodDays) == 0) {
                            contractPhasedPaySetting.acntPeriodDays = null;
                        }
                    } else if (acntPeriodForm == 2) {
                        // 阶段间隔天数
                        let phaseGapDays = contractPhasedPaySetting.phaseGapDays;
                        if (parseInt(phaseGapDays) == 0) {
                            contractPhasedPaySetting.phaseGapDays = null;
                        }
                    }
                }
                //
                contract.contractPhasedPaySettingList = Utils.merge([], contractPhasedPaySettingList);
                this.contract = Utils.merge({}, contract);
            },
            // 阶段名称
            phaseNameChange: function (index) {
                let contract = this.contract || {};
                let contractPhasedPaySettingList = contract.contractPhasedPaySettingList || [];
                let contractPhasedPaySetting = contractPhasedPaySettingList[index];
                let phaseName = contractPhasedPaySetting.phaseName;
                let originalPhaseName = contractPhasedPaySetting.originalPhaseName;
                if (!Utils.isNoB(phaseName)) {
                    if (phaseName.length > 30) {
                        MsgBox.warning('阶段名称最多可输入30个字！');
                        contractPhasedPaySetting.phaseName = null;
                    } else {
                        for (let i = 0; i < contractPhasedPaySettingList.length; i++) {
                            let phasedPaySetting = contractPhasedPaySettingList[i];
                            let phaseNameX = phasedPaySetting.phaseName;
                            if (i != index && phaseNameX == phaseName && phasedPaySetting.rowFlag != contractPhasedPaySetting.rowFlag && Utils.isTrue(phasedPaySetting.showPhaseNameAndPhaseType)) {
                                MsgBox.warning('已存在相同的阶段名称，请重新输入！');
                                contractPhasedPaySetting.phaseName = null;
                                break;
                            }
                        }
                    }
                    if (Utils.isNoB(contractPhasedPaySetting.id) && !Utils.isNoB(contractPhasedPaySetting.phaseName)) {
                        contractPhasedPaySetting.originalPhaseName = contractPhasedPaySetting.phaseName;
                    } else if (Utils.isNoB(contractPhasedPaySetting.phaseName)) {
                        contractPhasedPaySetting.phaseName = originalPhaseName;
                    }
                    for (let i = 0; i < contractPhasedPaySettingList.length; i++) {
                        let phasedPaySetting = contractPhasedPaySettingList[i];
                        if (i != index && phasedPaySetting.rowFlag == contractPhasedPaySetting.rowFlag && !Utils.isTrue(phasedPaySetting.showPhaseNameAndPhaseType)) {
                            phasedPaySetting.phaseName = contractPhasedPaySetting.phaseName;
                        }
                    }
                    //
                    contract.contractPhasedPaySettingList = Utils.merge([], contractPhasedPaySettingList);
                    this.contract = Utils.merge({}, contract);
                }
            },
            // 阶段类型
            phaseTypeChange: function (index) {
                let contract = this.contract || {};
                let contractPhasedPaySettingList = contract.contractPhasedPaySettingList || [];
                let contractPhasedPaySetting = contractPhasedPaySettingList[index];
                let phaseType = contractPhasedPaySetting.phaseType;
                let payPhaseType = getEnumInfoWith('payPhaseType', 'name', 'FinalPayment');
                for (let i = 0; i < contractPhasedPaySettingList.length; i++) {
                    let phasedPaySetting = contractPhasedPaySettingList[i];
                    if (index < i && phaseType == payPhaseType.value && phasedPaySetting.rowFlag != contractPhasedPaySetting.rowFlag) {
                        MsgBox.warning('阶段类型[尾款]只能设置在最后一行，请重新设置！');
                        contractPhasedPaySetting.phaseType = null;
                        break;
                    }
                    if (i != index && phaseType == payPhaseType.value && phasedPaySetting.phaseType == payPhaseType.value && phasedPaySetting.rowFlag != contractPhasedPaySetting.rowFlag) {
                        MsgBox.warning('已存在阶段类型为[' + payPhaseType.text + ']，请重新选择阶段类型！');
                        contractPhasedPaySetting.phaseType = null;
                        break;
                    }
                    if (i != index && phasedPaySetting.rowFlag == contractPhasedPaySetting.rowFlag) {
                        phasedPaySetting.phaseType = phaseType;
                    }
                }
                //
                contract.contractPhasedPaySettingList = Utils.merge([], contractPhasedPaySettingList);
                this.contract = Utils.merge({}, contract);
            },
            // 付款比例
            ratioChange: function (index) {
                let contract = this.contract || {};
                let contractPhasedPaySettingList = contract.contractPhasedPaySettingList || [];
                let contractPhasedPaySetting = contractPhasedPaySettingList[index];
                let ratio = contractPhasedPaySetting.ratio;
                if (!Utils.isNoB(ratio)) {
                    if (Utils.isNumStr(ratio)) {
                        if (parseFloat(ratio) <= 0) {
                            MsgBox.warning('付款比例(%)必须是大于0小于等于100的数字！');
                            contractPhasedPaySetting.ratio = null;
                        } else {
                            let ratioVal = 0;
                            for (let i = 0; i < contractPhasedPaySettingList.length; i++) {
                                let phasedPaySetting = contractPhasedPaySettingList[i];
                                if (phasedPaySetting.ratio != null) {
                                    phasedPaySetting.ratio = parseFloat(phasedPaySetting.ratio);
                                    ratioVal += parseFloat(phasedPaySetting.ratio);
                                }
                            }
                            if (ratioVal > 100) {
                                MsgBox.warning('付款比例(%)总和不能超过100%！');
                            } else {
                                contractPhasedPaySetting.ratio = parseFloat(ratio);
                            }
                        }
                    } else {
                        MsgBox.warning('付款比例(%)只能是数字！');
                        contractPhasedPaySetting.ratio = null;
                    }
                    //
                    contract.contractPhasedPaySettingList = Utils.merge([], contractPhasedPaySettingList);
                    this.contract = Utils.merge({}, contract);
                }
            },
            acntPeriodBasisChange(index){
                let contract = this.contract || {};
                let contractPhasedPaySettingList = contract.contractPhasedPaySettingList || [];
                let contractPhasedPaySetting = contractPhasedPaySettingList[index];
                for (let i = 0; i < contractPhasedPaySettingList.length; i++) {
                    let phasedPaySetting = contractPhasedPaySettingList[i];
                    if (i != index && phasedPaySetting.rowFlag == contractPhasedPaySetting.rowFlag) {
                        phasedPaySetting.acntPeriodBasis = contractPhasedPaySetting.acntPeriodBasis;
                    }
                }
                //
                contract.contractPhasedPaySettingList = Utils.merge([], contractPhasedPaySettingList);
                this.contract = Utils.merge({}, contract);
            },
            // 账期
            acntPeriodDaysChange: function (index) {
                let contract = this.contract || {};
                let contractPhasedPaySettingList = contract.contractPhasedPaySettingList || [];
                let contractPhasedPaySetting = contractPhasedPaySettingList[index];
                let acntPeriodDays = contractPhasedPaySetting.acntPeriodDays;
                if (!Utils.isNoB(acntPeriodDays)) {
                    if (Utils.isIntStr(acntPeriodDays)) {
                        if (parseInt(acntPeriodDays) <= 0) {
                            MsgBox.warning('账期(天)只能是正整数！');
                            contractPhasedPaySetting.acntPeriodDays = null;
                        } else {
                            contractPhasedPaySetting.acntPeriodDays = acntPeriodDays;
                        }
                    } else {
                        MsgBox.warning('账期(天)只能是正整数！');
                        contractPhasedPaySetting.acntPeriodDays = null;
                    }
                    for (let i = 0; i < contractPhasedPaySettingList.length; i++) {
                        let phasedPaySetting = contractPhasedPaySettingList[i];
                        if (i != index && phasedPaySetting.rowFlag == contractPhasedPaySetting.rowFlag) {
                            phasedPaySetting.acntPeriodDays = contractPhasedPaySetting.acntPeriodDays;
                        }
                    }
                    //
                    contract.contractPhasedPaySettingList = Utils.merge([], contractPhasedPaySettingList);
                    this.contract = Utils.merge({}, contract);
                }
            },
            // 支付方式
            payMethodChange: function (index) {
                let contract = this.contract || {};
                let contractPhasedPaySettingList = contract.contractPhasedPaySettingList || [];
                let contractPhasedPaySetting = contractPhasedPaySettingList[index];
                let payMethod = contractPhasedPaySetting.payMethod;
                for (let i = 0; i < contractPhasedPaySettingList.length; i++) {
                    let phasedPaySetting = contractPhasedPaySettingList[i];
                    if (i != index && phasedPaySetting.rowFlag == contractPhasedPaySetting.rowFlag && payMethod == phasedPaySetting.payMethod) {
                        MsgBox.warning('同一个阶段不能存在重复的支付方式！');
                        contractPhasedPaySetting.payMethod = null;
                        break;
                    }
                }
                //
                contract.contractPhasedPaySettingList = Utils.merge([], contractPhasedPaySettingList);
                this.contract = Utils.merge({}, contract);
            },
            // 当期阶段间隔天数
            phaseGapDaysChange: function (index) {
                let contract = this.contract || {};
                let contractPhasedPaySettingList = contract.contractPhasedPaySettingList || [];
                let contractPhasedPaySetting = contractPhasedPaySettingList[index];
                let phaseGapDays = contractPhasedPaySetting.phaseGapDays;
                if (!Utils.isNoB(phaseGapDays)) {
                    if (Utils.isIntStr(phaseGapDays)) {
                        if (parseInt(phaseGapDays) <= 0) {
                            MsgBox.warning('当期阶段间隔天数只能是正整数！');
                            contractPhasedPaySetting.phaseGapDays = null;
                        } else {
                            contractPhasedPaySetting.phaseGapDays = phaseGapDays;
                        }
                    } else {
                        MsgBox.warning('当期阶段间隔天数只能是正整数！');
                        contractPhasedPaySetting.phaseGapDays = null;
                    }
                    for (let i = 0; i < contractPhasedPaySettingList.length; i++) {
                        let phasedPaySetting = contractPhasedPaySettingList[i];
                        if (i != index && phasedPaySetting.rowFlag == contractPhasedPaySetting.rowFlag) {
                            phasedPaySetting.phaseGapDays = contractPhasedPaySetting.phaseGapDays;
                        }
                    }
                    //
                    contract.contractPhasedPaySettingList = Utils.merge([], contractPhasedPaySettingList);
                    this.contract = Utils.merge({}, contract);
                }
            },
            // 添加阶段
            addContractPhasedPaySetting: function () {
                let contract = this.contract || {};
                let contractPhasedPaySettingList = contract.contractPhasedPaySettingList || [];
                //
                if(contractPhasedPaySettingList.length > 0) {
                    let lastContractPhasedPaySetting = contractPhasedPaySettingList[contractPhasedPaySettingList.length - 1];
                    if (lastContractPhasedPaySetting.phaseType === this.payPhaseTypeFinalPayment) {
                        MsgBox.warning('阶段类型[尾款]后，不能再添加阶段！');
                        return;
                    }
                }
                //
                let contractPhasedPaySetting = {
                    phaseName: null,
                    phaseType: null, // getEnumInfoWith('payPhaseType', 'name', 'StagePayment').value,
                    calcBasis: getEnumInfoWith('amtCalcMethod', 'name', 'ByPercent').value,
                    ratio: null,
                    acntPeriodBasis: null,
                    acntPeriodDays: null,
                    phaseGapDays: null,
                    payMethod: getEnumInfoWith('payMethod', 'name', 'Transfer').value,
                    rowspanNum: 1, // 合并行数
                    showPhaseNameAndPhaseType: true, // 新增加的行是否展示前两列，单据增加行的时候默认展示
                    rowFlag: 'row' + contractPhasedPaySettingList.length // 行标记，是一组的行标记相同
                };
                //
                contractPhasedPaySettingList.push(contractPhasedPaySetting);
                contract.contractPhasedPaySettingList = Utils.merge([], contractPhasedPaySettingList);
                this.contract = Utils.merge({}, contract);
            },
            // 增加付款次数
            addPaySetting: function (row, index) {
                let payMethodList = this.payMethodList || [];
                if (row.rowspanNum == payMethodList.length) {
                    MsgBox.warning('同一个阶段不能存在重复的支付方式！');
                    return;
                }
                let payMethod = row.payMethod;
                let payMethodTransfer = getEnumInfoWith('payMethod', 'name', 'Transfer').value;
                let payMethodAcceptanceBill = getEnumInfoWith('payMethod', 'name', 'AcceptanceBill').value;
                if (Utils.isNoB(payMethod)) {
                    payMethod = payMethodTransfer;
                } else if (payMethod == payMethodTransfer) {
                    payMethod = payMethodAcceptanceBill;
                } else if (payMethod == payMethodAcceptanceBill) {
                    payMethod = payMethodTransfer;
                }
                //
                let contractPhasedPaySetting = {
                    phaseName: row.phaseName,
                    phaseType: row.phaseType,
                    calcBasis: row.calcBasis,
                    ratio: null,
                    acntPeriodBasis: row.acntPeriodBasis,
                    acntPeriodDays: row.acntPeriodDays,
                    phaseGapDays: row.phaseGapDays,
                    payMethod: payMethod,
                    rowspanNum: 1, // 合并行数
                    showPhaseNameAndPhaseType: false, // 新增加的行是否展示前两列，默认不展示
                    rowFlag: row.rowFlag
                };
                //
                let contract = this.contract || {};
                let contractPhasedPaySettingList = contract.contractPhasedPaySettingList || [];
                let dataList = [];
                for (let i = 0; i < contractPhasedPaySettingList.length; i++) {
                    let item = contractPhasedPaySettingList[i];
                    if (i < index) {
                        dataList[i] = item;
                    } else if (i === index) {
                        item.rowspanNum += 1;
                        dataList[i] = item;
                        dataList[i + 1] = contractPhasedPaySetting;
                    } else if (i > index) {
                        dataList[i + 1] = item;
                    }
                }
                contract.contractPhasedPaySettingList = Utils.merge([], dataList);
                this.contract = Utils.merge({}, contract);
            },
            // 移除付款阶段
            removeContractPhasedPaySetting: function (index) {
                let contractInfo = this.contract || {};
                //
                let contractPhasedPaySettingList = contractInfo.contractPhasedPaySettingList || [];
                let contractPhasedPaySetting = contractPhasedPaySettingList[index];
                if (contractPhasedPaySetting.rowspanNum > 1) {
                    contractPhasedPaySettingList[index + 1].rowspanNum = contractPhasedPaySetting.rowspanNum - 1;
                    contractPhasedPaySettingList[index + 1].showPhaseNameAndPhaseType = true;
                } else {
                    let index_X = null;
                    for (let i = 0; i < contractPhasedPaySettingList.length; i++) {
                        let item = contractPhasedPaySettingList[i];
                        if (item.rowFlag == contractPhasedPaySetting.rowFlag && item.rowspanNum > 1) {
                            index_X = i;
                            break;
                        }
                    }
                    if (!Utils.isNoB(index_X)) {
                        contractPhasedPaySettingList[index_X].rowspanNum -= 1;
                    }
                }
                contractPhasedPaySettingList.splice(index, 1);
                // 重新计算rowFlag
                let preRow = null;
                for (let i = 0; i < contractPhasedPaySettingList.length; i++) {
                    if (preRow == null) {
                        contractPhasedPaySettingList[i].newRowFlag = 'row' + i;
                        preRow = contractPhasedPaySettingList[i];
                    } else if(preRow.rowFlag == contractPhasedPaySettingList[i].rowFlag){
                        contractPhasedPaySettingList[i].newRowFlag = preRow.newRowFlag;
                    } else {
                        contractPhasedPaySettingList[i].newRowFlag = 'row' + i;
                        preRow = contractPhasedPaySettingList[i];
                    }
                }
                for (let i = 0; i < contractPhasedPaySettingList.length; i++) {
                    contractPhasedPaySettingList[i].rowFlag = contractPhasedPaySettingList[i].newRowFlag;
                }
                //
                contractInfo.contractPhasedPaySettingList = Utils.merge([], contractPhasedPaySettingList);
                this.contract = Utils.merge({}, contractInfo);
            },
            setAsmblAcc(row, index) {
                if (!Utils.isNoB(row.assetDefId)) {
                    this.clearDevcDef(row, index, false);
                }
            },
            selectDevcDef: function (row, index) {
                let self = this;
                let contract = self.contract || {};
                let contractGoodsList = contract.contractGoodsList || [];
                //
                let devcDefIds = [];
                let accDefIds = [];
                for (let i = 0; i < contractGoodsList.length; i++) {
                    let contractGoods = contractGoodsList[i];
                    let assetDefId = contractGoods.assetDefId;
                    if (!Utils.isNoB(assetDefId) && assetDefId != -1) {
                        if (Utils.isTrue(contractGoods.asmblAccFlag)) {
                            if (!accDefIds.contains(assetDefId)) {
                                accDefIds.push(assetDefId)
                            }
                        } else {
                            if (!devcDefIds.contains(assetDefId)) {
                                devcDefIds.push(assetDefId)
                            }
                        }
                    }
                }
                //
                let assetDefId = row.assetDefId;
                if (row.asmblAccFlag) {
                    let checkIds = [];
                    if (!Utils.isNoB(assetDefId) && assetDefId != -1) {
                        checkIds.push(assetDefId)
                    }
                    showAsmblAccDefSelectDlg({
                        filter: {
                            vendorIdX: contract.sndPartyId,
                            queryOneAdoptedDevice: true // 查询一个入选商品
                        },
                        checkBox: false,
                        checkIds: checkIds,
                        needDisabled: true
                    }, function (devcDef, dlg) {
                        if (accDefIds.contains(devcDef.id) && row.assetDefId != devcDef.id) {
                            MsgBox.warning('商品信息中已包含该定义，请更换其他定义');
                            return;
                        }
                        dlg.close();
                        self.makeContractGoodsInfo(row, devcDef, contract);
                        self.contract.contractGoodsList = Utils.merge([], contractGoodsList);
                    });
                } else {
                    let selectIds = [];
                    if (!Utils.isNoB(assetDefId) && assetDefId != -1) {
                        selectIds.push(assetDefId)
                    }
                    showMerchtDevcDefSelectDlg({
                        catId: row.catId,
                        brandId: row.brandId,
                        modelSpec: row.shortSpec,
                        normalized: self.normalFlag,
                        selectIds: selectIds,
                        filter: {
                            vendorIdX: contract.sndPartyId,
                            purchFlag: Utils.isTrue(self.normalFlag) ? true : null,
                            queryOneAdoptedDevice: true // 查询一个入选商品
                        }
                    }, function (devcDef, dlg) {
                        if (devcDefIds.contains(devcDef.id) && row.assetDefId != devcDef.id) {
                            MsgBox.warning('商品信息中已包含该定义，请更换其他定义');
                            return;
                        }
                        dlg.close();
                        self.makeContractGoodsInfo(row, devcDef, contract);
                        self.contract.contractGoodsList = Utils.merge([], contractGoodsList);
                    });
                }
            },
            saveDevcDef: function (row, index) {
                let self = this;
                let contractGoodsList = self.contract.contractGoodsList || [];
                let brandId = row.brandId == null ? -1 : row.brandId;
                let devcDef = {};
                devcDef.name = row.title;
                devcDef.model = row.model;
                devcDef.fixedSpec = row.fixedSpec;
                devcDef.theUnit = row.unit;
                devcDef.catId = row.catId;
                devcDef.catName = row.catName;
                devcDef.brandId = brandId;
                devcDef.brandName = row.brandName;
                devcDef.createDef = true;

                if (row.asmblAccFlag) {
                    devcDef.centBuyMode = false;
                    openAccDefSaveDlg({
                        row: devcDef,
                        buildFlag: true,
                        realDevcDef: true
                    }, function (result, theDlg) {
                        theDlg.close();
                        let postData = result;
                        postData.assetType = 3;
                        postData.createFlag = true;
                        let msgBoxDlg = MsgBox.loading();
                        asmblAccApi.getAsmblAccDefByUK(postData, function (result1) {
                            msgBoxDlg.close();
                            if (result1.type == 'info') {
                                let accDef = result1.data;
                                row.assetDefId = accDef.id;
                                row.assetDefNo = accDef.innerCode;
                                row.title = accDef.title;
                                row.devcName = accDef.name;
                                row.devcCatId = accDef.catId;
                                row.devcCatName = accDef.catName;
                                row.devcBrandId = accDef.brandId;
                                row.devcBrandName = accDef.brandName;
                                row.devcModel = accDef.model;
                                row.devcFixedSpec = accDef.fixedSpec;
                                row.devcUnit = accDef.theUnit;
                                devcDefApi.doSaveMerchtDevcDefRel({
                                    devcDefId: accDef.assetDefId,
                                    merchtDevcAccAsmblRelList: [{
                                        accDefId: accDef.id,
                                        accDefTitle: accDef.title,
                                        count: 1
                                    }]
                                }, function (result2) {
                                    if (result2.type === 'info') {

                                    } else {
                                        MsgBox.warning(result2.message);
                                    }
                                });
                                self.contract.contractGoodsList = Utils.merge([], contractGoodsList);
                            } else {
                                MsgBox.warning(result1.message);
                            }
                        });
                    });
                } else {
                    devcDef.purchFlag = true;
                    devcDef.centBuyRequired = false;
                    devcDef.vendorUknoFlag = false;
                    devcDef.setupFlag = false;
                    devcDef.asmblFlag = false;
                    devcDef.asmblWhileSetup = false;
                    devcDef.stockFifo = false;
                    devcDef.assetType = 0;
                    devcDef.useManner = 0;
                    let params = {
                        row: devcDef,
                        assetTypeDisabled: true,
                        normalized: Utils.isTrue(self.normalFlag)
                    };
                    openDevcDefSaveDlg(params, function (result, theDlg) {
                        theDlg.close();
                        let postData = result;
                        postData.createFlag = true;
                        postData.normalized = Utils.isTrue(self.normalFlag);
                        let msgBoxDlg = MsgBox.loading();
                        devcDefApi.getMerchtDevcDefInfoByUK(postData, function (result) {
                            msgBoxDlg.close();
                            if (result.type == 'info') {
                                let devcDef = result.data;
                                if (Utils.isTrue(self.normalFlag)) {
                                    MsgBox.warning('定义已生成,请财务审核后再关联');
                                } else {
                                    row.assetDefId = devcDef.id;
                                    row.assetDefNo = devcDef.innerCode;
                                    row.title = devcDef.title;
                                    row.devcName = devcDef.name;
                                    row.devcCatId = devcDef.innerDevcCatId;
                                    row.devcCatName = devcDef.innerDevcCatName;
                                    row.devcBrandId = devcDef.innerDevcBrandId;
                                    row.devcBrandName = devcDef.innerDevcBrandName;
                                    row.devcModel = devcDef.model;
                                    row.devcFixedSpec = devcDef.fixedSpec;
                                    row.devcUnit = devcDef.theUnit;
                                    self.contract.contractGoodsList = Utils.merge([], contractGoodsList);
                                }
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    });
                }
            },
            clearDevcDef: function (row, index, clearAsmblAccFlag) {
                let self = this;
                let contractGoodsList = self.contract.contractGoodsList || [];
                if (row.assetDefId != null && row.assetDefId != -1) {
                    row.assetDefId = null;
                    row.assetDefNo = null;
                    row.devcName = null;
                    row.devcCatId = null;
                    row.devcCatName = null;
                    row.devcBrandId = null;
                    row.devcBrandName = null;
                    row.devcModel = null;
                    row.devcFixedSpec = null;
                    row.devcUnit = null;
                    row.customized = false;
                    if (Utils.isTrue(clearAsmblAccFlag)) {
                        row.asmblAccFlag = false;
                    }
                    self.contract.contractGoodsList = Utils.merge([], contractGoodsList);
                }
            },
            // 选择资产定义，只能选择可采购的定义
            showDevcDefListDlg: function () {
                let self = this;
                let contract = self.contract || {};
                let contractGoodsList = contract.contractGoodsList || [];
                let selectIds = [];
                for (let i = 0; i < contractGoodsList.length; i++) {
                    let contractGoods = contractGoodsList[i];
                    let assetDefId = contractGoods.assetDefId;
                    if (!Utils.isNoB(assetDefId) && assetDefId != -1 && !Utils.isTrue(contractGoods.asmblAccFlag)) {
                        if (!selectIds.contains(assetDefId)) {
                            selectIds.push(assetDefId)
                        }
                    }
                }
                showMerchtDevcDefSelectDlg({
                    checkBox: true,
                    normalized: Utils.isTrue(self.normalFlag) ? true : null,
                    selectIds: selectIds,
                    filter: {
                        purchFlag: true,
                        disabled: false,
                        vendorIdX: contract.sndPartyId,
                        queryOneAdoptedDevice: true // 查询一个入选商品
                    }
                }, function (devcDefs, dlg) {
                    dlg.close();
                    devcDefs = devcDefs || [];
                    let goodsList = [];
                    for (let i = 0; i < devcDefs.length; i++) {
                        let devcDef = devcDefs[i];
                        let goodsInfo = {};
                        goodsInfo.asmblAccFlag = false;
                        self.makeContractGoodsInfo(goodsInfo, devcDef, contract);
                        goodsList.push(goodsInfo);
                    }
                    contractGoodsList = contractGoodsList.concat(goodsList);
                    self.contract.contractGoodsList = Utils.merge([], contractGoodsList);
                });
            },
            // 选择组装件定义
            showAsmblAccListDlg: function () {
                let self = this;
                let contract = self.contract || {};
                let contractGoodsList = contract.contractGoodsList || [];
                let selectIds = [];
                for (let i = 0; i < contractGoodsList.length; i++) {
                    let contractGoods = contractGoodsList[i];
                    let assetDefId = contractGoods.assetDefId;
                    if (!Utils.isNoB(assetDefId) && assetDefId != -1 && Utils.isTrue(contractGoods.asmblAccFlag)) {
                        if (!selectIds.contains(assetDefId)) {
                            selectIds.push(assetDefId)
                        }
                    }
                }
                showAsmblAccDefSelectDlg({
                    filter: {
                        vendorIdX: contract.sndPartyId,
                        queryOneAdoptedDevice: true // 查询一个入选商品
                    },
                    checkBox: true,
                    checkIds: selectIds,
                    needDisabled: true
                }, function (devcDefs, dlg) {
                    dlg.close();
                    devcDefs = devcDefs || [];
                    let goodsList = [];
                    for (let i = 0; i < devcDefs.length; i++) {
                        let devcDef = devcDefs[i];
                        let goodsInfo = {};
                        goodsInfo.asmblAccFlag = true;
                        self.makeContractGoodsInfo(goodsInfo, devcDef, contract);
                        goodsList.push(goodsInfo);
                    }
                    contractGoodsList = contractGoodsList.concat(goodsList);
                    self.contract.contractGoodsList = Utils.merge([], contractGoodsList);
                });
            },
            // 组装合同商品信息
            makeContractGoodsInfo: function (contractGoods, assetDef, contract) {
                contractGoods.assetDefId = assetDef.id;
                contractGoods.assetDefNo = assetDef.innerCode;
                contractGoods.title = assetDef.title;
                contractGoods.devcName = assetDef.name;
                if (Utils.isTrue(contractGoods.asmblAccFlag)) {
                    contractGoods.devcCatId = assetDef.catId;
                    contractGoods.devcCatName = assetDef.catName;
                    contractGoods.devcBrandId = assetDef.brandId;
                    contractGoods.devcBrandName = assetDef.brandName;
                } else {
                    contractGoods.devcCatId = assetDef.innerDevcCatId;
                    contractGoods.devcCatName = assetDef.innerDevcCatName;
                    contractGoods.devcBrandId = assetDef.innerDevcBrandId;
                    contractGoods.devcBrandName = assetDef.innerDevcBrandName;
                }
                contractGoods.devcModel = assetDef.model;
                contractGoods.devcFixedSpec = assetDef.fixedSpec;
                contractGoods.devcUnit = assetDef.theUnit;
                contractGoods.taxRate = contract.taxRate || 0.00;
                contractGoods.taxOffset = Utils.isTrue(contract.taxOffset);
                contractGoods.bizAreaFlag = contract.bizAreaFlag;
                let adoptedDevice = assetDef.adoptedDevice || {};
                if (!Utils.isNoB(adoptedDevice) && adoptedDevice.id > 0 && (contract.creatorComId == contract.fstPartyComId || this.operateContract == 'change')) {
                    contractGoods.adoptedDeviceId = adoptedDevice.id;
                    contractGoods.skuId = adoptedDevice.skuId;
                    contractGoods.model = adoptedDevice.model;
                    contractGoods.fixedSpec = adoptedDevice.fixedSpec;
                    contractGoods.name = adoptedDevice.title;
                    contractGoods.title = contractGoods.name || '' + adoptedDevice.fixedSpec || '';
                    contractGoods.goodsId = adoptedDevice.goodsId;
                    contractGoods.catId = adoptedDevice.goodsCatId;
                    contractGoods.catName = adoptedDevice.goodsCatName;
                    contractGoods.brandId = adoptedDevice.goodsBrandId;
                    contractGoods.brandName = adoptedDevice.goodsBrandName;
                    contractGoods.price = Utils.isNoB(adoptedDevice.price) ? null : parseFloat(adoptedDevice.price).toFixed(2);
                    if (Utils.isNoB(contractGoods.price)) {
                        contractGoods.ntxPrice = contractGoods.price;
                    } else {
                        contractGoods.ntxPrice = (parseFloat(contractGoods.price) / (1 + (parseFloat(contractGoods.taxRate) * 0.01))).toFixed(2);
                    }
                    contractGoods.customized = adoptedDevice.customizable;
                    contractGoods.customizable = Utils.isTrue(adoptedDevice.customizable);
                    contractGoods.wrntPeriod = adoptedDevice.wrntPeriod;
                    contractGoods.unit = adoptedDevice.unit;
                }
            },
            // 选择/更换入选商品信息
            selectAdoptedDevice: function (row, index) {
                let self = this;
                //
                let assetDefId = row.assetDefId;
                if (assetDefId == -1) {
                    assetDefId = null;
                }
                if (Utils.isNoB(assetDefId)) {
                    MsgBox.warning('请选择定义！');
                    return;
                }
                //
                let contract = self.contract || {};
                let contractGoodsList = contract.contractGoodsList || [];
                let sndPartyId = contract.sndPartyId;
                if (!Utils.isNoB(sndPartyId) && sndPartyId == -1) {
                    sndPartyId = null;
                }
                //
                let filter = {
                    asmblAccFlag: row.asmblAccFlag,
                    assetDefId: assetDefId,
                    vendorId: sndPartyId,
                    disabled: false
                };
                let checkIds = [];
                if (Utils.isNoB(row.adoptedDeviceId)) {
                    checkIds.push(row.adoptedDeviceId);
                }
                //
                let params = {};
                params.filter = filter;
                params.skuFlag = true;
                params.checkBox = false;
                params.showTable = false;
                params.checkIds = checkIds;
                goodsInSelectDlg(params, function (adoptedDevice) {
                    row.adoptedDeviceId = adoptedDevice.id;
                    row.skuId = adoptedDevice.skuId;
                    row.model = adoptedDevice.model;
                    row.fixedSpec = adoptedDevice.fixedSpec;
                    row.name = adoptedDevice.title;
                    row.title = row.name || '' + adoptedDevice.fixedSpec || '';
                    row.goodsId = adoptedDevice.goodsId;
                    row.catId = adoptedDevice.goodsCatId;
                    row.catName = adoptedDevice.goodsCatName;
                    row.brandId = adoptedDevice.goodsBrandId;
                    row.brandName = adoptedDevice.goodsBrandName;
                    row.price = Utils.isNoB(adoptedDevice.price) ? null : parseFloat(adoptedDevice.price).toFixed(2);
                    row.taxRate = contract.taxRate || 0.00;
                    if (Utils.isNoB(row.price)) {
                        row.ntxPrice = row.price;
                    } else {
                        row.ntxPrice = (parseFloat(row.price) / (1 + (parseFloat(row.taxRate) * 0.01))).toFixed(2);
                    }
                    row.bizAreaFlag = contract.bizAreaFlag;
                    row.wrntPeriod = adoptedDevice.wrntPeriod;
                    row.unit = adoptedDevice.unit;
                    row.customized = adoptedDevice.customizable;
                    row.customizable = Utils.isTrue(adoptedDevice.customizable);
                    row.taxOffset = Utils.isTrue(contract.taxOffset);
                    //
                    contractGoodsList[index] = Utils.merge({}, row);
                    contract.contractGoodsList = Utils.merge([], contractGoodsList);
                    self.contract = Utils.merge({}, contract);
                });
            },
            // 常用发票
            selectInvoiceSubject: function () {
                let self = this;
                if (Utils.isNoB(self.contract.invoiceType)) {
                    MsgBox.warning('未确定发票类型');
                    return;
                }
                let params = {
                    showAddFlag: true,
                    buyerRealComId: self.contract.fstPartyRealComId,
                    invoiceType: self.contract.invoiceType
                };
                selectInvoiceSubjectDlg(params, function (resultData, theDlag) {
                    theDlag.close();
                    self.contract.invoiceTitle = resultData.invoiceTitle;
                    self.contract.taxPayerNo = resultData.taxPayerNo;
                    //self.contract.invoiceContentTag = data.invoiceContentTag;
                    self.contract = Utils.merge({}, self.contract);
                })
            },
            // 纳入结算单费用项
            changeWorkFeeType: function (value) {
                let contract = this.contract || {};
                if (contract.settleInvolvedFeeTypeIds.length <= 0) {
                    contract.settleInvolvedFeeTypeIds.push(1);
                    this.contract = Utils.merge({}, contract);
                    MsgBox.warning('至少选择一个费用项');
                }
            },
            // 选择买、 卖方公司
            selectRealCom: function (isFstPartyFlag) {
                let self = this;
                let contractInfo = self.contract || {};
                let prams = {};
                if (!isFstPartyFlag) { // 卖方公司
                    if (Utils.isNoB(contractInfo.sndPartyId)) {
                        MsgBox.warning('请先选择商户信息');
                        return;
                    }
                    prams.merchantId = contractInfo.sndPartyId;
                    prams.merchantType = contractInfo.sndPartyType;
                }
                let fstPartyRealComId = contractInfo.fstPartyRealComId;

                // 买方公司
                if (isFstPartyFlag) {
                    selectMerchantRealComDlg(prams, function (result) {
                        if (fstPartyRealComId != result.id) {
                            contractInfo.signGroupId = null;
                            contractInfo.signGroupName = null;
                            // 买方公司发生变化，清空适用机构
                            if (self.contractType == self.servcPurch.value) {
                                contractInfo.contractAppliedShopList = [];
                            }
                        }
                        contractInfo.fstPartyRealId = result.realId;
                        contractInfo.fstPartyRealComId = result.id;
                        contractInfo.fstPartyRealComName = result.name;
                        contractInfo.fstPartyRealComCode = result.code;
                        //
                        getMerchantBizParam('asset.finac.enabled', function (normalFlagResult) {
                            self.normalFlag = Utils.isTrue(normalFlagResult);
                        }, 2, null, result.id);
                        self.contract = Utils.merge({}, contractInfo);
                        if (!Utils.isNoB(self.contract.invoiceType)) {
                            // 重新获取发票抬头
                            self.getMerchantInvoiceSubjectByOnly();
                        }
                    });
                } else {
                    if (self.contractType == self.goodsPurch.value || self.contractType == self.servcPurch.value) {
                        //
                        let peerMerchantType = getEnumInfoWith('merchantType', 'name', 'Vendor').value;
                        if (self.contractType == self.servcPurch.value) {
                            peerMerchantType = getEnumInfoWith('merchantType', 'name', 'Servicer').value;
                        }
                        // 供应商卖方公司,选择入选供方公司
                        selectRealAdoptedComDlg({
                            checkBox: false,
                            filter: {
                                peerRealComId: contractInfo.sndPartyRealComId,
                                peerMerchantType: peerMerchantType,
                                adoptedType: 1 // 准入类型：入选
                            }
                        }, function (realAdoptedCom, theDlg) {
                            theDlg.close();
                            realAdoptedCom = realAdoptedCom || {};
                            contractInfo.sndPartyRealId = realAdoptedCom.peerRealMerchantId;
                            contractInfo.sndPartyRealComId = realAdoptedCom.peerRealComId;
                            contractInfo.sndPartyRealComName = realAdoptedCom.peerRealComName;
                            //
                            self.contract = Utils.merge({}, contractInfo);
                            if (!Utils.isNoB(self.contract.invoiceType)) {
                                // 重新获取发票抬头
                                self.getMerchantInvoiceSubjectByOnly();
                            }
                        });
                    } else {
                        // 服务商卖方公司
                        selectMerchantRealComDlg(prams, function (result) {
                            // 卖方公司
                            contractInfo.sndPartyRealId = result.realId;
                            contractInfo.sndPartyRealComId = result.id;
                            contractInfo.sndPartyRealComName = result.name;
                            contractInfo.sndPartyRealComCode = result.code;
                            self.contract = Utils.merge({}, contractInfo);
                            if (!Utils.isNoB(self.contract.invoiceType)) {
                                // 重新获取发票抬头
                                self.getMerchantInvoiceSubjectByOnly();
                            }
                        });
                    }
                }
            }
        }
    }
</script>
<style>
    .delX {
        position: absolute;
        right: 2px;
    }
</style>



// WEBPACK FOOTER //
// src/compo/contract/RegisterComnContract.vue